import {
  AgentStatus,
  CallStatus,
  CaseStatus,
  HotelCategories,
  SALE_ORDER_STATUS,
  WhatsappMessageEventStatusType,
} from '@bandido/shared/constants';
import {
  CommunicationType,
  IVRActionType,
  MarkupFieldOptionHotels,
  MarkupRuleOperator,
  NotificationType,
  OriginatedByChannel,
  TimeoutAction,
  UserRoles,
} from '@bandido/shared/types';
import { WELCOME_MESSAGE } from '@frontend/features/calls-menu/constants';

export const espanol = {
  hotelOnboarding: {
"reviewSources":"Revisar hoteles importados","sourceNotice":"Revisá la identidad de la fuente antes de vincularla o crear un hotel. La publicación para esta agencia requiere una acción separada.","sourceSearch":"Buscar hotel importado","createExplicit":"Verifiqué que no corresponde vincular un hotel canónico existente y quiero crear uno desde esta fuente.","createFromSource":"Crear hotel en borrador","linkSource":"Vincular al hotel seleccionado","linkError":"No se confirmó el vínculo. Recargá la fuente; los vínculos existentes no se reasignan.","canonicalHotel":"Hotel canónico","agencyStatus":"Estado del catálogo de la agencia","projectionPending":"Pendiente de proyección","activeLinks":"Vínculos de proveedor activos","noAvailabilityClaim":"La proyección activa y un vínculo no garantizan disponibilidad ni precio. Agregá la selección global por separado y verificá mediante una búsqueda.","activateAgency":"Activar hotel para esta agencia","activationPending":"La proyección puede estar pendiente o la operación no se confirmó. Consultá el estado antes de continuar.",
  "imports": "Importar contenido de proveedor",
  "importNotice": "La importación consulta al proveedor usando esta cuenta. No publica contenido global ni activa hoteles para la agencia.",
  "account": "Cuenta propia",
  "access": "Acceso configurado",
  "feed": "Contenido",
  "supplier_hotel_list": "Hoteles del proveedor",
  "hotel_master": "Maestro FastX",
  "destination_list": "Destinos del proveedor",
  "board_list": "Regímenes",
  "category_list": "Categorías",
  "countries": "Países ISO (separados por coma)",
  "destinationCodes": "Códigos de destino del proveedor (coma o línea)",
  "hotelCodes": "Códigos de hotel del proveedor (coma o línea)",
  "scope": "Alcance a importar",
  "confirmScope": "Revisé la cuenta, acceso y alcance; autorizo esta importación.",
  "enqueue": "Solicitar importación",
  "enqueueError": "No se confirmó la importación. Consultá los trabajos existentes antes de volver a solicitarla.",
  "pages": "Páginas procesadas",
  "attempts": "Intentos",
  "checkpoint": "Tiene progreso guardado",
  "refreshStatus": "Consultar estado",
  "existingJobs": "Trabajos existentes",
  "resumeNotice": "El worker conserva el progreso. Una solicitud idéntica devuelve el mismo trabajo, incluso terminado o fallido; no lo reinicia. El seguimiento automático se detiene a los diez minutos.",
  "loadError": "No se pudo consultar la información.",
  "addDestination": "Agregar destino",
  "addHotel": "Agregar hotel a destino",
  "geoCandidate": "Buscar lugar canónico de hotelrs",
  "hotelCandidate": "Buscar hotel canónico",
  "find": "Buscar candidatos",
  "selectionNotice": "Esta selección global no garantiza disponibilidad. El hotel también necesita vínculo de proveedor y publicación activa para la agencia. No reemplaza registros existentes.",
  "destinationOnly": "Seleccioná un destino canónico; no una dirección o coordenada."
  },

  hotelEditorial: {
  "title": "Contenido del hotel",
  "loading": "Cargando…",
  "unavailable": "No tenés acceso a la administración editorial.",
  "noPublication": "Este hotel no tiene una publicación disponible para editar.",
  "reload": "Recargar",
  "version": "Versión {{version}}",
  "global": "Esta publicación es compartida por todas las agencias. Los cambios se publican sólo después de revisar la vista previa.",
  "withdrawn": "La publicación está retirada. Este editor no la vuelve a publicar.",
  "edit": "Editar contenido",
  "name": "Nombre",
  "restoreName": "Usar nombre de la fuente",
  "descriptions": "Descripciones",
  "customizeText": "Personalizar textos conservando todos los idiomas",
  "language": "Idioma",
  "kind": "Tipo de texto",
  "text": "Texto",
  "remove": "Quitar",
  "addText": "Agregar texto",
  "restoreText": "Restaurar todos los textos de la fuente",
  "gallery": "Galería (la primera foto es la principal)",
  "image": "Imagen {{index}}",
  "up": "Anterior",
  "down": "Siguiente",
  "upload": "Subir imagen propia",
  "uploadUnavailable": "La subida de imágenes requiere almacenamiento público configurado por el administrador del servidor. Podés ordenar o quitar las imágenes existentes.",
  "uploadError": "No se pudo subir la imagen. Usá PNG o JPEG válido de hasta 3 MB.",
  "restoreImages": "Restaurar galería de la fuente",
  "previewLanguage": "Idioma de la vista previa",
  "reason": "Motivo del cambio",
  "conflict": "La publicación cambió. Recargá y revisá la versión actual antes de publicar.",
  "saveError": "No se pudo completar la operación. Revisá los campos y volvé a previsualizar.",
  "preview": "Vista previa del servidor",
  "publish": "Publicar para todas las agencias",
  "cancel": "Descartar cambios",
  "history": "Historial editorial",
  "historyError": "No se pudo cargar el historial.",
  "previous": "Anterior",
  "next": "Siguiente"
},
  hotelPolicy: {
    emptyAdditions: "Sin adicionales: se usarán los predeterminados.",
    additional: "Adicional",
    inherited: "Predeterminado",
    noneEffective: "No se consultará ningún proveedor.",
    effective: "Se consultarán estos proveedores",
    extend: "Predeterminados + adicionales",
    unsupportedAccounts: 'Hay conexiones activas con accesos sin enumerar. Configurá accesos explícitos en Conexiones de hoteles antes de usar Todos los habilitados: ',
  "title": "Proveedores de búsqueda",
  "scope": "Estas reglas eligen qué cuentas y accesos se consultan para esta agencia. No cambian el contenido compartido ni habilitan reservas.",
  "default": "Proveedores predeterminados",
  "loading": "Cargando…",
  "loadError": "No se pudieron cargar las reglas o no tenés permiso para administrarlas.",
  "reload": "Recargar",
  "overrides": "Excepciones por destino: {{count}}",
  "edit": "Editar reglas",
  "pointDefault": "Las búsquedas por coordenadas usan la regla general. Las excepciones aplican únicamente al destino seleccionado.",
  "all_enabled": "Todos los accesos habilitados",
  "allowlist": "Sólo los accesos seleccionados",
  "disabled": "Búsquedas deshabilitadas",
  "inherit": "Usar predeterminados",
  "includesFuture": "Esta opción incluirá los nuevos accesos habilitados que se agreguen más adelante.",
  "routesError": "No se pudieron verificar los accesos disponibles.",
  "unavailableRoute": "Acceso seleccionado no disponible:",
  "noRoutes": "No hay accesos activos configurados para seleccionar.",
  "emptyAllowlist": "Sin accesos seleccionados: no se ejecutarán búsquedas para esta regla.",
  "destinationRule": "Regla de este destino",
  "addDestination": "Agregar excepción para un destino",
  "add": "Agregar",
  "remove": "Quitar",
  "reason": "Motivo del cambio",
  "conflict": "Las reglas cambiaron. Recargá y revisá la versión actual antes de guardar.",
  "saveError": "No se pudieron guardar las reglas.",
  "close": "Cerrar",
  "save": "Guardar"
  },
  hotelDestinationMembership: {
    reference: 'Referencia: {{id}}',
    identityHelp: 'Puede haber registros con el mismo nombre. La referencia identifica el registro que vas a agregar; revisalo en las herramientas de contenido si tenés dudas.',
    hotelName: 'Nombre del hotel',
    search: 'Buscar',
    add: "Agregar hotel",
    included: "Incluidos",
    disabled: "Desactivados",
    disabledCount: "{{count}} hoteles desactivados",
    disabledRange: "Hoteles desactivados {{start}}–{{end}} · página del catálogo",
    deactivate: "Desactivar",
    reactivate: "Reactivar",
    deactivateHotel: "Desactivar {{hotel}} en este destino",
    reactivateHotel: "Reactivar {{hotel}} en este destino",
    choose: "Elegir hotel",
    catalogHelp: "Buscá por nombre un hotel que ya exista en el catálogo. Si no aparece, su incorporación al catálogo se gestiona desde las herramientas de contenido.",
    alreadyIncluded: "{{hotel}} ya está incluido en {{destination}}. No hace falta agregarlo otra vez.",
    existingDisabled: "{{hotel}} está desactivado en {{destination}}. Podés reactivarlo conservando su prioridad.",
    newRelationship: "{{hotel}} todavía no está incluido en {{destination}}. Revisá su ubicación antes de continuar.",
    deactivateHelp: "Dejará de incluirse en las nuevas búsquedas por {{destination}}. Conserva su prioridad y sigue en el catálogo y en los demás destinos. Las reservas existentes no cambian.",
    includeHelp: "Se incluirá en {{destination}} para todas las agencias. La inclusión no garantiza disponibilidad ni habilita proveedores.",
    saved: "Cambio guardado. Se aplicará a las nuevas búsquedas por destino.",
    emptyDisabled: "Este destino no tiene hoteles desactivados.",
  },
  hotelDestinationOrder: {
    previousMatches: 'Destinos anteriores',
    nextMatches: 'Más destinos',
    edit: 'Editar',
    hotel: 'Hotel',
    title: "Hoteles por destino",
    subtitle: "Administrá qué hoteles se incluyen en cada destino y en qué orden consultarlos.",
    destination: "Destino",
    typeDestination: "Escribí al menos 2 letras para buscar un destino.",
    chooseDestination: "Elegí un destino para ver sus hoteles incluidos y editar sus prioridades.",
    priority: "Prioridad",
    priorityHelp: "Menor número = aparece antes. Los empates mantienen un orden estable por identificador del hotel.",
    editPriority: "Editar prioridad",
    editHotel: "Editar prioridad de {{hotel}}",
    currentOrder: "Orden actual",
    previewTitle: "Así quedaría el orden",
    preview: "Vista previa",
    position: "Posición",
    pagePosition: "En esta página",
    count: "{{count}} hoteles incluidos",
    range: "Hoteles incluidos {{start}}–{{end}} · página del catálogo",
    previewPosition: "Posición {{position}} de {{count}}",
    previewPagePosition: "Posición {{position}} entre los {{count}} hoteles de esta página",
    partialPreview: "Esta vista previa compara solo los hoteles de esta página. El puesto definitivo puede quedar en otra página; al guardar volvemos al inicio para consultar el orden actualizado.",
    moves: "Del puesto {{before}} al {{after}} dentro de esta vista.",
    unchanged: "Sin cambios en el orden.",
    reasonHelp: "El motivo queda registrado junto al cambio.",
    discard: "Descartar",
    save: "Guardar prioridad",
    saved: "Prioridad guardada. Se aplicará a las nuevas búsquedas por destino.",
    saveUncertain: "No pudimos confirmar el guardado. Recargá para comprobar el estado y la prioridad actuales antes de volver a editar.",
    empty: "Este destino no tiene hoteles incluidos. Usá Agregar hotel para incluir uno del catálogo.",
    searchHelp: "Las nuevas búsquedas por destino consultan hasta 200 hoteles elegibles en este orden. Solo se muestran resultados con disponibilidad. Ordenar por precio prevalece sobre la prioridad; las búsquedas por ubicación mantienen el orden por cercanía. Las búsquedas ya iniciadas conservan su selección original.",
    pageLimit: "Llegaste al límite de navegación del catálogo. Hay más relaciones que esta pantalla no puede consultar.",
    discardTitle: "¿Descartar los cambios sin guardar?",
    discardBody: "La prioridad y el motivo que estás editando no se guardarán.",
    keepEditing: "Seguir editando",
    backToAgency: "Volver a Hoteles de la agencia",
    otherTools: "Otras herramientas: destinos, contenido y proveedores",
    agencyDescription: "Administrá la inclusión y el orden de hoteles por destino. El catálogo es compartido: los cambios afectan a todas las agencias.",
  },
  hotelCatalogAdmin: {
    cancel: 'Cancelar',
    "title": "Catálogo de hoteles",
    "globalNotice": "Estos cambios afectan al catálogo compartido de todas las agencias. No modifican los permisos de reserva ni importan hoteles.",
    "unavailable": "La administración del catálogo no está disponible para esta cuenta.",
    "destinations": "Destinos",
    "hotels": "Hoteles del destino",
    "destinationFilter": "ID canónico del destino (opcional)",
    "filter": "Filtrar",
    "loading": "Cargando…",
    "loadError": "No se pudo cargar el catálogo.",
    "reload": "Recargar",
    "externalPlace": "Destino externo",
    "enabled": "Habilitado",
    "rank": "Orden",
    "yes": "Sí",
    "no": "No",
    "edit": "Editar selección",
    "empty": "No hay relaciones para estos filtros.",
    "previous": "Anterior",
    "next": "Siguiente",
    "reason": "Motivo del cambio",
    "conflict": "Otro administrador cambió esta selección. Recargá y revisá los valores antes de volver a guardar.",
    "saveError": "No se pudo guardar.",
    "close": "Cerrar",
    "save": "Guardar"
},
  hotelReservation: {
    uncertainLabel: 'Resultado incierto',
    refreshPending: 'Consultando el estado con el proveedor…',
    refreshWaiting: 'La consulta sigue pendiente. Podés volver a consultar el estado.',
    refreshComplete: 'Consulta finalizada. El estado actualizado se muestra en esta reserva.',
    refreshManual: 'No se pudo determinar el resultado. Se requiere conciliación manual; no vuelvas a reservar.',
    refreshError: 'No pudimos consultar el estado. Podés reintentar la consulta; no vuelvas a reservar.',
    packageCondition: 'Tarifa PACKAGE: el proveedor exige vender este hotel junto con otro producto, por ejemplo un vuelo.',
    quoteUnknown: 'No se pudo confirmar la validación de la tarifa. No se envió una reserva. Consultá el estado de esta solicitud.',
    bookingsDisabledShort: 'Reservas deshabilitadas para esta conexión',
    fareIncompleteShort: 'Faltan datos del proveedor',
    quoteFailed: 'No se pudo validar la tarifa con el proveedor. No se envió una reserva.',
    caseTravelers: 'Viajeros del caso',
    acceptSearch: "Acepto el precio y las condiciones mostradas para estos pasajeros. Si cambian, quiero revisarlos antes de reservar.",
    selectedPrice: "Precio seleccionado",
    reviewBeforeBooking: "Revisá las condiciones confirmadas por el proveedor antes de reservar. Todavía no se envió la reserva.",
    fareUnavailable: "La tarifa seleccionada ya no está disponible en esta búsqueda. Volvé a buscar. No se envió una reserva.",
    fareIncomplete: "La tarifa no tiene los datos de proveedor necesarios para reservar. No se envió una reserva.",
    quoteInvalid: "No se pudo validar la tarifa: la solicitud fue rechazada. Revisá los datos del titular y del caso. No se envió una reserva.",
    quoteForbidden: "No tenés permiso para iniciar esta reserva. Revisá los permisos de la agencia y de la conexión. No se envió una reserva.",
    quoteConflict: "No se pudo validar la tarifa porque cambió el estado de la solicitud. No se envió una reserva.",
    quoteInvalidResponse: "Bandido no pudo interpretar la respuesta del servicio de hoteles al validar la tarifa. No se envió una reserva.",
    quoteUnavailable: "El servicio de hoteles no respondió correctamente al validar la tarifa. No se envió una reserva.",
    quoteConnectionError: "No se recibió la respuesta al validar la tarifa. No se envió una reserva al proveedor desde este formulario.",

    permissionLoading: 'Verificando permiso para reservar…',
    permissionError: 'No se pudo verificar el permiso para reservar. Volvé a consultar.',
    bookingsDisabled: 'Las reservas están deshabilitadas para esta cuenta. Un administrador de la agencia puede habilitarlas en Conexiones de hoteles.',

    cancelBooking: 'Cancelar reserva',
    cancelAccept: 'Revisé las condiciones y quiero cancelar esta reserva.',
    cancelUncertain: 'Estamos verificando la cancelación porque la respuesta tardó más de lo esperado. No la envíes otra vez; el estado se actualizará aquí.',
    cancelState: {
      requested: 'Cancelación solicitada. Esperando al proveedor.',
      processing: 'El proveedor está procesando la cancelación.',
      completed: 'El proveedor confirmó la cancelación. Esto no certifica un importe de reembolso.',
      failed: 'La cancelación falló. La reserva no debe considerarse cancelada.',
      unknown: 'Resultado de cancelación incierto. Consultá el estado o solicitá conciliación manual.',
    },

    quotationTerms: 'Condiciones de la cotización',
    confirmedCancellation: 'Cancelación de la reserva confirmada',
    confirmedPrice: 'Precio confirmado de la reserva',
    searchRoomCharge: 'Cargos informados en la búsqueda — habitación {{room}} (sin actualizar por la cotización)',
    nonRefundable: 'No reembolsable',
    title: 'Reserva de hotel',
    quote: 'Reservar',
    book: 'Confirmar reserva',
    close: 'Cerrar',
    refresh: 'Consultar estado',
    searchOnly: 'Reserva no disponible',
    commercialNotice: 'Las reservas pueden generar cargos reales del proveedor. Revisá la cotización vigente y el plazo de cancelación antes de confirmar.',
    case: 'Caso #{{id}}',
    caseSelect: 'Caso',
    reference: 'Referencia de la reserva: {{id}}',
    holderSelect: 'Titular de la reserva',
    holderDefault: 'Cliente del caso o datos manuales',
    holderHint: 'Elegí un viajero del caso o completá los datos. El email se puede corregir para esta reserva.',
    holder: { given_name: 'Nombre del titular', family_name: 'Apellido del titular', email: 'Email del titular' },
    quoteError:
      'No se pudo confirmar la solicitud de cotización. Revisá el listado de reservas antes de iniciar otra solicitud.',
    bookRejected:
      'La reserva no se envió. Corregí los datos de los viajeros y revisá y aceptá nuevamente la cotización.',
    boardCode: 'Código de régimen',
    bookUncertain:
      'Estamos verificando la reserva porque la respuesta tardó más de lo esperado. No hace falta reservar otra vez; el estado se actualizará aquí.',
    readError:
      'No se pudo consultar el estado. Esto no significa que la reserva haya fallado. Volvé a consultar sin enviar otra reserva.',
    pollPaused:
      'Las consultas automáticas se pausaron. Podés consultar el estado aquí o volver desde el listado de reservas.',
    priceChanged: 'El precio cambió desde la búsqueda. Revisá y aceptá la cotización vigente antes de confirmar.',
    expires: 'La cotización vence: {{date}}',
    priceComponents: 'Neto: {{net}} · Bruto: {{gross}} · Precio mínimo de venta: {{msp}}',
    binding: 'Aplica una restricción del proveedor sobre el precio de venta',
    cancellation: 'Condiciones de cancelación',
    policyUnknown: 'No se informaron penalidades detalladas. No asumas que la cancelación es gratuita.',
    penaltyWindow: 'Desde {{startsAt}} hasta {{endsAt}}: {{value}} {{currency}} ({{type}})',
    penalty: 'Desde {{date}}: {{value}} {{currency}} ({{type}})',
    manageTravelers: 'Gestionar viajeros del caso',
    travelersError: 'No se pudieron cargar los viajeros del caso.',
    travelerSlot: 'Habitación {{room}} · {{type}}',
    room: 'Habitación {{room}}',
    adult: 'Adulto',
    childAge: 'Menor: {{age}} años al ingresar',
    travelerHint:
      'Elegí un viajero distinto del caso para cada lugar. Los menores necesitan una fecha de nacimiento que coincida con su edad cotizada al ingresar.',
    accept:
      'Acepto este precio vigente, las condiciones de cancelación y los suplementos para los viajeros seleccionados.',
    providerReference: 'Confirmación del proveedor',
    phase: {
      quoting: 'Validando disponibilidad y condiciones antes de reservar…',
      quoted: 'Cotización lista para revisar',
      booking: 'La reserva se está procesando. No vuelvas a enviarla.',
      confirmed: 'Reserva confirmada',
      failed: 'La solicitud falló. No hay una confirmación disponible.',
      unknown: 'El resultado es incierto. Consultá el estado o solicitá conciliación manual; no vuelvas a reservar.',
      expired: 'La cotización venció. Iniciá una nueva búsqueda de disponibilidad.',
      cancelled: 'Reserva cancelada',
    },
  },
  hotelSearch: {
    hotelName: 'Nombre del hotel',
    applyName: 'Buscar',
    sortHotels: 'Ordenar hoteles',
    sortSelection: 'Orden sugerido',
    sortCheapest: 'Menor precio (USD)',
    sortHighest: 'Mayor precio (USD)',
    nameScope: 'El nombre se busca entre los hoteles consultados en esta búsqueda.',
    sortPriceScope:
      'Se compara el menor precio informado de cada hotel con los filtros actuales, en USD y la base elegida. Los hoteles sin precio comparable quedan al final. Puede haber cargos adicionales.',
    sortPriceFrom: 'Desde {{currency}} {{amount}} · {{basis}}',
    noSortPrice: 'Sin precio comparable para este orden',
    catalogLimit:
      'Consultamos los primeros {{count}} hoteles de la selección. Hay más hoteles en el catálogo; los filtros y el orden se aplican a esta selección.',

    routeConfiguration: 'Un administrador debe configurar los accesos explícitos de las conexiones hoteleras antes de ejecutar esta búsqueda.',
    contextChanged: 'La selección o las reglas de búsqueda cambiaron o vencieron. Volvé a buscar para resolver los hoteles con las reglas actuales.',
    contextUnresolved: 'No se pudo confirmar el inicio de la búsqueda. No se reintentó automáticamente; verificá su estado antes de volver a iniciar.',
    interruptedSearch: 'La carga de esta página se interrumpió antes de recibir el identificador de búsqueda. No se reintentó automáticamente. Podés volver a la página anterior o iniciar una nueva búsqueda desde el formulario.',

    allReceivedOffers: 'Todas las ofertas recibidas están visibles',
    enlargePhoto: "Ampliar foto",
    closePhoto: "Cerrar foto",
    verifiedStars: "{{count}} estrellas verificadas",
    showDescription: "Acerca del hotel",
    hideDescription: "Ocultar descripción",
    includePackages: "Incluir tarifas de paquete",
    packagesNeedSearch: "Esta búsqueda no solicitó tarifas de paquete. Para incluirlas se necesita una nueva búsqueda.",
    searchWithPackages: "Buscar incluyendo paquetes",
    keepSearch: "Mantener búsqueda actual",
    cancellationState: {"free_now": "Cancelación gratuita", "penalty_applies": "Cancelación con cargo", "non_refundable": "No reembolsable", "unknown": "Cancelación por confirmar"},
    noDeadline: "Límite no informado",
    policyExpired: "Las condiciones informadas necesitan actualizarse. Consultá la política vigente antes de confirmar.",
    allDetailFilters: 'Todos',
    providerLabel: 'Proveedor',
    cancellationLabel: 'Cancelación',
    roomsLabel: 'Habitaciones',
    roomLabel: 'Habitación {{index}}',
    priceLabel: 'Total',
    priceFromLabel: 'Desde',
    completeOffers: 'Ofertas completas por habitaciones',
    rateMinimums: 'Tarifas mínimas informadas',
    loadedOfferFilters: 'Los filtros se aplican a las ofertas cargadas. Cargá más para explorar otras alternativas.',
    noLoadedOffers: 'No hay ofertas cargadas que coincidan. Cambiá los filtros o cargá más ofertas.',
    policyWhen: 'Cuándo cancelás · UTC',
    policyPenalty: 'Penalidad',
    policyFrom: 'Desde {{time}}',
    policyBefore: 'Hasta antes de {{time}}',
    occupancyAdult: '{{count}} adulto',
    occupancyAdults: '{{count}} adultos',
    occupancyChildren: 'Menores (edades): {{ages}}',
    freeUntil: "Gratis hasta {{time}}",
    cancellationDetails: "Condiciones de cancelación",
    policyFromQuote: "Condiciones de la cotización actual",
    policyFromSearch: "Condiciones de búsqueda; confirmar la tarifa seleccionada antes de reservar",
    penaltyNights: "noche(s)",
    penaltyUnknown: "Cargo no informado",
    policyLimitations: "Sólo política informada. Los tramos no se suman. Porcentajes y noches no se convierten a dinero. La interpretación termina al inicio de la fecha de entrada en UTC; no es la hora de entrada del hotel.",
    wholeStay: "Precio informado para toda la estadía y todas las habitaciones. Puede haber cargos adicionales.",
    netPrice: "Tarifa neta",
    additionalCharges: "Revisar cargos adicionales en la oferta",
    moreRatesAvailable: "Más condiciones de tarifa disponibles en el detalle del hotel",
    loadingOffers: "Actualizando ofertas disponibles…",
    restrictions: "Restricciones de la tarifa",
    policyChanged: "El proveedor actualizó las condiciones de cancelación. Compará las condiciones de la búsqueda con las actuales antes de confirmar.",

    summaryFallback: 'Esta búsqueda conserva las combinaciones de habitaciones recibidas; no se aplicó reducción del resumen en origen.',
    summaryLimited: 'Resumen limitado de las ofertas recibidas. Abrí un hotel para solicitar más opciones.',
    executionProgress: '{{done}} de {{total}} rutas de proveedores finalizadas',
    expansion_failed: 'La ampliación falló. Las ofertas recibidas anteriormente siguen disponibles.',
    expansion_completed: 'Ampliación finalizada. Los resultados no representan todo el inventario.',
    expansion_running: 'Recibiendo ofertas adicionales del hotel…',
    expansion_accepted: 'Ampliación del hotel en cola…',
    expansion_not_requested: 'Preparando la ampliación del hotel…',
    expansionError: 'No se pudo comprobar la ampliación. Las ofertas conocidas siguen disponibles. No se reintentó automáticamente.',
    expandedOffers: 'Ofertas adicionales del hotel',
    knownOffers: 'Ofertas recibidas anteriormente',
    hotelPhoto: '{{name}} — foto {{index}}', imageUnavailable: 'Imagen no disponible',
    contentLoading: 'Cargando información publicada del hotel…', contentMissing: 'No hay información publicada del hotel disponible.',
    contentError: 'No se pudo cargar la información del hotel. La disponibilidad sigue disponible.', reloadContent: 'Recargar información del hotel',
    locationUnknown: 'Ubicación no informada', coordinates: 'Coordenadas', categoryCode: 'Código de categoría: {{code}}', categoryUnknown: 'Categoría no informada',
    descriptionLanguage: 'Idioma de la descripción: {{language}}', descriptionUnknown: 'Descripción no informada',
    partialFriendly: 'No pudimos consultar todos los hoteles. Podés comparar las opciones recibidas.',
    resultsNotice: 'Hay observaciones sobre los resultados disponibles.',
    noticeDetails: 'Ver detalles de la búsqueda',
    receivedPrices: 'Precios de las ofertas recibidas. Al abrir un hotel pueden aparecer más opciones; el precio y las condiciones se verifican antes de reservar.',
    compareCancellation: 'Comparar cancelación',
    hideComparison: 'Ocultar comparación',
    visibleHotelCount: 'Mostrando {{from}}–{{to}} de {{total}} hoteles encontrados con estos filtros.',
    groupHotelCount: 'Mostrando {{from}}–{{to}} de {{total}} hoteles del grupo {{group}} con estos filtros.',
    groupCountScope: 'Consultamos el destino por grupos. Este total corresponde al grupo actual, no a todo el destino.',
    resultPages: 'Páginas de resultados',
    previousResults: 'Anterior',
    nextResults: 'Siguiente',
    resultPage: 'Página {{page}}',
    hotelCount: '{{count}} de {{total}} hoteles en esta vista filtrada',
    moreHotels: 'Cargar más hoteles', moreGroups: 'Cargar más grupos de habitaciones', moreOffers: 'Cargar más ofertas',
    viewRooms: 'Ver habitaciones', viewOffers: 'Ver ofertas de brokers', backResults: 'Volver a resultados',
    reportedFrom: 'Desde {{currency}} {{amount}} informado', minimumUnknown: 'Mínimo comparable no disponible',
    wholeOffer: 'Importe informado por toda la estancia y todas las habitaciones solicitadas; no es el total final a pagar.',
    priceBasis: 'Base del importe', basis: { gross: 'Bruto', net: 'Neto', unknown: 'Desconocida' },
    optionStatus: 'Estado del proveedor', packageCondition: 'Condición de paquete', notPackage: 'No exclusivo de paquete', conditionUnknown: 'Desconocida',
    reportedCharges: 'Cargos informados: {{included}} incluidos · {{excluded}} excluidos · {{unknown}} desconocidos',
    chargeDetailsMissing: 'La información de cargos está incompleta. Pueden existir cargos adicionales.',
    chargeOtherCurrency: 'Hay cargos en otra moneda que no se suman a este importe.',
    navigationGroup: 'Grupo de navegación: no se verificó equivalencia de habitaciones ni condiciones. Se conserva cada oferta de broker.',
    moreGroupsAvailable: 'Hay más grupos de habitaciones en el detalle.',
    observedAt: 'Observado: {{time}}',
    unmappedOffers: '{{count}} ofertas no tienen una propiedad verificada y no se incluyen en estas tarjetas.',
    quoteValidityUnknown: 'La búsqueda no garantiza un plazo de vigencia. Una nueva cotización verifica precio y disponibilidad actuales.',
    resultsRefreshStopped: 'La actualización automática se detuvo porque los resultados seguían cambiando. Se conservan los resultados cargados. Recargá esta vista para continuar.',
    resultsChanged: 'Llegaron nuevas ofertas. La vista se actualiza automáticamente sin mezclar versiones de resultados.',
    reloadResults: 'Recargar resultados',
    emptyFiltered: 'No hay ofertas que coincidan con estos filtros. Cambialos para explorar las alternativas guardadas.',
    boardFilter: 'Régimen',
    anyBoard: 'Cualquier régimen',
    refundabilityFilter: 'Reembolsabilidad',
    anyRefundability: 'Cualquier condición',
    filtersHelp:
      'Cada habitación debe coincidir con uno de los regímenes elegidos. Reembolsable no significa cancelación gratuita: revisá la política. Las condiciones desconocidas siguen siendo desconocidas.',
    resultFilters: 'Filtrar estos resultados',
    filteredCount: '{{count}} de {{total}} ofertas para todas las habitaciones',
    mixedBoards: 'Regímenes diferentes entre habitaciones',
    boards: {
      room_only: 'Solo alojamiento',
      breakfast: 'Desayuno',
      half_board: 'Media pensión',
      full_board: 'Pensión completa',
      all_inclusive: 'Todo incluido',
      other: 'Otro',
      unknown: 'Régimen desconocido',
    },
    refundability: {
      refundable: 'Reembolsable',
      non_refundable: 'No reembolsable',
      unknown: 'Reembolsabilidad desconocida',
    },
    title: 'Hoteles',
    intro: 'Buscá un destino o un punto cercano, elegí fechas y habitaciones.',
    location: 'Destino, aeropuerto o dirección',
    destinations: 'Lugares',
    google: 'Direcciones y lugares de Google',
    keepTyping: 'Escribí al menos dos letras',
    noPlaces: 'No se encontraron lugares',
    destinationMode: 'Selección de hoteles del destino',
    pointMode: 'Hoteles cerca de este punto',
    partialPlaces: 'Una fuente de lugares no está disponible. Los resultados pueden estar incompletos.',
    coordsError: 'No se pudo ubicar este punto. Elegí otro lugar o intentá nuevamente.',
    radius: 'Radio (km)',
    nationality: 'Nacionalidad de los viajeros',
    search: 'Buscar hoteles',
    invalid: 'Revisá el destino, las fechas y la ocupación. Cada habitación necesita al menos un adulto.',
    priceWarning:
      'Importes informados por los proveedores. Revisá la cotización vigente antes de confirmar una reserva.',
    packages: 'Mostrar tarifas exclusivas de paquetes',
    onlyPackages: 'Las opciones recibidas son para paquetes. Activá el filtro para verlas.',
    offerCount_one: '{{count}} opción para todas las habitaciones',
    offerCount_other: '{{count}} opciones para todas las habitaciones',
    unknownBroker: 'Proveedor sin identificar',
    roomDetail: 'Habitación {{index}} · {{adults}} adultos · edades de menores: {{ages}}',
    cancellationUnknown: 'Condiciones de cancelación no informadas',
    payment: 'Pago',
    surcharge: 'Cargo adicional',
    roomCharge: 'Cargo de habitación {{index}}',
    chargeIncluded: 'Incluido en la tarifa',
    chargeExcluded: 'No incluido en la tarifa',
    chargeUnknown: 'Inclusión en la tarifa desconocida',
    loading: 'Resolviendo hoteles y consultando disponibilidad…',
    running: 'Recibiendo opciones de los proveedores…',
    partial: 'La búsqueda está incompleta: algunos proveedores u opciones no pudieron procesarse.',
    failed: 'La búsqueda no pudo completarse. Las opciones recibidas pueden estar incompletas.',
    expired: 'Se detuvo la actualización por tiempo máximo. Las opciones pueden estar incompletas; iniciá una nueva búsqueda para actualizar.',
    empty: 'Sin disponibilidad para esta selección.',
    noCatalog: 'No hay hoteles habilitados para esta selección.',
    error: 'No se pudo completar la búsqueda. No se reintentó automáticamente.',
    unmapped: 'Este destino todavía no tiene una selección de hoteles configurada.',
    nextPage: 'Buscar el siguiente grupo de hoteles',
    pageNotice: 'Se muestra un grupo del catálogo. Hay más hoteles para consultar.',
    stop: 'Detener actualización',
    stopped: 'Actualización detenida. Las opciones pueden estar incompletas.',
    searched: 'Resultados para {{location}} · {{from}} — {{to}}',
  },
  hotelConnections: {
    bookings: 'Permitir reservas',
    commercialWarning: '¿Habilitar operaciones reales con el proveedor para esta cuenta? Las cotizaciones y reservas pueden generar cargos. El modo de prueba no garantiza un sandbox. Al apagarlo se bloquean nuevas cotizaciones y reservas; las existentes se pueden cancelar.',
    confirmBookings: 'Habilitar operaciones con el proveedor',

    retry: 'Reintentar',
    empty: 'Esta agencia todavía no tiene conexiones de hoteles.',
    accessHint: 'Ingresá los IDs de acceso Travelgate autorizados para esta cuenta, separados por comas. No son nombres de proveedores ni se detectan automáticamente.',
    invalidAccess: 'Ingresá entre 1 y 50 IDs de acceso, sin espacios dentro de cada ID.',
    title: 'Conexiones de hoteles',
    hint: 'La configuración se guarda cifrada en el servicio de hoteles. Activar una conexión no comprueba disponibilidad.',
    loading: 'Cargando conexiones…',
    error: 'No se pudo completar la operación.',
    test: 'Pruebas',
    live: 'Live',
    add: 'Agregar conexión Travelgate',
    name: 'Nombre',
    client: 'Cliente Travelgate',
    access: 'Códigos de acceso (separados por coma)',
    key: 'API key (solo escritura)',
    safety: 'Las cuentas nuevas no pueden cotizar ni reservar hasta que un administrador habilite las reservas. El modo de prueba no garantiza un sandbox.',
    close: 'Cerrar',
    save: 'Guardar',
  },
  travelServices: {
    showFilteredResults_one: 'Ver {{count}} resultado',
    showFilteredResults_other: 'Ver {{count}} resultados',
    title: 'Servicios de tierra',
    subtitle:
      'Tours, transfers, circuitos, trenes, ferries, autos y eSIMs. Los precios ya incluyen el markup de la agencia.',
    caseContext: {
      active: 'Caso #{{number}} · {{subject}} · {{client}}',
      invalid: 'Este caso no está disponible para reservar en la agencia operativa o no tiene cliente.',
      remove: 'Quitar contexto',
      travelers_one: '{{count}} viajero',
      travelers_other: '{{count}} viajeros',
      useComposition: 'Usar esta composición',
      compositionTooLarge: 'El roster tiene {{count}} viajeros; este buscador admite hasta 9 por búsqueda.',
      searchServices: 'Buscar servicios',
      caseNeedsClient: 'Asigná un cliente antes de buscar servicios para este caso.',
      wrongAgency: 'El caso no pertenece a la agencia operativa de Rutero.',
    },
    transfersIntro:
      'Traslados privados y compartidos. Los precios ya incluyen el markup de la agencia.',
    busesIntro:
      'Micros de media y larga distancia. El precio de búsqueda es la tarifa del asiento: los impuestos de venta aparecen al reservar.',
    buses: {
      from: 'Origen',
      to: 'Destino',
      returnDate: 'Fecha de vuelta',
      withReturn: 'Ida y vuelta',
      seats: 'Asientos',
      stationPlaceholder: 'Ciudad o terminal',
      typeToSearch: 'Escribí al menos 2 letras',
      noStations: 'Sin paradas para esa búsqueda',
      emptyState: 'Completá origen, destino y fecha para buscar micros.',
      found_one: '{{count}} servicio',
      found_other: '{{count}} servicios',
      returnsFound_one: '{{count}} vuelta para tu ida',
      returnsFound_other: '{{count}} vueltas para tu ida',
      noResults: 'Sin servicios para esa fecha.',
      direct: 'Directo',
      connection: 'Con trasbordo',
      attendant: 'Con azafata',
      fewSeats_one: 'Queda {{count}} asiento',
      fewSeats_other: 'Quedan {{count}} asientos',
      otherClasses: 'También: {{classes}}',
      // El precio de búsqueda es la tarifa pelada: el total con impuestos
      // sale del hold. Decirlo en la card evita cotizar de menos.
      plusTaxes: '+ impuestos al reservar',
      roundTripTotal: 'Total ida y vuelta',
      stepOutbound: '1 · Elegí la ida',
      // El CTA del paso 1 dice el verbo REAL: en ida y vuelta elegir la ida
      // no reserva nada todavía, abre el paso 2.
      pickOutbound: 'Elegir ida',
      stepReturn: '2 · Elegí la vuelta',
      outboundChosen: 'Ida elegida: {{time}} ({{seatClass}})',
      changeOutbound: 'Cambiar ida',
      outboundExpired:
        'La ida elegida venció (la sesión del proveedor dura 15 minutos). Elegila de nuevo.',
      sortDeparture: 'Hora de salida',
      sortDuration: 'Duración',
      classFilter: 'Calidad',
      operatorFilter: 'Operador',
      serviceFilter: 'Servicio',
      seatMap: 'Elegir asientos',
      seatMapOptional:
        'Elegir asiento es opcional: sin elección se asignan los primeros libres de la calidad.',
      seatsChosen: '{{chosen}} de {{total}}',
      seatPremium: 'Adicional {{price}}',
      deck: 'Piso {{deck}}',
    },
    places: {
      placeholder: 'Ciudad, aeropuerto, puerto…',
      typeToSearch: 'Escribí al menos {{count}} letras',
      noResults: 'Sin resultados para esa búsqueda',
      noProviders: 'Sin proveedores configurados para este destino',
      searchError: 'No se pudo buscar destinos. Probá de nuevo.',
      groups: {
        places: 'Ciudades y zonas',
        airports: 'Aeropuertos',
        stations: 'Estaciones',
        ports: 'Puertos y terminales',
        points: 'Puntos de interés',
        addresses: 'Hoteles y direcciones',
      },
      kinds: {
        country: 'País',
        region: 'Región',
        district: 'Distrito',
        city: 'Ciudad',
        neighborhood: 'Barrio',
        airport: 'Aeropuerto',
        station: 'Estación',
        port: 'Puerto',
        terminal: 'Terminal',
        beach: 'Playa',
        poi: 'POI',
      },
    },
    passengerPicker: {
      label: 'Pasajeros',
      title: 'Pasajeros',
      empty: 'Elegí los pasajeros',
      max: 'Hasta {{count}} pasajeros en total',
      incomplete: 'Completá las edades requeridas',
      done: 'Listo',
      increase: 'Agregar {{type}}',
      decrease: 'Quitar {{type}}',
      ageLabel: 'Edad · {{type}} {{number}}',
      typeNames: {
        passenger: 'Pasajero',
        adult: 'Adulto',
        child: 'Menor',
        youth: 'Joven',
        senior: 'Senior',
      },
      types: {
        passenger_one: '{{count}} pasajero',
        passenger_other: '{{count}} pasajeros',
        adult_one: '{{count}} adulto',
        adult_other: '{{count}} adultos',
        child_one: '{{count}} menor',
        child_other: '{{count}} menores',
        youth_one: '{{count}} joven',
        youth_other: '{{count}} jóvenes',
        senior_one: '{{count}} senior',
        senior_other: '{{count}} seniors',
      },
      age: {
        hidden: 'No se pide edad',
        optional: 'Edad opcional · mejora la precisión de la tarifa',
        required: 'Edad obligatoria',
      },
      errors: {
        required: 'Ingresá la edad para continuar.',
        invalid: 'Ingresá una edad entera dentro del rango indicado.',
        unsupported: 'Ese tipo de pasajero ya no está disponible.',
      },
    },
    railIntro:
      'Trenes en Europa. El proveedor cotiza en vivo, así que la búsqueda puede tardar hasta un minuto.',
    rail: {
      from: 'Origen',
      to: 'Destino',
      stationPlaceholder: 'Ciudad o estación',
      typeToSearch: 'Escribí al menos 2 letras',
      noStations: 'Sin estaciones para esa búsqueda',
      searchingLong:
        'Buscando… el proveedor cotiza en vivo con los operadores, puede tardar hasta un minuto.',
      ageErrors: {
        required: 'La edad real es obligatoria para jóvenes y seniors.',
        invalid: 'Ingresá una edad entera entre 0 y 120.',
        unsupported: 'Este tipo ya no está habilitado. Volvé a seleccionarlo.',
      },
      ageNeededForPasses:
        'Cerrá este diálogo, volvé a la búsqueda de trenes, ingresá la edad real de todos los pasajeros y buscá de nuevo para cotizar pases.',
      journeysFound_one: '{{count}} viaje',
      journeysFound_other: '{{count}} viajes',
      direct: 'Directo',
      connection: 'Trasbordo · {{duration}}',
      stops_one: '{{count}} combinación',
      stops_other: '{{count}} combinaciones',
      select: 'Elegir',
      extraVariants_one: 'El proveedor publica {{count}} variante más con la misma condición y otro precio: se muestra la más barata.',
      extraVariants_other: 'El proveedor publica {{count}} variantes más con las mismas condiciones y otros precios: se muestran las más baratas.',
      emptyState: 'Completá origen, destino y fecha para buscar trenes.',
      conditions: 'Condiciones de la tarifa',
      // El texto de cada condición lo publica el operador (en inglés): solo se
      // traduce la etiqueta del tipo, nunca la letra chica.
      conditionTypes: {
        REFUND: 'Devolución',
        EXCHANGE: 'Cambios',
        LUGGAGE: 'Equipaje',
        SEAT: 'Asiento',
        CANCELLATION: 'Cancelación',
      },
    },
    ferryIntro:
      'Ferries. Los horarios son hora local de cada puerto y el precio incluye el vehículo cuando se embarca.',
    ferry: {
      fromPort: 'Puerto de salida',
      toPort: 'Puerto de llegada',
      date: 'Fecha de ida',
      returnDate: 'Fecha de vuelta',
      addReturn: 'Agregar vuelta',
      withVehicle: 'Con vehículo',
      vehicle: 'Vehículo',
      vehicleTooltip:
        'Sin vehículo los pasajeros viajan a pie. La tarifa depende del largo y la altura del vehículo, así que hay que elegir el modelo del catálogo del proveedor.',
      currency: 'Moneda',
      portPlaceholder: 'ej. Dover',
      vehiclePlaceholder: 'ej. Volkswagen Golf',
      typeToSearch: 'Escribí al menos 2 letras',
      vehicleOnly: 'solo con vehículo',
      noRoutes: 'El proveedor no conecta este puerto de salida con ningún otro. Probá otro origen.',
      noPorts: 'Sin puertos para esa búsqueda',
      noVehicles: 'Sin vehículos para esa búsqueda',
      emptyState:
        'Elegí los puertos de salida y llegada y la fecha para ver las travesías disponibles.',
      accommodation: 'Acomodación',
      ticketType: 'Tipo de tarifa',
      berths_one: '{{count}} plaza',
      berths_other: '{{count}} plazas',
      shared: 'Compartida',
      compulsory: 'Obligatoria en esta travesía',
      compulsoryNotice:
        'Esta travesía exige plaza asignada para cada pasajero. Si no elegís, queda la plaza incluida en la tarifa; si elegís, tu selección la reemplaza y el operador la valida antes de reservar.',
      compulsoryNoOptions:
        'Esta travesía exige plaza asignada para cada pasajero y el operador no publica plazas para elegir: se reserva con la que incluye la tarifa.',
      includedInPrice: 'Incluida en el precio',
      defaultAccommodation: 'Queda esta si no elegís',
      fareIncluded: 'Incluida',
      fareOptional: 'Opcional: sin elección se aplica la tarifa base.',
      fareSamePrice:
        'Todas cuestan lo mismo: lo que cambia son las condiciones de abajo.',
      farePriceUnknown:
        'Opcional: el operador no publica el precio de todas las tarifas; el total firme se calcula al reservar.',
      fareFinalHint: 'Los adicionales ya incluyen el markup de la agencia; el precio firme se calcula al reservar.',
      pricingUnavailable:
        'No se pudieron cotizar los adicionales de esta oferta (pudo vencer): el precio firme se calcula al reservar.',
      extraPrice: '+ {{price}}',
      seatsOptional: 'Opcional en esta travesía',
      seatsRequired: 'Elegí una plaza por pasajero: esta travesía la exige',
      seatsPartial_one: 'Falta cubrir {{count}} pasajero',
      seatsPartial_other: 'Faltan cubrir {{count}} pasajeros',
      seatsCovered_one: '{{count}} pasajero cubierto',
      seatsCovered_other: '{{count}} pasajeros cubiertos',
      vessel: 'Buque',
      noRoute:
        'Sin salidas para esa fecha entre {{fromPort}} y {{toPort}}. Ojo: que los dos puertos existan no significa que haya una ruta directa entre ellos.',
      noKnownRoute:
        'No encontramos ninguna ruta entre {{fromPort}} y {{toPort}}. Podés buscar igual, pero probablemente no haya travesía directa.',
      found_one: '{{count}} travesía',
      found_other: '{{count}} travesías',
      busIncluded: 'Incluye tramo en bus',
      checkIn_one: 'Check-in {{count}} min antes',
      checkIn_other: 'Check-in {{count}} min antes',
      crossing: 'Travesía',
      assignedSeatRequired: 'Butaca asignada obligatoria',
      roundTrip: 'Ida y vuelta',
      onFoot: 'A pie (sin vehículo)',
      totalOneWay: 'total del tramo',
      totalRoundTrip: 'total ida y vuelta',
      sortDeparture: 'Salida',
      sortDuration: 'Duración',
    },
    circuitsIntro:
      'Circuitos guiados multi-día. Primero elegí el circuito y después vas a ver sus salidas: el precio del proveedor es por persona y acá se muestra el total.',
    circuits: {
      productSheet: 'Ficha del circuito',
      clientPdf: 'PDF para tu cliente',
      selectedCount_one: '{{count}} seleccionada — va marcada en el PDF',
      selectedCount_other: '{{count}} seleccionadas — van marcadas en el PDF',
      print: {
        optionalPriceNote: 'El precio de cada excursión lo confirma tu asesor.',
        loading: 'Cargando los datos de la agencia…',
        agencyUnavailable:
          'No se pudieron cargar los datos de la agencia: recargá la pantalla para volver a intentarlo.',
        action: 'Imprimir / Guardar PDF',
        quotedOn: 'Cotización de circuito · {{date}}',
        yourAdvisor: 'Tu asesor: {{name}}',
        operatedBy: 'Operado por {{provider}}',
        perPersonDoubleLong: 'por persona en base doble',
        indicativeOn:
          'Precios indicativos al {{date}}, sujetos a disponibilidad y confirmación del operador.',
        selectedBadge: 'Seleccionada',
        alsoAvailable: 'también disponible',
        generatedOn: 'Cotización generada el {{date}}',
      },
      changeCircuit: 'Cambiar circuito',
      returns: 'regresa {{date}}',
      series: 'Serie {{name}}',
      singleSupplementIndicative: 'Supl. single {{price}} (indicativo)',
      indicativeFrom: 'Desde — indicativo',
      itineraryByDay: 'Itinerario día a día',
      optionalFull: 'Ver la excursión completa',
      dayFull: 'Ver día completo',
      dayLess: 'Ver menos',
      dayVideo: 'Video del día',
      seeAllDays_one: 'Ver el día del itinerario',
      seeAllDays_other: 'Ver los {{count}} días del itinerario',
      collapseDays: 'Ver menos días',
      optionalsAside: 'Excursiones opcionales — se compran aparte',
      providerPrice: 'Precio del proveedor',
      optionalNoPrice: 'Precio a confirmar',
      operatorBrochure: 'Folleto del operador',
      seeDepartures: 'Ver salidas',
      toConfirmByOperator: 'A confirmar por operador',
      passportFlag: 'Requiere pasaporte',
      fromPerPersonIndicative: 'desde {{price}} p/p en doble · indicativo',
      sheetError: 'No se pudo cargar la ficha del circuito',
      viewSheet: 'Ver ficha',
      includes: 'Incluye',
      video: 'Ver video',
      brochure: 'Folleto {{number}}',
      guaranteedDeparture: 'Salida garantizada',
      passportRequired: 'Este circuito exige el número de pasaporte de cada pasajero.',
      product: 'Circuito',
      productPlaceholder: 'ej. Bellezas de Europa',
      typeToSearch: 'Escribí al menos 3 letras',
      noProducts: 'Sin circuitos para esa búsqueda',
      onlyPastSeasons:
        'Solo hay circuitos de temporadas pasadas con ese nombre. Activá "incluir temporadas anteriores" para verlos.',
      includePastSeasons: 'Incluir temporadas anteriores',
      // ── Multibuscador (catálogo rastreado) ─────────────────────────────
      destinations: 'Destinos',
      destinationsPlaceholder: 'Ciudad por la que pasa',
      typeToSearchCity: 'Escribí al menos 2 letras',
      noCities: 'Sin ciudades para esa búsqueda',
      reselectCanonicalDestinations:
        'Esta búsqueda guardada usa destinos anteriores. Volvé a elegirlos en el maestro de lugares.',
      circuitsCount_one: '{{count}} circuito',
      circuitsCount_other: '{{count}} circuitos',
      allCitiesNotice: 'El circuito tiene que pasar por TODAS las ciudades elegidas.',
      duration: 'Duración (días)',
      minDays: 'Mín.',
      maxDays: 'Máx.',
      catalogFound_one: '{{count}} circuito en el catálogo',
      catalogFound_other: '{{count}} circuitos en el catálogo',
      catalogTracked: 'Catálogo rastreado',
      catalogProviderFreshness_one: '{{provider}} {{total}} circuito ({{date}})',
      catalogProviderFreshness_other: '{{provider}} {{total}} circuitos ({{date}})',
      catalogCoverage:
        'G Adventures no es listable: se busca por producto puntual.',
      noCatalogResults:
        'Ningún circuito pasa por todas esas ciudades. Probá con menos ciudades o ampliando la duración.',
      pickDate: 'Elegí desde qué fecha querés ver salidas y tocá Buscar.',
      categoryPrice: 'Precio de categoría {{category}}',
      seeCircuit: 'Ver circuito',
      // ── Filtros de resultados ──────────────────────────────────────────
      sortDate: 'Fecha de salida',
      sortDuration: 'Duración',
      sortName: 'Nombre',
      categoryFilter: 'Categoría',
      monthFilter: 'Mes de salida',
      band: {
        '1-7': 'Hasta 7 días',
        '8-14': '8 a 14 días',
        '15+': '15 días o más',
      },
      mixedCurrencies:
        'Hay circuitos en distintas monedas: el orden por precio compara los importes sin convertirlos.',
      priceOnDepartures: 'Precio al abrir el circuito',
      perPersonDouble: 'p/p en doble',
      indicativeByDeparture: 'Indicativo — según salida',
      pastSeasonWarning:
        'Ese circuito es de la temporada {{season}}: probablemente no tenga salidas disponibles. Buscá uno de la temporada vigente.',
      from: 'Salidas desde',
      to: 'Salidas hasta',
      emptyState: 'Elegí un circuito y la ventana de fechas para ver sus salidas.',
      departuresFound_one: '{{count}} salida',
      departuresFound_other: '{{count}} salidas',
      noDepartures:
        'Ese circuito no tiene salidas en esas fechas. Probá otra ventana o revisá que sea de la temporada vigente.',
      providerNotSearchable:
        'Las salidas de este circuito son de {{provider}}, que no está disponible para búsqueda en esta agencia: no se pueden cotizar hasta que se configure su conector.',
      providerNotSearchableShort: '{{provider}} no cotiza salidas en esta agencia',
      until: 'hasta el {{date}}',
      departureOn: 'Salida el {{date}}',
      fromPerPersonDouble: 'desde, por persona en doble',
      singleSupplement: 'Individual: + {{price}}',
      indicativeNotice: 'El total exacto se confirma al reservar.',
      perPerson: '{{price}} por persona',
      totalForPax_one: 'total por {{count}} pasajero',
      totalForPax_other: 'total por {{count}} pasajeros',
      occupancy: {
        label: 'Habitaciones y edades',
        title: 'Habitaciones y edades de los pasajeros',
        hint: 'Las edades son a la fecha de salida. Un pasajero nuevo se agrega con la edad adulta que publica el operador.',
        summary: '{{rooms}} hab. · {{passengers}} pax',
        room: 'Habitación {{number}}',
        age: 'Edad del pasajero {{number}}',
        addAdult: 'Agregar adulto',
        addRoom: 'Agregar habitación',
        removeRoom: 'Quitar habitación',
        removePassenger: 'Quitar pasajero',
        unavailable: 'El conector de este circuito no publicó los límites de ocupación. No se puede cotizar habitaciones con seguridad.',
      },
      quote: {
        rooms: 'Habitaciones y categoría',
        roomsHint: 'La composición viene de la búsqueda. Elegí una categoría solo cuando el operador la publica.',
        ages: 'Edades: {{ages}}',
        supplements: 'Suplementos',
        passengerScope: 'Pasajero {{passenger}} · habitación {{room}}',
        bookingScope: 'Toda la reserva',
        addSupplement: 'Agregar',
        nights: 'Noches',
        breakdown: 'Desglose del operador',
        conditions: 'Ver condiciones del operador',
        passengerRoom: '{{passenger}} · habitación {{room}}',
        unavailable: 'No se puede obtener la cotización autoritativa de esta salida. La reserva queda bloqueada hasta que el conector publique esa capacidad.',
        refreshing: 'El operador rechazó el token anterior. Se está pidiendo una cotización nueva con las mismas habitaciones y pasajeros.',
        ageBandsUnavailable: 'El operador no publicó una franja etaria inequívoca para cada pasajero. La reserva queda bloqueada sin inventar tipos de pasajero.',
        unavailableReason: {
          external_approval_required: 'La cotización está bloqueada hasta completar la certificación comercial externa.',
          provider_environment_restriction: 'El entorno actual del operador no permite cotizar esta salida.',
          live_validation_pending: 'La cotización está pendiente de validación operativa en vivo.',
        },
        transfer: {
          airport: 'Aeropuerto',
          airline: 'Aerolínea',
          flightNumber: 'Número de vuelo',
          dateTime: 'Fecha y hora',
          city: 'Ciudad',
        },
      },
    },
    extras: {
      title: 'Extras del proveedor',
      loading: 'Buscando los extras del proveedor…',
      unavailable: 'No se pudieron obtener los extras del proveedor de esta reserva.',
      none: 'Esta reserva no tiene extras disponibles.',
      purchased: 'Contratados',
      add: 'Agregar',
      remove: 'Quitar',
      added: 'Servicio agregado a la reserva',
      removed: 'Servicio quitado de la reserva',
      unavailableCount_one: 'No disponible ({{count}})',
      unavailableCount_other: 'No disponibles ({{count}})',
      addError: 'No se pudo agregar el servicio',
      removeError: 'No se pudo quitar el servicio',
      serviceDate: 'Fecha del servicio',
      validRange: 'Válido {{from}} – {{to}}',
      passengers: 'Pasajeros',
      passengerFallback: 'Pasajero {{number}}',
      providerPassenger: 'Pasajero del proveedor: {{reference}}',
      passengerUnknown: 'El proveedor no dice a qué pasajero aplica',
      // El importe publicado describe UNA unidad (el proveedor compra una por
      // pasajero): se dice eso y cuántos van, sin sumar nada.
      perPassenger_one: 'por pasajero · {{count}} pasajero',
      perPassenger_other: 'por pasajero · {{count}} pasajeros',
      blocked: {
        noPassenger: 'Elegí al menos un pasajero',
        dateOutOfRange: 'La fecha está fuera de la vigencia del servicio',
        dateRequired: 'Elegí la fecha del servicio',
        limitReached: 'Sin cupo del operador para este servicio en esta reserva',
        overRemaining:
          'El operador acepta {{max}} en esta reserva y queda(n) {{remaining}}: elegí menos pasajeros',
      },
    },
    passesIntro:
      'Pases de tren para Europa. No hay origen ni destino: un pase habilita a viajar por una red durante su vigencia. El producto (Interrail o Eurail) lo define la residencia del pasajero.',
    passes: {
      residence: 'País de residencia',
      bookingBlocked: 'Los pases se pueden cotizar pero todavía no reservar: el proveedor está resolviendo un problema en su lado. El precio que ves es real.',
      // El motivo corto va EN la card y pegado a cada botón bloqueado; el
      // texto largo queda como tooltip.
      quoteOnly: 'Solo cotización',
      residenceHint:
        'Define el producto: los residentes en Europa compran Interrail y el resto, Eurail. Por eso no se elige a mano.',
      addPassenger: 'Agregar pasajero',
      age: 'Edad',
      youth: 'Joven',
      youthHint:
        'No existe tarifa de niño: los menores viajan como "joven" con su edad real, y el proveedor aplica el descuento que corresponda.',
      emptyState: 'Indicá la residencia y los pasajeros para ver los pases disponibles.',
      found_one: '{{count}} producto ({{total}} variantes)',
      found_other: '{{count}} productos ({{total}} variantes)',
      variants_one: '{{count}} variante',
      variants_other: '{{count}} variantes',
      fromPrice: 'desde',
      showVariants: 'Ver variantes',
      hideVariants: 'Ocultar',
      travelClass: 'Clase',
      firstClass: '1ª clase',
      secondClass: '2ª clase',
      travelDays: 'Días de viaje',
      travelDaysIn: '{{days}} días de viaje dentro de {{validity}} días',
      continuous: 'Viaje continuo (todos los días de la vigencia)',
      globalOnly: 'Solo pases globales',
      filterByCountry: 'Buscar país',
      ticketNotice:
        'El título de viaje es un CÓDIGO (no un PDF) y el proveedor lo emite entre 3 y 15 minutos después de confirmar.',
      residenceNeeded:
        'Indicá el país de residencia del pasajero para ver los pases que le corresponden.',
      crossSell: 'Pases que cubren este viaje',
      crossSellHint:
        'Si el pasajero hace varios trayectos, un pase puede convenir más que los boletos sueltos.',
      crossSellSearch: 'Ver pases para este viaje',
      crossSellEmpty: 'No hay pases que cubran este viaje.',
      crossSellFrom: '{{count}} pases desde {{price}}',
    },
    carsIntro:
      'Alquiler de autos. El precio es el TOTAL del período y el proveedor tarifa según el país de residencia del cliente.',
    cars: {
      pickUp: 'Retiro',
      dropOff: 'Devolución',
      pickUpDate: 'Fecha de retiro',
      pickUpTime: 'Hora',
      dropOffDate: 'Fecha de devolución',
      dropOffTime: 'Hora',
      residence: 'País de residencia',
      residenceHint: 'Del cliente: cambia la tarifa',
      differentDropOff: 'Devolver en otro lugar',
      paymentType: 'Forma de pago',
      paymentAny: 'Todas',
      paymentPpd: 'Prepago',
      paymentPod: 'Pago en destino',
      locationPlaceholder: 'Aeropuerto o ciudad',
      typeToSearch: 'Escribí al menos 2 letras',
      noLocations: 'Sin ubicaciones para esa búsqueda',
      nearbyOffices_one: '{{count}} oficina cercana',
      nearbyOffices_other: '{{count}} oficinas cercanas',
      unsearchableLocation:
        'El proveedor no publica código ni coordenadas para esa ubicación: elegí el aeropuerto o una ciudad cercana.',
      unsearchableLocationNoCountry:
        'No pudimos obtener el país de ese lugar: probá elegir otro.',
      reselectCanonicalDropOff:
        'Esta búsqueda guardada usa una devolución anterior. Volvé a elegirla en el maestro de lugares.',
      reselectCanonicalPickUp:
        'Esta búsqueda guardada usa un retiro anterior. Volvé a elegirlo en el maestro de lugares.',
      emptyState: 'Elegí dónde y cuándo retirar el auto para ver los vehículos disponibles.',
      found_one: '{{count}} vehículo · {{rates}} tarifas',
      found_other: '{{count}} vehículos · {{rates}} tarifas',
      ratePlan: 'Tarifa',
      included: 'Qué incluye',
      onTerminal: 'En la terminal',
      shuttle: 'Con shuttle',
      onTerminalOnly: 'Solo en terminal',
      onTerminalTooltip:
        'La oficina está EN la terminal del aeropuerto: se retira el auto sin traslados.',
      shuttleTooltip:
        'La oficina está fuera del aeropuerto: hay que tomar un shuttle de la rentadora para retirar el auto.',
      // Tipos de condición que publica el proveedor (en inglés): se traduce
      // solo la etiqueta, el texto es suyo.
      conditionTypes: {
        Mileage: 'Kilometraje',
        Tax: 'Impuestos y tasas',
        'Collision Protection': 'Cobertura de daños',
        'Liability Insurance': 'Responsabilidad civil',
        'Addt’l. Driver': 'Conductor adicional',
        'Additional Driver': 'Conductor adicional',
        Fuel: 'Combustible',
        Deductible: 'Franquicia',
      },
      filters: 'Filtros',
      clearFilters: 'Limpiar',
      showResults_one: 'Ver {{count}} vehículo',
      showResults_other: 'Ver {{count}} vehículos',
      commissionableTooltip: 'Este precio ya es el PVP al cliente: no se le aplica markup de la agencia. El proveedor liquida su comisión por separado, y el monto exacto se conoce al confirmar la reserva.',
      onTerminalDetail: 'La oficina está EN la terminal del aeropuerto: se retira el auto sin traslados.',
      offTerminalDetail: 'La oficina está fuera del aeropuerto: la rentadora traslada al pasajero en shuttle.',
      typeFilter: 'Tipo',
      paxFilter: 'Pasajeros',
      companyFilter: 'Compañía',
      protectionFilter: 'Protección',
      compareProtections: 'Comparar protecciones',
      comparingProtections: 'Cargando protecciones…',
      refreshProtections: 'Actualizar protecciones',
      retryProtections: 'Reintentar comparación',
      protectionComparisonFailed:
        'No pudimos cargar la comparación. Conservamos la tarifa disponible originalmente.',
      protectionComparisonExpired:
        'La comparación de protecciones venció. Actualizala para poder elegir esas tarifas.',
      protectionComparisonReady_one:
        '{{count}} protección disponible · vigente {{time}}',
      protectionComparisonReady_other:
        '{{count}} protecciones disponibles · vigentes {{time}}',
      protectionComparisonEmpty:
        'La comparación terminó correctamente, pero no hay protecciones alternativas disponibles.',
      automaticOnly: 'Solo automáticos',
      sort: 'Ordenar por',
      sortPrice: 'Precio',
      sortPassengers: 'Capacidad',
      sortCompany: 'Compañía',
      bodies: {
        car: 'Auto',
        suv: 'SUV',
        van: 'Van',
        pickup: 'Pick up',
        convertible: 'Convertible',
        wagon: 'Rural',
      },
      passengers_one: '{{count}} pasajero',
      passengers_other: '{{count}} pasajeros',
      bags_one: '{{count}} valija',
      bags_other: '{{count}} valijas',
      doors_one: '{{count}} puerta',
      doors_other: '{{count}} puertas',
      airConditioning: 'Aire acondicionado',
      sameOffice: 'Retiro y devolución en {{office}}',
      twoOffices: 'Retiro en {{pickUp}} · devolución en {{dropOff}}',
      totalForDays_one: 'total por {{count}} día',
      totalForDays_other: 'total por {{count}} días',
      totalTooltip_one:
        'Precio total del alquiler por {{count}} día, con los impuestos que el proveedor informa.',
      totalTooltip_other:
        'Precio total del alquiler por {{count}} días, con los impuestos que el proveedor informa.',
      commissionable: 'El proveedor liquida comisión aparte',
      approxBreakdown: 'Aproximados del proveedor — base: {{base}} · tasas: {{tax}}',
      bookingDates_one: 'Retiro {{pickUp}} → devolución {{dropOff}} ({{count}} día)',
      bookingDates_other: 'Retiro {{pickUp}} → devolución {{dropOff}} ({{count}} días)',
      bookingOffices: '{{location}} · oficinas {{pickUp}} → {{dropOff}}',
    },
    esimsIntro:
      'eSIMs de datos para viajar. Consultá la política de activación de cada paquete: instalar la eSIM no necesariamente inicia su vigencia.',
    esims: {
      local: 'Un país',
      global: 'Regional / mundial',
      destination: 'Destino',
      countriesUnavailable:
        'No pudimos buscar países en este momento. Podés elegir una región, o probá de nuevo en un rato.',
      noDestinations: 'Sin destinos para esa búsqueda',
      countries: 'Países',
      regions: 'Regiones',
      available_one: '{{count}} paquete',
      available_other: '{{count}} paquetes',
      findPlan: 'Buscar un plan',
      destinationPlaceholder: 'ej. España, Europa',
      coverageIs: 'Cobertura: {{type}}',
      dataFilter: 'Datos (GB)',
      validityFilter: 'Vigencia (días)',
      emptyState: 'Elegí un destino y buscá los paquetes disponibles.',
      days: 'días',
      coverage: 'Cobertura',
      network: 'Red',
      package: 'Paquete',
      validityCol: 'Vigencia',
      retailCol: 'PVP sugerido',
      unlimited: 'Datos ilimitados',
      validity_one: '{{count}} día de vigencia',
      validity_other: '{{count}} días de vigencia',
      suggestedPrice: 'PVP sugerido: {{price}}',
      planType: 'Tipo: {{value}}',
      voiceMinutes: '{{count}} min de voz',
      textMessages: '{{count}} SMS',
      activationPolicy: 'Activación: {{value}}',
      requiresRoaming: 'Activá la itinerancia de datos en esta eSIM. Mantenela desactivada en tu línea habitual para evitar posibles cargos de tu operador.',
      apn: 'APN: {{value}}',
    },
    experiencesIntro:
      'Tours y actividades. Los precios ya incluyen el markup de la agencia.',
    search: 'Buscar',
    searching: 'Buscando en los proveedores…',
    refreshingPrices: 'Actualizando los precios actuales…',
    resultsExpired: 'Estos resultados vencieron. Tocá Buscar para obtener precios vigentes antes de reservar.',
    // Versión corta para pegar al lado de un botón bloqueado, donde no entra
    // la explicación completa (el aviso largo ya está arriba de la lista).
    resultsExpiredShort: 'Cotización vencida',
    // El formulario dejó de describir la búsqueda que produjo la lista: los
    // resultados son de la anterior y no se puede reservar sobre ellos.
    formDiverged:
      'Cambiaste la búsqueda y todavía no la ejecutaste — estos resultados son de la anterior. Tocá Buscar para verlos actualizados.',
    formDivergedShort: 'Búsqueda sin ejecutar',
    // La vigencia es propiedad de la BÚSQUEDA, no de cada oferta: vive en la
    // barra de resumen y no como chip por card, donde se leería como escasez.
    pricesValidFor: 'Precios válidos {{time}} más',
    editSearch: 'Editar búsqueda',
    refreshPrices: 'Actualizar precios',
    sortDirection: 'Invertir el orden',
    priceFrom: 'desde',
    viaProvider: 'vía {{provider}}',
    incompleteLink:
      'Este link no trae todos los datos de la búsqueda: completá lo que falta en el formulario y tocá Buscar.',
    activeSearchSummary: 'Resultados para',
    searchError: 'La búsqueda falló. Probá de nuevo.',
    noResults: 'Sin resultados para esta búsqueda.',
    providerFailed: '{{provider}} no respondió',
    providerNoResults: 'sin resultados',
    providerTimedOut: '{{provider}} tardó demasiado',
    providerSkipped: '{{provider}} omitido por ubicación',
    providerSkippedReasons: {
      place_not_mapped: 'El proveedor no cubre este lugar.',
      system_not_known: 'El proveedor no reconoce este tipo de lugar.',
      resolver_unavailable: 'No se pudo resolver el lugar en este intento.',
    },
    providerTruncated: '{{provider}}: {{returned}} de {{total}} resultados',
    providerDegraded: '{{provider}} cotizó en su moneda nativa',
    providersFailed: 'Proveedores sin respuesta: {{providers}}',
    offer: 'Oferta',
    pax: 'Pasajeros',
    durationDays_one: '{{count}} día',
    durationDays_other: '{{count}} días',
    clearSearch: 'Limpiar',
    recentSearches: 'Búsquedas recientes',
    // Resumen de una búsqueda reciente: entra en un chip, así que va corto.
    paxShort_one: '{{count}} pax',
    paxShort_other: '{{count}} pax',
    netPrice: 'Neto: {{price}}',
    grossPrice: 'PVP del proveedor',
    book: 'Reservar',
    all: 'Todos',
    finalPrice: 'Precio',
    createdAt: 'Creada',
    bookingsTitle: 'Reservas',
    bookingsSubtitle:
      'Todas las reservas de hoteles, tours, transfers y demás servicios de la agencia.',
    bookingList: {
      tabs: {
        attention: 'Necesitan atención',
        upcoming: 'Próximas a viajar',
        all: 'Todas',
        closed: 'Cerradas',
      },
      columns: {
        state: 'Estado',
        service: 'Servicio',
        holder: 'Titular · pax',
        provider: 'Proveedor · ref',
        milestone: 'Próximo hito',
        total: 'Total',
        case: 'Caso',
        created: 'Creada',
        action: 'Acción',
      },
      scope: {
        label: 'De quién',
        mine: 'Mías',
        all: 'Todas',
        advisor: 'Asesor',
        advisorPlaceholder: 'Buscar…',
      },
      filters: {
        search: 'Buscar',
        searchPlaceholder: 'Reserva, titular, caso, cliente…',
        case: 'Caso #{{number}}',
        serviceDate: 'Fecha del servicio',
        serviceDateFrom: 'Servicio desde',
        serviceDateTo: 'Servicio hasta',
        saleOrderless: 'Sin sale order',
      },
      sort: {
        createdAt: { desc: 'Creación ↓', asc: 'Creación ↑' },
        serviceDate: { asc: 'Servicio ↑', desc: 'Servicio ↓' },
        finalAmount: { desc: 'Total ↓', asc: 'Total ↑' },
      },
      day: {
        today: 'Hoy',
        tomorrow: 'Mañana',
        undated: 'Sin fecha de servicio',
      },
      // El paso que queda, por cara de la recuperación: las mismas cuatro que
      // el modal, sin estados nuevos.
      nextStep: {
        transportAmbiguous: 'El intento quedó sin respuesta — se retoma desde la reserva',
        unknownStateSync: 'Pendiente de conciliación',
        manual: 'Verificar con el proveedor y conciliar a mano',
        adoptionPending: 'Reservada — falta cerrar los números',
        awaitingProvider: 'Esperando al proveedor',
        ticketsReady: 'Tickets listos',
        ticketsPending: 'Sin tickets aún',
      },
      saleOrder: {
        attached: 'Adjuntada',
        detached: 'Sin adjuntar',
        detachedHint: 'Esta reserva todavía no entró a una orden de venta.',
      },
      case: {
        number: 'Caso #{{number}}',
        none: 'Sin caso',
      },
      actions: {
        view: 'Ver',
        resolve: 'Resolver',
      },
      by: 'por {{who}}',
      rowAria: '{{service}} — {{state}}. Abre el detalle de la reserva.',
      actionAria: '{{action}} — {{service}}',
      empty: {
        attention: {
          title: '✅ Nada necesita atención',
          body: 'Todas las reservas están al día. El badge desaparece cuando esto pasa.',
        },
        upcoming: {
          title: 'Sin servicios próximos',
          body: 'No hay reservas vivas con fecha de servicio de hoy en adelante. Probá ampliar el rango de fechas o mirá "Todas".',
        },
        filtered: {
          title: 'Sin reservas con estos filtros',
          body: 'Ningún resultado para lo que está filtrado. Limpiá los filtros para ver la pestaña entera.',
        },
        default: {
          title: 'Sin reservas todavía',
          body: 'Las reservas de servicios de tierra aparecen acá apenas se crean.',
        },
      },
      truncated: 'La cola tiene {{count}} reservas y se muestran las {{shown}} más urgentes. Acotá con los filtros para verlas todas.',
    },
    selectedOptions: {
      section: 'Opciones elegidas para la reserva',
      ferryAccommodations: 'Acomodaciones elegidas',
      ferryTicketType: 'Tipo de tarifa elegido',
      noFerryAccommodations: 'No se enviaron acomodaciones explícitas.',
      busSeats: 'Asientos elegidos explícitamente',
      busClassOverride: 'Cambio de clase elegido',
      noExplicitBusSeats:
        'No se eligieron asientos explícitos — los asigna el proveedor.',
      // Confirmado por el PROVEEDOR al holdear — distinto de lo elegido/pedido.
      sectionReserved: 'Lo que quedó reservado',
      reservedAccommodations: 'Acomodación',
      noReservedAccommodations: 'El proveedor no asignó ninguna plaza.',
      reservedTicketType: 'Tarifa',
      // El proveedor no confirmó (al menos) una de las facetas pedidas —
      // acomodación y/o tarifa — así que se muestran ambas fuentes para que
      // la discrepancia sea visible. La nota tiene que nombrar la faceta que
      // realmente falta: nunca puede decir "ninguna plaza" cuando el panel
      // de arriba SÍ lista una acomodación confirmada (o viceversa con la
      // tarifa).
      requestedDiscrepancyNoteAccommodations:
        'El proveedor no confirmó ninguna plaza, pero esto fue lo solicitado:',
      requestedDiscrepancyNoteTicketType:
        'El proveedor no confirmó la tarifa, pero esto fue lo solicitado:',
      requestedDiscrepancyNoteBoth:
        'El proveedor no confirmó la plaza ni la tarifa, pero esto fue lo solicitado:',
    },
    // Los TRAMOS del traslado (`booking.legs` del hub, solo transfers):
    // recogida con su estado, punto de encuentro y vehículo, por tramo.
    legs: {
      section: 'Tramos del traslado',
      pickup: 'Recogida',
      associatedFlight: 'Vuelo asociado',
      associatedFlightTime: '{{time}} hora local del vuelo',
      // El proveedor todavía no da la hora (la declara más cerca del viaje).
      // El AVISO pre-confirm con la antelación es de otra pantalla (#2357).
      pickupReconfirm: 'Hora de recogida pendiente',
      pickupReconfirmWithin: 'Consultá la hora de recogida {{hours}} h antes del servicio.',
      verifyPickup: 'El proveedor exige verificar la hora de recogida, aunque ya haya un horario publicado.',
      verificationAvailable: 'La consulta está disponible desde {{hours}} h antes del servicio.',
      instructionsUnavailable: 'Las instrucciones completas exceden el límite disponible. Consultá al operador antes de viajar; este documento no las reemplaza.',
      pickupReconfirmGeneric: 'Consultá la hora de recogida antes del servicio.',
      pickupReconfirmConfirmed: 'La reserva sigue confirmada.',
      pickupReconfirmLink: 'Consultar horario de recogida',
      meetingPoint: 'Punto de encuentro',
      driverInstructions: 'Cómo encontrar a tu conductor',
      vehicle: 'Vehículo',
      freeCancellationUntil: 'Cancelación gratis de este tramo hasta',
      // Hora de PARED del punto de recogida, jamás convertida: es la hora
      // que el pasajero lee en su reloj al llegar.
      localTime: '{{time}} hora local',
      localTimeWithZone: '{{time}} hora local ({{timeZone}})',
    },
    detail: {
      cancelConfirmTitle: '¿Cancelar esta reserva?',
      cancelConfirmQuestion: 'La cancelación no se puede deshacer.',
      cancelConfirm: 'Cancelar y aceptar el cargo',
      cancelConfirmFree: 'Cancelar la reserva',
      cancelKeep: 'No, volver',
      cancelRefused: 'El operador no permitió cancelar',
      cancelToday: {
        costWithRefund: 'Cancelar hoy cuesta {{fee}} — se devuelven {{refund}}',
        cost: 'Cancelar hoy cuesta {{fee}}',
        freeWithRefund: 'Cancelar hoy no tiene costo — se devuelven {{refund}}',
        free: 'Cancelar hoy no tiene costo',
        refund: 'Cancelando hoy se devuelven {{refund}}',
      },
      cancelFullVoucherValue:
        'Cancelar hoy retiene el valor completo del voucher. No es un importe monetario.',
      noShow: {
        cost: 'Cargo por no presentarse: {{fee}}',
        fullVoucherValue:
          'No presentarse retiene el valor completo del voucher. No es un importe monetario.',
      },
      cancelRefundByProvider: 'La devolución la procesa el proveedor.',
      cancelPolicyUnpublished:
        'El proveedor no publica costos de cancelación — puede haber cargos.',
      policyLoading: 'Consultando la política de cancelación…',
      policyUnknown: 'No pudimos obtener la política de cancelación de este proveedor. Cancelar igual puede tener costo.',
      policyScheduleTitle: 'Calendario del proveedor',
      serviceRulesTitle: 'Reglas de cancelación por servicio',
      serviceRuleFrom: 'Desde {{from}} (incluido)',
      serviceRuleUntil: 'Hasta {{to}} (excluido)',
      serviceRulesNotice: 'Horarios locales del proveedor. Cada corte reemplaza al anterior del mismo servicio; estos importes no son devoluciones.',
      serviceRulesMissing: 'Sin reglas publicadas; no implica cancelación gratuita.',
      policyService: 'Servicio {{number}}',
      policyBeforeFirst: 'Antes del primer corte',
      policySummaryBasis: 'Resumen para cancelar todos los servicios suponiendo que ninguno fue consumido. No acredita consumo ni devolución.',
      policyPenaltyUnknown: 'El cargo actual de cancelación no está determinado. No significa que sea cero.',
      conditionalNotice: 'Cargos condicionales independientes: no son el costo vigente ni se suman entre sí.',
      conditionalEvent: { cancellation: 'En caso de cancelación', no_show: 'En caso de no presentarse' },
      conditionalFull: 'Cargo: valor completo del voucher',
      conditionalWindow:
        'Antelación publicada respecto al retiro: {{hours}} h. Frontera y zona horaria no especificadas; consultar las condiciones del proveedor.',
      policyRefundUnknown: 'El proveedor no determina el valor consumido ni la devolución.',
      policySource: { availability: 'Fuente: disponibilidad cotizada', booking: 'Fuente: reserva del proveedor' },
      policyScope: { incomplete: 'Faltan reglas o hay contradicciones: no hay un total determinado.', unattributed: 'No se puede asociar cada regla a un servicio; los importes no se suman.' },
      policyScheduleWhen: 'Cuándo',
      policyScheduleCost: 'Costo de cancelar',
      policyScheduleLocalTime: 'Cortes en hora local del servicio, sin conversión al huso del asesor. El inicio es exclusivo y el fin inclusivo. El costo actual es el informado por el proveedor.',
      policyRuleCost: '{{percent}} + {{fee}} de gastos',
      policyRuleManagement: '{{fee}} de gastos',
      policyRangeBetween: 'Después de {{from}} y hasta {{to}} inclusive',
      policyRangeUntil: 'Hasta {{to}} inclusive',
      policyRangeFrom: 'Después de {{from}}',
      policyRangeAny: 'Sin fecha declarada',
      title: 'Detalle de reserva',
      expiresCol: 'Vence',
      onRequestNotice: 'El operador todavía no aceptó esta reserva: puede confirmarla o rechazarla. El estado se actualiza al sincronizar.',
      holdExpires: 'Plazo para confirmar: {{date}}.',
      createdBy: 'Reservada por',
      updatedAt: 'Actualizada',
      case: 'Caso',
      openCase: 'Abrir caso',
      pricingSection: 'Precio',
      net: 'Neto',
      markup: 'Markup',
      commission: 'Comisión del proveedor',
      carPaymentBreakdown: 'Desglose del alquiler',
      providerTotal: 'Total del proveedor congelado al reservar',
      serviceBase: 'Base del servicio, sin cargos en mostrador',
      payment: {
        ppd: 'La base del servicio se cobra al reservar; los cargos señalados se pagan en mostrador.',
        pod: 'La tarifa completa se paga en mostrador.',
      },
      pickupCharge: 'En mostrador — {{name}}: {{amount}}',
      unnamedCharge: 'Cargo del proveedor',
      cancelBooking: 'Cancelar reserva',
      viewPolicy: 'Ver política de cancelación',
      operate: 'Operar reserva',
      itemNotLinked: 'Este item no tiene una reserva de servicios vinculada.',
    },
    updates: {
      viewBooking: 'Ver reserva',
      unavailable: 'La reserva no está disponible o no tenés acceso.',
      stateChanged: 'Reserva {{booking}}: {{state}}',
      ticketsReady: 'Reserva {{booking}}: tickets disponibles',
      holdExpiring: 'Reserva {{booking}}: vence el {{date}}. Revisá su estado',
    },
    bookingStates: {
      draft: 'Borrador',
      quoted: 'Cotizada',
      held: 'En hold',
      confirmed: 'Confirmada',
      cancelled: 'Cancelada',
      failed: 'Fallida',
      // `confirmed` + on-request: la reserva existe pero el operador todavia
      // no la acepto. Decir "Confirmada" seria mentirle al pasajero.
      onRequest: 'Pendiente del operador',
    },
    routeMap: {
      title: 'Recorrido',
      requestedPointsHint:
        'Los puntos son los del pedido; si el proveedor resolvió otro, vale la dirección de la oferta.',
      resolvedPointsHint:
        'Es el recorrido que confirmó el proveedor para esta oferta, no el del pedido.',
      alt: 'Mapa del recorrido',
      show: 'Ver recorrido',
      hide: 'Ocultar recorrido',
    },
    serviceMoments: {
      start: 'Inicio',
      end: 'Fin',
      requested: 'Dato solicitado',
    },
    booking: {
      ticketsExpired: 'Los documentos vencieron. Pedilos de nuevo para obtener links válidos.',
      ticketsExpireAt: 'Los links vencen el {{date}}. Pasado ese momento hay que volver a pedirlos.',
      ticketsRefresh: 'Volver a pedir',
      esimQrCopied: '¡Copiado!',
      esimCopyFailed:
        'No se pudo copiar automáticamente. Seleccioná el link y copialo a mano.',
      esimInstallation: 'Instalación manual de la eSIM',
      esimIccid: 'ICCID',
      esimSmdpAddress: 'Dirección SM-DP+',
      esimActivationCode: 'Código de activación',
      esimQrCodeData: 'Datos del QR',
      esimCopyValue: 'Copiar',
      ticketOpen: 'Abrir documento',
      ticketCodeHint: 'Este código se activa en la app del proveedor: no hay nada que descargar.',
      ticketKinds: {
        pdf: 'Documento PDF',
        checkin: 'Check-in online',
        collection: 'Retiro en mostrador',
        file: 'Documento',
        selfservice: 'Autogestión',
        barcode: 'Código de barras para el embarque',
        code: 'Código del pase',
      },
      ticketDirections: {
        outbound: 'Ida · {{document}}',
        return: 'Vuelta · {{document}}',
      },
      // Lo que pide el formulario sale de lo que declara la oferta: los rótulos
      // son de los CAMPOS, no de un vertical.
      phoneCountry: 'País',
      phonePlaceholder: 'Número sin el código de país',
      phonePickCountry: 'Elegí el código de país',
      phoneIncomplete: 'Número incompleto, o no válido para ese país',
      identityDocument: 'Documento de identidad',
      reselectIdentityDocument: 'El documento del perfil cambió. Volvé a seleccionarlo antes de reservar o guardar cambios.',
      chooseIdentityDocument: 'Elegí un documento',
      newIdentityDocument: 'Cargar {{type}}',
      paxFields: {
        type: 'Tipo de pasajero',
        title: 'Tratamiento',
        birthDate: 'Fecha de nacimiento',
        email: 'Email',
        phone: 'Teléfono',
        nationality: 'Nacionalidad',
        countryOfResidence: 'País de residencia',
        passportNumber: 'Pasaporte',
        passportExpiry: 'Vencimiento del pasaporte',
        flightNumber: 'Vuelo de llegada',
        returnFlightNumber: 'Vuelo de regreso',
        driverNotes: 'Comentarios al conductor',
      },
      // Placeholders de los campos que lo necesitan (el texto libre): dicen
      // QUÉ escribir, no repiten el rótulo.
      paxFieldPlaceholders: {
        driverNotes:
          'Puerta, timbre, punto exacto de encuentro, "no tocar bocina"…',
      },
      // El multilínea no recorta en el input (el proveedor responde 400 en vez
      // de truncar): el exceso se marca y lo acorta el asesor.
      paxFieldTooLong:
        'Máximo {{max}} caracteres (hay {{count}}). El proveedor no recorta: acortalo.',
      fieldScope: {
        contact: 'titular',
        all: 'todos los pasajeros',
      },
      // Los cuatro niveles con los que la autoridad declara un dato: qué decisión
      // condiciona cada uno. Van pegados al control que lo carga.
      fieldLevel: {
        hold: 'para reservar',
        quote: 'para cotizar',
        confirm: 'para confirmar',
        recommended: 'mejora la reserva',
      },
      requiredForQuote:
        'La sesión elegida requiere {{fields}} para obtener el precio final.',
      requiredForAll:
        'Este proveedor exige {{fields}} de TODOS los pasajeros.',
      requiredForContact: 'Del titular exige además {{fields}}.',
      recommendedFields:
        'Opcionales que el proveedor aprovecha si los cargás: {{fields}}.',
      confirmValidatedNotice:
        'El proveedor valida {{fields}} al confirmar, pero se envían al reservar. Completalos antes de crear el hold.',
      missingPassengerFields:
        'El proveedor rechazó la reserva porque faltan datos: {{fields}}. Completalos y volvé a reservar.',
      confirmBlockTitle: 'Esta reserva en hold no se puede confirmar',
      confirmBlockNotice:
        'El proveedor exigió datos de pasajeros que no publicó antes del hold. Los pasajeros no se pueden cambiar a través del contrato actual de la integración, por lo que volver a confirmar no puede reparar esta reserva.',
      confirmBlockField: '{{field}} — {{scope}}',
      confirmBlockChip: 'Confirmación bloqueada',
      confirmBlockListTooltip:
        'El proveedor pidió datos de pasajeros después del hold; volver a confirmar no puede reparar esta reserva.',
      confirmPendingSection: 'Falta para confirmar',
      confirmPendingNotice:
        'Los datos del pasajero viajan al proveedor solo al reservar: el confirmar únicamente lleva las respuestas al operador. Para cargarlos hay que cancelar esta reserva y volver a reservar.',
      passengers: 'Pasajeros',
      passenger: 'Pasajero',
      adult: 'Adulto',
      youth: 'Menor',
      child: 'Menor',
      infant: 'Infante',
      senior: 'Senior',
      firstName: 'Nombre',
      lastName: 'Apellido',
      addPassenger: 'Agregar pasajero',
      rosterHint: 'Elegí una persona del roster para cada lugar, o cargala manualmente.',
      manageRoster: 'Administrar viajeros',
      rosterLoading: 'Cargando viajeros del caso…',
      rosterLoadError: 'No se pudo cargar el roster. Lo escrito en la reserva se conserva.',
      rosterTraveler: 'Viajero del caso',
      rosterTravelerHint: 'Opcional: precarga sus datos canónicos.',
      rosterBirthDateMissing: 'Sin fecha de nacimiento',
      bookingContact: 'Contacto de la reserva',
      saveChangesToProfile: 'Guardar estos cambios en el perfil de {{traveler}}',
      saveTravelerToCase: 'Guardar a {{traveler}} como viajero de este caso',
      saveTravelerToCaseHint: 'Podrás reutilizar sus datos en próximas reservas.',
      travelersSavedToCase: 'Los viajeros seleccionados quedaron guardados en el caso.',
      travelerCreateError: 'No se pudo guardar a {{traveler}} en el caso. Los datos cargados se conservan.',
      profileUpdated: 'Perfil del viajero actualizado',
      profileUpdateError: 'No se pudo actualizar el perfil. La reserva conserva lo escrito.',
      selectedCaseSummary: 'Caso #{{case}} · Cliente: {{client}}',
      holderSection: 'Datos del titular de la reserva',
      holderContactSection: 'Porque es el titular de la reserva',
      driverContactSection: 'Porque conduce el auto',
      contactRow: 'Pasajero {{number}} · contacto',
      driverRow: 'Conductor',
      paxTypeWithAge: '{{type}} · {{age}}',
      partyFromSearch: 'De la búsqueda: {{party}}',
      partyFromQuote: 'De la cotización: {{party}}',
      partyChangeHint: 'para cambiarlo, volvé a buscar',
      partyGroup_adult_one: '1 adulto',
      partyGroup_adult_other: '{{count}} adultos',
      partyGroup_passenger_one: '1 pasajero',
      partyGroup_passenger_other: '{{count}} pasajeros',
      partyGroup_youth_one: '1 menor',
      partyGroup_youth_other: '{{count}} menores',
      partyGroup_child_one: '1 menor',
      partyGroup_child_other: '{{count}} menores',
      partyGroup_infant_one: '1 infante',
      partyGroup_infant_other: '{{count}} infantes',
      partyGroup_senior_one: '1 senior',
      partyGroup_senior_other: '{{count}} seniors',
      partyGroupWithAges: '{{group}} ({{ages}} años)',
      shapeContradiction:
        'El proveedor exige {{fields}}, que este pedido no tiene. Es una contradicción de su integración: no hay dónde cargarlo ni sentido en hacerlo. Si la reserva se rechaza por eso, hay que reclamarlo por su canal.',
      driverSection: 'Datos del conductor',
      refundPending:
        'El proveedor procesa el reintegro: el importe se confirma en su liquidación, no en esta pantalla.',
      refundDone: 'Reintegro confirmado: {{amount}}',
      refundError: 'El proveedor no pudo procesar el reintegro ({{amount}}): reclamarlo por su canal.',
      nationality: 'Nacionalidad',
      phone: 'Teléfono',
      birthDate: 'Fecha de nacimiento',
      providerHold: 'Crear la reserva en el proveedor (On Hold)',
      providerHoldTooltip:
        'A diferencia del resto de los proveedores, en autos el hold NO crea nada del otro lado por defecto: solo congela el precio de esta cotización acá. Activá esto para que la rentadora cree la reserva "On Hold" (sin cargo, con la tarifa retenida), como pasa en los demás productos; después se confirma o se cancela.',
      offerOptionsUnavailable:
        'No se pudieron cargar las opciones del proveedor: se reserva igual y él asigna lo que incluye la tarifa.',
      flightsSection: 'Horarios y vuelos',
      outbound: 'Ida',
      return: 'Vuelta',
      paxNumber: 'Pasajero {{number}}',
      requoteHint: 'Cambiaste un horario: actualizá el precio antes de reservar.',
      arrivalFlight: 'Vuelo de llegada',
      returnFlight: 'Vuelo de regreso',
      requote: 'Actualizar precio',
      requoteNotFound:
        'No se encontró una oferta equivalente (mismo proveedor y producto) al re-cotizar. Los resultados ya muestran la búsqueda nueva: elegí una oferta de la lista.',
      requoteAmbiguous:
        'La re-cotización trajo varias ofertas indistinguibles de esta (mismo proveedor y producto). Para no reservar otra, elegí la correcta de la lista, que ya muestra la búsqueda nueva.',
      fixedPax:
        'Los pasajeros corresponden a la búsqueda ({{count}}). Para cambiar la cantidad, volvé a buscar.',
      hold: 'Reservar (hold)',
      confirm: 'Confirmar reserva',
      cancelHold: 'Cancelar hold',
      cancelBooking: 'Cancelar reserva',
      sync: 'Sincronizar',
      getTickets: 'Ver tickets',
      close: 'Cerrar',
      holdRetention: {
        none: 'Hold local: el proveedor no retiene cupo ni tarifa. Confirmá dentro del plazo publicado.',
        provider: 'El proveedor mantiene una reserva temporal hasta el vencimiento publicado.',
        'provider-expiry-unpublished': 'El proveedor mantiene una reserva temporal, pero no publica su vencimiento.',
        unknown: 'Pendiente de confirmación. El proveedor no especifica si retiene cupo.',
      },
      holdRateExpired: 'Venció el plazo para confirmar. Obtené una cotización nueva; esta tarifa no puede volver a confirmarse.',
      holdTooltip:
        'Pendiente de confirmación. Revisá las condiciones de retención y el plazo para confirmar.',
      questionsTitle: 'El operador pregunta',
      questionsNotice:
        'Las respuestas viajan con la confirmación; las obligatorias la bloquean hasta responderlas. Ninguna se completa sola: una respuesta inventada confirmaría la reserva con un dato equivocado.',
      questionForPassenger: 'Pasajero {{number}}',
      questionForPassengerNamed: 'Pasajero {{number}} · {{name}}',
      questionYes: 'Sí',
      questionNo: 'No',
      questionMandatory: 'obligatoria',
      questionAnswer: 'Respuesta',
      questionsOmitted_one:
        'La confirmación admite {{max}} respuestas: 1 de las opcionales que respondiste no va a viajar.',
      questionsOmitted_other:
        'La confirmación admite {{max}} respuestas: {{count}} de las opcionales que respondiste no van a viajar.',
      questionFormat: 'Formato que espera el operador: {{format}}',
      confirmTooltip:
        'Confirma la reserva con el proveedor: genera obligación de pago, salvo cancelación de acuerdo a su política de cancelación.',
      cancelHoldTooltip:
        'Libera el hold sin costo. Ojo: algunos proveedores no permiten cancelarlo (expira solo al vencimiento).',
      flightNumber: 'Vuelo',
      passport: 'Pasaporte/DNI',
      tickets: 'Tickets',
      ticketsNotReady: 'Los tickets todavía no están listos: reintentá en unos minutos.',
      ticketsPolling:
        'Los tickets todavía no están listos. Los estamos consultando automáticamente.',
      ticketsPollingStopped:
        'Los tickets todavía no están listos. Podés volver a pedirlos cuando quieras.',
      ticketsNotSupported: 'Este proveedor no expone tickets por API.',
      pendingVerification:
        'La reserva quedó pendiente de verificación con el proveedor. Sincronizar puede recuperarla usando su id de Rutero; no vuelvas a intentar el hold.',
      pendingChip: 'Pendiente de verificación',
      manualChip: 'Conciliación manual',
      manualNotice:
        'El proveedor puede haber creado una reserva. La sincronización automática no puede resolverla porque no hay un id de Rutero. No crees otra reserva hasta resolver esta ambigüedad.',
      sameAttemptRetryChip: 'Reintentar intento original',
      sameAttemptRetryNotice:
        'Hay un hold equivalente sin resolver. Reintentá para retomar el intento y la clave de idempotencia originales; no crees un intento nuevo.',
      existingAttemptNotice:
        'Ya se está procesando un intento de hold equivalente. El intento original conserva la autoridad.',
      verifiedBookingId: 'Id de reserva Rutero verificado',
      attachVerifiedBookingId: 'Adjuntar id verificado',
      markNoRemoteBooking: 'No existe reserva remota',
      confirmNoRemoteTitle: 'Confirmar que no existe reserva remota',
      confirmNoRemoteNotice:
        'Continuá solo después de verificar externamente que el proveedor no creó una reserva. Esto cierra el intento incierto original y no se revierte automáticamente.',
      keepManual: 'Mantener pendiente',
      confirmNoRemote: 'Confirmar que no existe',
      manualAttachError: 'No se pudo adjuntar el id verificado',
      manualNoRemoteError: 'No se pudo resolver la reserva como no creada',
      // Cuando algo sale raro: cada estado del hold con SU cara y SU acción. El
      // vocabulario es el del asesor, no el del sistema — el código técnico va
      // aparte, chiquito, para soporte.
      recovery: {
        transportAmbiguous: {
          title: '🔌 No sabemos si llegó',
          body: 'Se cortó la conexión al enviar la reserva: puede haberse creado o no. Reintentar es seguro — se reenvía con la misma clave y el proveedor no la duplica.',
          cta: 'Reintentar (seguro)',
          noResend:
            'Desde acá ya no se puede reenviar este intento. Verificá con el proveedor si la reserva existe antes de reservar de nuevo.',
        },
        unknownStateSync: {
          title: '🔄 Pendiente de conciliación',
          body: 'No sabemos si el proveedor completó la operación. Sincronizá para consultar su estado; la consulta puede seguir sin resultado. No crees otra reserva ni repitas la confirmación o cancelación mientras siga pendiente.',
          cta: 'Sincronizar ahora',
        },
        manual: {
          title: '🧑‍💼 Necesita un ojo humano',
          body: 'El proveedor respondió raro y no tenemos referencia para verificar solos. No reintentes: revisá en el extranet del proveedor si la reserva existe.',
          cta: 'Ya verifiqué — resolver',
        },
        providerReference: 'Localizador del proveedor: {{reference}}',
        trackingId: 'ID de seguimiento: {{id}}',
        adoptionPending: {
          title: '⏳ Reservada, cerrando números',
          body: 'La reserva está creada; falta congelar el registro comercial (precio, markup, comisión). Se completa solo — no se puede confirmar hasta que cierre.',
          cta: 'Actualizar estado',
        },
        // Los rechazos LIMPIOS: el hub contestó, no quedó nada vivo del otro
        // lado y la única salida honesta es volver a buscar.
        terminal: {
          provenanceExpired: 'La oferta ya no está vigente',
          selectionChanged: 'El proveedor cambió la tarifa seleccionada',
          offerExpired: 'La oferta venció según el proveedor',
          railPassengerCompositionMismatch:
            'Los pasajeros no coinciden con la cotización',
          railPlacePropertyRequired: 'Esta tarifa exige elegir una plaza',
          railPlacePropertyRequiredBody:
            'Bandido todavía no permite elegir esa plaza. El hold temporal del proveedor vence automáticamente; volvé a buscar después de su vencimiento para intentar otra reserva.',
          providerTemporaryHoldExpiresAt:
            'El hold temporal del proveedor vence: {{date}}',
          offerExpiredHint:
            'El vencimiento lo firma el proveedor en cada cotización. Re-cotizá el mismo traslado para obtener una oferta vigente sin perder lo cargado.',
          providerPolicy: 'El operador no acepta esta reserva',
          cleanFailed: 'No se pudo reservar esta oferta',
          correctRequest:
            'La oferta sigue vigente: corregí lo que indica el proveedor —acá abajo— y volvé a reservar. Mandar el mismo pedido no cambia nada.',
          noProviderMessage: 'El proveedor no dio un motivo.',
          requote: 'Re-cotizar esta oferta',
          searchAgain: 'Buscar de nuevo',
        },
      },
      activeOperation: {
        confirm: {
          in_progress: 'Confirmación en proceso',
          ambiguous: 'Confirmación en verificación',
          reconciling: 'Confirmación conciliando datos locales',
          stalled:
            'Confirmación sin resolver: el sistema dejó de reintentar. Puede haber una reserva viva en el proveedor — verificá con el proveedor antes de operar.',
        },
        cancel: {
          in_progress: 'Cancelación en proceso',
          ambiguous: 'Cancelación en verificación',
          reconciling: 'Cancelación conciliando datos locales',
          stalled:
            'Cancelación sin resolver: el sistema dejó de reintentar. La reserva puede seguir viva en el proveedor — verificá con el proveedor antes de operar.',
        },
      },
      fareValidFor: 'Tarifa vigente {{time}}',
      fareExpired: 'Tarifa vencida',
      fareTtlHint: 'El proveedor congela el precio 15 minutos desde la búsqueda. Si vence, hay que volver a buscar.',
      fareExpiredHint: 'Pasaron los 15 minutos desde la búsqueda: volvé a buscar para cotizar de nuevo.',
      // Cuando el corte lo fija el vencimiento FIRMADO por el proveedor en la
      // oferta (no el TTL local): el plazo es de él, no nuestro.
      fareSignedTtlHint: 'El proveedor firmó hasta cuándo vale esta cotización. Si vence, hay que volver a cotizar.',
      fareSignedExpiredHint: 'La cotización venció según el vencimiento que firmó el proveedor: volvé a cotizar para obtener una oferta vigente.',
      perPassengerTimes: '{{price}} × {{count}} pasajeros',
      // El precio de cada momento: qué es el número de la barra y, si el
      // proveedor lo movió al reservar, con qué desglose lo explica.
      priceEstimated: 'Estimado — el precio final llega al reservar',
      providerFrozenPrice: 'Precio del proveedor, congelado',
      providerFrozenPriceAmount: 'Precio del proveedor, congelado: {{price}}',
      reprice: {
        title: 'El proveedor ajustó el precio al reservar',
        breakdown: 'Desglose del proveedor: {{lines}} · congelado {{total}}',
      },
      includesOptions: 'Incluye {{price}} de opciones',
      includesNamedOptions: 'Incluye {{options}}: {{price}}',
      discountsOptions: 'Descuenta {{price}} por las opciones elegidas',
      selectionRejected: {
        UNCOVERED_PASSENGERS_one: 'El operador rechaza esta selección: falta cubrir {{count}} pasajero.',
        UNCOVERED_PASSENGERS_other: 'El operador rechaza esta selección: faltan cubrir {{count}} pasajeros.',
        UNCOVERED_PASSENGERS_UNKNOWN: 'El operador rechaza esta selección: no cubre a todos los pasajeros.',
        BELOW_MINIMUM_OCCUPANCY: 'El operador rechaza esta selección: una de las plazas exige más ocupantes que los pasajeros del viaje.',
        PROVIDER_RULE: 'El operador rechaza esta selección.',
      },
      willReserve: 'Quedaría reservado: {{options}}',
      quotingSelection: 'Cotizando la selección con el operador…',
      basePriceWithUnquotedOptions:
        'Precio base — este importe no incluye los adicionales seleccionados. El total se valida al crear el hold, antes de confirmar.',
      selectionNotQuoted:
        'No se pudo cotizar la selección: el total de arriba es el de la oferta sin opciones; el precio firme se calcula al reservar.',
      provenanceExpired: 'La oferta expiró (15 min). Volvé a buscar para obtener precio vigente.',
      offerExpiredByProvider:
        'La oferta venció según el vencimiento que firmó el proveedor. Volvé a buscar para obtener precio vigente.',
      searchChanged: 'La búsqueda cambió. Seleccioná una oferta vigente de los resultados actuales.',
      caseLabel: 'Caso de esta reserva',
      caseHint: 'Buscá por número, asunto o cliente.',
      caseNumber: 'Caso #{{id}}',
      caseNoOptions: 'No hay casos con cliente para esta búsqueda.',
      caseLoadError: 'No se pudieron cargar los casos. Probá de nuevo.',
      createCase: 'Crear caso',
      createCaseTitle: 'Crear caso para esta reserva',
      createCaseSubject: 'Asunto del caso',
      createCaseClient: 'Cliente obligatorio',
      selectClient: 'Elegir cliente',
      holdError: 'No se pudo crear la reserva',
      confirmError: 'No se pudo confirmar la reserva',
      cancelError: 'No se pudo cancelar la reserva',
      syncError: 'No se pudo sincronizar la reserva',
      syncSuccess: 'Reserva sincronizada',
      // El momento de la reserva y su barra de decisión: qué se está
      // decidiendo, con qué precio, hasta cuándo y qué falta para decidirlo.
      moments: {
        review: 'Revisar',
      },
      viaHub: '{{provider}} · vía Rutero',
      providerReference: 'Ref: {{reference}}',
      tripSection: 'Datos del viaje',
      // Los adicionales que publica la OFERTA: se eligen acá (cantidad y
      // tramo) y se reservan en el MISMO hold. El total con adicionales lo
      // devuelve el hub; la sección no suma plata.
      optionalItems: {
        section: 'El proveedor ofrece',
        perBooking: 'por reserva',
        perPerson: 'por pasajero',
        maxAllowed: 'Acepta hasta {{max}}',
        unknownRejected:
          'La oferta ya no ofrece: {{names}}. Corregí la selección y volvé a reservar.',
        limitRejected:
          'El operador acepta menos unidades de un adicional que las pedidas',
      },
      confirmedOptionalItems: {
        title: 'Adicionales de la confirmación original',
        providerAdded: 'Incluido por el operador',
        free: 'Sin costo',
      },
      conditionsSection: 'Condiciones',
      cancellationPolicySection: 'Política de cancelación antes de confirmar',
      showConditions_one: 'Ver {{count}} condición',
      showConditions_other: 'Ver {{count}} condiciones',
      hideConditions: 'Ocultar condiciones',
      documentsSection: 'Documentos del viaje',
      voucher: {
        title: 'Voucher de agencia',
        kind: {
          voucher: 'Voucher de agencia',
          receipt: 'Comprobante de agencia',
          confirmation: 'Confirmación de agencia',
        },
        generate: {
          voucher: 'Generar voucher',
          receipt: 'Generar comprobante',
          confirmation: 'Generar confirmación',
        },
        regenerate: 'Regenerar',
        view: 'Ver',
        download: 'Descargar',
        generatedAt: 'PDF · generado el {{date}}',
        generating: 'Generando el documento… puede tardar unos segundos.',
        ready: 'El voucher está listo.',
        stillGenerating: 'La generación está tardando más de lo normal. Volvé a abrir la reserva en un rato.',
        requestFailed: 'No se pudo pedir el voucher.',
        fileUnavailable: 'El archivo ya no está disponible. Volvé a generarlo.',
        fileFailed: 'No se pudo bajar el archivo. Probá de nuevo.',
        stateUnavailable: 'No se pudo leer el estado del voucher.',
        stale: 'La reserva cambió el {{date}}: el documento que tenés ya no coincide.',
        unsupported: 'Todavía no hay voucher para {{vertical}}.',
        alternative: {
          circuits: 'El itinerario se imprime desde el producto.',
        },
        attachedReferences: 'El ticket del operador va aparte: {{references}}. Se descarga desde "Ver tickets".',
        providerDocument: {
          embedded: 'Incluye el ticket del operador en las páginas siguientes.',
          printed: 'El documento incluye los datos o instrucciones del operador. Un enlace de autoservicio no equivale al ticket incorporado.',
          attached: 'El ticket del operador va aparte, en su archivo original.',
        },
        send: {
          button: 'Enviar…',
          email: 'Por mail al contacto de la reserva',
          link: 'Copiar link (vence en 7 días)',
          requestFailed: 'No se pudo enviar el voucher.',
          requestUnanswered:
            'El servidor no contestó a tiempo. El envío puede estar saliendo: no lo repitas todavía; el estado de acá abajo dice cómo terminó. Si volvés a tocar "Enviar", se consulta ese mismo intento en vez de mandar otro mail.',
          sent: {
            pending: 'El envío sigue en curso: el estado de acá abajo se actualiza solo. Si volvés a tocar "Enviar", se consulta este mismo intento, no se manda otro mail.',
            resolved: 'Voucher enviado a {{recipient}}.',
            partial: 'Enviado a {{recipient}}, pero SIN el ticket del operador: va aparte, mandalo desde "Ver tickets".',
            no_email: 'La reserva no tiene mail del contacto. Cargalo en los datos del pasajero y volvé a enviar.',
            failed: 'El proveedor de mail lo rechazó: no salió. Quedó registrado; probá de nuevo más tarde y, si sigue, avisá a soporte.',
            uncertain:
              'No se sabe si salió: el mail a {{recipient}} se entregó al proveedor pero la conexión se cortó antes de la respuesta. Confirmá con el contacto antes de reenviarlo.',
          },
          copied: 'Link copiado. Vence en 7 días.',
          copiedPartial: 'Link copiado, vence en 7 días. OJO: no incluye el ticket del operador, que va aparte.',
          copyFailed: 'No se pudo copiar solo: copiá el link del campo de abajo.',
          linkField: 'Link para compartir',
          linkHint: 'Vence en 7 días y deja de servir si el voucher se regenera.',
          last: {
            pending: 'Envío en curso desde el {{date}}: todavía sin respuesta del proveedor de mail.',
            resolved: 'Enviado a {{recipient}} el {{date}}.',
            partial: 'Enviado a {{recipient}} el {{date}}, sin el ticket del operador (va aparte).',
            no_email: 'Último intento el {{date}}: la reserva no tenía mail del contacto.',
            failed: 'Último intento el {{date}}: el proveedor de mail rechazó el envío a {{recipient}}.',
            uncertain:
              'Último intento el {{date}}: el mail a {{recipient}} quedó sin confirmar (pudo haber salido).',
            link: 'Link para compartir emitido el {{date}}.',
            linkPartial: 'Link para compartir emitido el {{date}}, sin el ticket del operador (va aparte).',
            linkUnconfirmed:
              'Se pidió un link para compartir el {{date}} y no quedó confirmado que se haya emitido. Si lo necesitás, copiá uno nuevo.',
          },
        },
        row: {
          ready: 'Voucher listo',
          stale: 'Voucher desactualizado',
          pending: 'Voucher por generar',
        },
        reasons: {
          agency_brand_missing: 'La agencia todavía no cargó su logo. Se configura en Vouchers.',
          provider_reference_missing: 'La reserva no tiene referencia del proveedor.',
          service_date_missing: 'Falta la fecha del servicio.',
          provider_created_at_missing: 'Falta la fecha de la reserva del proveedor; llega con la próxima sincronización.',
          service_end_missing: 'Falta la fecha de devolución, que el documento de alquiler necesita.',
          holder_missing: 'La reserva no tiene titular.',
          service_detail_missing: 'Falta el detalle del servicio que el documento imprime.',
          booking_not_confirmed: 'La reserva todavía no está confirmada.',
          booking_outcome_unresolved: 'El último cambio de la reserva no está resuelto con el proveedor. Se resuelve con la recuperación o la próxima sincronización.',
          provider_tickets_pending: 'El proveedor todavía no emitió el código o el QR; llega con la próxima sincronización.',
        },
      },
      recordSection: 'Registro',
      holdExpiresIn: 'Vence en {{time}}',
      holdExpired: 'El hold venció',
      instantConfirmation: 'Confirmación inmediata',
      onRequestConfirmation: 'El operador debe aceptar la reserva',
      freeCancellationUntil: 'Cancelación gratis hasta {{date}}',
      // Un CTA deshabilitado SIEMPRE dice por qué, al lado del botón.
      blockedForHold: 'Para reservar: {{reasons}}',
      blockedForConfirm: 'Para confirmar: {{reasons}}',
      blocked: {
        case: 'elegí el caso del cliente',
        passengers: 'completá los datos que el proveedor exige de los pasajeros',
        passengerFields: 'completá los datos requeridos: {{fields}}',
        incompleteTrip:
          'esta tarifa no contiene los tramos de ida y vuelta que exige el pedido',
        fieldTooLong:
          'acortá {{fields}}: supera el largo máximo que acepta el proveedor, y no se recorta solo',
        shapeContradiction:
          'el proveedor exige {{fields}} y este pedido no puede tenerlos: no hay dónde cargarlos, y los datos del pasajero solo viajan al reservar, así que la reserva no podría completarse. Hay que reclamarlo por su canal',
        options: 'revisá las opciones seleccionadas',
        luggageQuote: 'completá el equipaje y esperá una cotización válida de equipaje y precio',
        requote: 'actualizá el precio con el horario nuevo',
        requoting: 'esperá a que termine la re-cotización',
        loadingOptions: 'esperá a que carguen las opciones del proveedor',
        questions: 'respondé las preguntas obligatorias del operador',
        answersOverflow:
          'el operador publicó más preguntas obligatorias de las que su confirmación admite responder: esta reserva no se puede confirmar desde acá, hay que resolverla con el operador',
        confirmPassengers:
          'el proveedor valida estos datos al confirmar y faltan: {{fields}}',
        requestRefused:
          'corregí lo que el operador rechazó (el motivo está arriba): el mismo pedido vuelve a salir rechazado',
      },
      expiresAt: 'El hold vence: {{date}}',
      // Cerrar el modal con la reserva retenida: se pregunta una vez, y sin
      // vencimiento publicado no se inventa una hora.
      closeHeld: {
        title: 'La reserva sigue retenida',
        question: 'La reserva sigue retenida hasta {{time}}. ¿Cerrar igual?',
        questionNoExpiry:
          'La reserva sigue retenida y todavía no está confirmada. ¿Cerrar igual?',
        keep: 'Seguir acá',
        closeAnyway: 'Cerrar igual',
      },
    },
    tours: {
      session: 'Sesión',
      pickup: 'Punto de recogida',
      ticketQuantities: 'Entradas',
      ticketQuantitiesRequired:
        'Elegí las cantidades exactas publicadas para esta sesión.',
      ticketQuantitiesUnavailable:
        'Esta sesión exige cantidades de entradas, pero no hay opciones disponibles.',
      noSessions: 'No hay sesiones disponibles para esta oferta.',
      selectionUnavailable: 'La sesión elegida ya no está disponible. Elegí otra.',
      discover: 'Ver opciones',
      priceAfterSession: 'Precio al elegir sesión',
      priceOnRequest: 'Precio disponible al consultar',
      viewExperience: 'Ver experiencia',
      freeCancellation: 'Cancelación gratuita',
      noFreeCancellation: 'Sin cancelación gratuita',
      instantConfirmation: 'Confirmación inmediata',
      noInstantConfirmation: 'La confirmación no es inmediata',
      mobileVoucher: 'Voucher móvil',
      noMobileVoucher: 'No acepta voucher móvil',
      productDetail: 'Detalle de la experiencia',
      detailUnavailable:
        'No pudimos cargar la información ampliada. Podés consultar disponibilidad con los datos publicados en la búsqueda.',
      description: 'Descripción',
      highlights: 'Destacados',
      routes: 'Itinerario',
      modalities: 'Modalidades disponibles',
      location: 'Ubicación',
      conditions: 'Condiciones',
      refundPolicies: 'Política de devolución',
      nonRefundable: 'El proveedor declara esta opción como no reembolsable.',
      included: 'Incluye',
      notIncluded: 'No incluye',
      meetingPoint: 'Punto de encuentro',
      remarks: 'Información importante',
      availability: 'Disponibilidad',
      chooseExperience: 'Elegí tu experiencia',
      loadingOptions: 'Cargando fechas y opciones…',
      optionsUnavailable: 'No pudimos cargar las opciones de este producto.',
      retryOptions: 'Reintentar',
      continueToQuote: 'Continuar y cotizar',
      selectPickup: 'Elegí un punto de recogida para ver las sesiones.',
      selectSession: 'Elegí una sesión explícitamente para continuar.',
      availabilityStatus: {
        schedule: 'Programación publicada',
        live: 'Disponibilidad en vivo',
      },
      pricingStatus: {
        unpriced: 'Precio pendiente de cotización',
        indicative: 'Precio indicativo',
        authoritative: 'Precio autoritativo',
      },
      quoteRequirements: {
        ages: 'Requiere edades reales para cotizar',
        ticket_quantities: 'Requiere cantidades de entradas',
      },
      checkAvailability: 'Consultar disponibilidad',
      quoteBeforeHold:
        'La sesión y el precio final se verifican antes de reservar.',
      passengerAgesForQuote: 'Pasajeros de esta cotización',
      passengerAgesForQuoteHint:
        'Ingresá una sola vez la fecha de nacimiento de cada pasajero. Calculamos la edad a la fecha de la actividad y reutilizamos el dato al reservar.',
      passengerAgesWithoutDateHint:
        'El proveedor no informó la fecha de esta sesión, por lo que no podemos calcular la edad desde la fecha de nacimiento. Ingresá la edad cumplida de cada pasajero para cotizar.',
      passengerAge: 'Edad participante {{number}}',
      passengerAgeInvalid: 'Ingresá una edad entera entre 0 y 120.',
      quoteInputRequired:
        'Falta completar la composición no personal que esta sesión exige para cotizar.',
      quoteMustRefresh:
        'La cotización ya no coincide con la selección o los pasajeros. Revisá las edades y cotizá nuevamente.',
      quoteValidUntil: 'Precio vigente hasta {{date}}',
      continueWithPassengers: 'Continuar con pasajeros',
      blockedForQuote: 'Para continuar: {{reasons}}',
      quotedSelection: 'Disponibilidad y precio verificados',
      changeAvailability: 'Cambiar disponibilidad',
      birthDateQuoteMismatch:
        'Una fecha de nacimiento completa no coincide con la edad usada para cotizar. Para reservar hay que actualizar el precio con la edad correcta.',
      requoteCorrectedAges: 'Recotizar edades',
      providerFilter: 'Proveedor',
      categoryFilter: 'Categoría',
      languageFilter: 'Idioma',
      sortRelevance: 'Relevancia',
      sortTitle: 'Nombre',
      sortPrice: 'Precio',
      mixedCurrencies:
        'Los resultados tienen monedas distintas. Se conserva el orden de relevancia para no comparar importes incomparables.',
      productsShown_one: '{{count}} de {{total}} experiencia',
      productsShown_other: '{{count}} de {{total}} experiencias',
      noFilteredProducts: 'No hay experiencias que coincidan con estos filtros.',
      free: 'Sin costo',
      from: 'Desde',
      to: 'Hasta',
      destination: 'Destino',
      typeToSearch: 'Escribí al menos 3 letras',
      noDestinations: 'Sin destinos con ese nombre',
      productsFound_one: '{{count}} experiencia',
      productsFound_other: '{{count}} experiencias',
      departuresCount_one: '{{count}} salida',
      departuresCount_other: '{{count}} salidas',
      pickDeparture: 'Elegí la fecha de salida',
      ageBand: 'Edad {{band}}',
      fare: 'Tarifa',
      perPassenger: 'por pasajero',
      perGroup: 'por grupo o servicio',
      perPassengerHint: 'Los precios son por pasajero de cada franja de edad, no del grupo.',
      adultOnlyBookingUnavailable:
        'Solo cotización: esta tarifa no es compatible con la reserva actual para adultos.',
      // Versión corta para pegar al lado del botón de la fila; la larga
      // queda como tooltip, donde sí entra.
      adultOnlyShort: 'No aplica a esta reserva',
      showMore: 'Ver más',
      showLess: 'Ver menos',
    },
    transfers: {
      onRequest: 'El operador debe aceptar la reserva',
      pickUpAt: 'Recogida {{time}}',
      // La hora que el PROVEEDOR resolvió, contra la que se pidió: con
      // hotelbeds e ineedtours la pedida es la del vuelo y ellos calculan la
      // recogida hacia atrás (medido: hasta 4 h antes).
      pickUpAtDiffers: 'Recogida {{time}} (pediste {{requested}})',
      pickUpReconfirm: 'Hora de recogida pendiente',
      // La antelación y el link son el AVISO operativo que el contrato manda
      // mostrar: sin ellos el asesor no sabe cuándo ni dónde reconfirmar.
      pickUpReconfirmWithin: 'Consultá la hora de recogida {{hours}} h antes',
      pickUpLegReconfirmWithin: '{{leg}}: consultá la hora de recogida {{hours}} h antes',
      pickUpReconfirmLink: 'Consultar horario de recogida',
      pickUpLeg: '{{leg}}: recogida {{time}}',
      pickUpLegDiffers: '{{leg}}: recogida {{time}} (pediste {{requested}})',
      pickUpLegReconfirm: '{{leg}}: hora de recogida pendiente',
      showConditions_one: 'Ver {{count}} condición',
      showConditions_other: 'Ver {{count}} condiciones',
      hideConditions: 'Ocultar condiciones',
      meetingPoint: 'Punto de encuentro e instrucciones',
      showMeetingPoints: 'Ver punto de encuentro e instrucciones',
      hideMeetingPoints: 'Ocultar punto de encuentro e instrucciones',
      operatingHours: 'Horario operativo del servicio',
      allDay: '24 horas',
      days: {
        monday: 'lun',
        tuesday: 'mar',
        wednesday: 'mié',
        thursday: 'jue',
        friday: 'vie',
        saturday: 'sáb',
        sunday: 'dom',
      },
      providerFilter: 'Proveedor',
      categoryFilter: 'Vehículo',
      capacityFilter: 'Pasajeros',
      conditionsFilter: 'Condiciones',
      freeCancellationFilter: 'Cancelación gratis',
      sortCapacity: 'Capacidad',
      found_one: '{{count}} de {{total}} traslado',
      found_other: '{{count}} de {{total}} traslados',
      capacity_one: 'Hasta {{count}} pasajero',
      capacity_other: 'Hasta {{count}} pasajeros',
      luggage_one: '{{count}} valija',
      luggage_other: '{{count}} valijas',
      waiting_one: '{{count}} min de espera incluido',
      waiting_other: '{{count}} min de espera incluidos',
      instant: 'Confirmación inmediata',
      freeCancellation: 'Cancelación gratis hasta el {{date}}',
      perPassenger: '{{price}} por pasajero',
      requestedRouteHint: 'Puntos solicitados: el proveedor no confirmó ambos extremos.',
      resolvedRouteWithoutLabelsHint:
        'El proveedor confirmó las ubicaciones, pero no publicó sus nombres; se muestran los puntos solicitados.',
      resolvedRoute: 'Dirección confirmada por el proveedor: {{from}} → {{to}}',
      resolvedPointHint:
        'El proveedor resolvió el punto a la dirección que figura arriba: confirmala con el pasajero antes de reservar.',
      notAvailable: 'No disponible',
      incompleteRoundTrip: {
        'outbound-only':
          'Esta tarifa cubre solamente la ida; no puede reservarse como ida y vuelta.',
        'return-only':
          'Esta tarifa cubre solamente la vuelta; no puede reservarse como ida y vuelta.',
        missing:
          'La oferta no identifica ambos tramos; no puede reservarse como ida y vuelta.',
      },
      incompleteRoundTripModal: {
        'outbound-only':
          'No podemos confirmar esta opción como ida y vuelta: la oferta contiene solamente la ida. Elegí otra tarifa o buscá dos traslados por separado.',
        'return-only':
          'No podemos confirmar esta opción como ida y vuelta: la oferta contiene solamente la vuelta. Elegí otra tarifa o buscá dos traslados por separado.',
        missing:
          'No podemos confirmar esta opción como ida y vuelta porque la oferta no identifica ambos tramos. Elegí otra tarifa o buscá dos traslados por separado.',
      },
      whenAndWho: 'Cuándo y quiénes',
      tripType: 'Tipo de viaje',
      swap: 'Invertir origen y destino',
      swapWhileResolving:
        'Esperá a que termine de resolverse la dirección para invertir origen y destino.',
      oneWay: 'Solo ida',
      roundTrip: 'Ida y vuelta',
      date: 'Fecha',
      endDate: 'Fecha de vuelta',
      dateInPast: 'Esa fecha ya pasó: elegí hoy o una posterior.',
      returnBeforePickup: 'La vuelta no puede ser anterior a la ida.',
      summaryFlightTime: 'vuelo {{time}} hs',
      summaryServiceTime: 'servicio {{time}} hs',
      summaryFlightNumber: 'Vuelo {{flight}}',
      summaryFrom: 'Desde',
      summaryTo: 'Hasta',
      providerResolvedRoute: 'Recorrido resuelto por el proveedor',
      luggage: {
        change: 'Cambiar equipaje',
        pricedSelection: 'Total cotizado con el equipaje y los adicionales seleccionados.',
        recoveryLocked: 'El equipaje queda fijado mientras se resuelve el intento de reserva. Reintentar conserva las cantidades del envío original.',
        confirmed: 'Equipaje confirmado del grupo',
        pieces: 'Capacidad utilizada: {{pieces}} piezas',
        capacity: 'Capacidad utilizada: {{pieces}} de {{capacity}} piezas',
        verified: 'Equipaje y precio verificados por el proveedor',
        expires: 'Cotización válida hasta {{date}}',
        freshOptions: 'Adicionales publicados en esta cotización (importes del proveedor). La selección se realiza en la sección de adicionales.',
        quoting: 'Verificando equipaje, vehículo y precio…',
        unavailable: 'Completá el equipaje y obtené una cotización vigente antes de reservar. Si la verificación falló o venció, reintentá o volvé a buscar.',
        rejected: 'El proveedor rechazó esta selección. Modificá el equipaje o los adicionales, o volvé a los resultados.',
        retry: 'Volver a cotizar',
        label: 'Equipaje total del grupo',
        later: 'Lo definiré después',
        none: 'Sin equipaje',
        specified: 'Indicar equipaje',
        checked: 'Valijas despachadas',
        carryOn: 'Equipaje de mano',
        invalid: 'Ingresá un entero desde 0.',
        increase: 'Aumentar {{label}}',
        decrease: 'Disminuir {{label}}',
        requested: 'Equipaje informado para el grupo',
        summary: '{{checked}} despachadas · {{carryOn}} de mano',
      },
      // El contrato define estos campos como "la hora conocida en cada punta".
      // Con un aeropuerto en la ruta esa hora es la del VUELO; en un traslado
      // hotel–hotel no hay vuelo y pedirlo sería pedir un dato inexistente.
      originTime: 'Hora del servicio (ida)',
      destinationTime: 'Hora del servicio (vuelta)',
      originTimeFlight: 'Hora del vuelo (ida)',
      destinationTimeFlight: 'Hora del vuelo (vuelta)',
      flightTimeHint:
        'Con un aeropuerto en la ruta, cargá la hora del vuelo: la de llegada si el traslado sale del aeropuerto, la de salida si va hacia él. Sin aeropuerto, es la hora del servicio en esa punta. En los dos casos, la hora de recogida la calcula el proveedor y la muestra cada oferta.',
      adults: 'Adultos',
      origin: 'Origen',
      destination: 'Destino',
      pointType: 'Tipo de punto',
      pointMode: 'Ubicar por',
      iataPoint: 'Punto IATA',
      placePoint: 'Lugar',
      pointSearch: 'Aeropuerto, hotel o dirección',
      pointPlaceholder: 'Escribí un aeropuerto, un hotel o una dirección…',
      pointNotice: {
        noSources:
          'No se pueden buscar puntos ahora. Cargá el punto a mano para seguir.',
        placesDisabled:
          'Sin proveedores de traslados configurados: solo se pueden buscar hoteles y direcciones.',
        placesError:
          'No se pudieron buscar aeropuertos, estaciones ni puertos. Podés buscar un hotel o una dirección.',
        addressesNotEnabled:
          'La búsqueda de hoteles y direcciones no está disponible ahora: solo aparecen aeropuertos, estaciones y puertos.',
        addressesBudgetExceeded:
          'Se alcanzó el límite de búsquedas de direcciones por hoy: solo aparecen aeropuertos, estaciones y puertos.',
        addressesError:
          'No se pudieron buscar hoteles ni direcciones. Elegí un aeropuerto, una estación o un puerto, o cargá el punto a mano.',
      },
      coordinates: 'Coordenadas',
      airport: 'Aeropuerto',
      hotel: 'Hotel',
      station: 'Estación',
      port: 'Puerto',
      name: 'Nombre',
      address: 'Dirección',
      town: 'Ciudad de la dirección',
      country: 'País de la dirección',
      zip: 'Código postal',
      postalAddressHint: 'Completá ciudad, país y código postal: algunos proveedores los exigen para reservar este punto.',
      geocode: {
        resolving: 'Resolviendo dirección…',
        resolveError: 'No se pudo resolver esa dirección. Probá de nuevo.',
        useManualFallback: 'Cargar dirección a mano',
        searchAgain: 'Buscar por nombre',
      },
    },
  },
  vouchers: {
    config: {
      tabLabel: 'Vouchers',
      title: 'Vouchers',
      intro:
        'Lo que sale impreso en los documentos que reciben tus pasajeros: la identidad de la agencia y sus textos.',
      loadFailed: 'No se pudo cargar la configuración de vouchers.',
      anchors: {
        identity: 'Identidad',
        texts: 'Textos',
        byVertical: 'Por tipo de producto',
        byProvider: 'Por proveedor',
      },
      preview: {
        title: 'Vista previa',
        seeAs: 'Ver como',
        savedIdentity: 'Dibuja con el logo y el color GUARDADOS: guardá la identidad para verla acá.',
        empty: 'Escribí o elegí un tipo de producto para ver el documento.',
        open: 'Abrir PDF',
        retry: 'Reintentar',
        unsupported: 'Todavía no hay voucher para este tipo de producto.',
        needsLogo: 'Subí el logo de la agencia para ver la cabecera del documento.',
        notReady: 'Todavía no se puede dibujar el documento de ejemplo.',
        hasIssues: 'Arreglá los textos marcados para volver a dibujar.',
        failed: 'No se pudo dibujar la vista previa. Probá de nuevo.',
      },
      identity: {
        appliesToAll:
          'Estos datos salen en TODOS los documentos de la agencia, de todos los productos.',
        legalName: 'Razón social',
        legalNameHint: 'El nombre legal, como se imprime en el pie',
        taxId: 'RUT / RUC / CUIT',
        taxIdHint: 'Tal como se imprime',
        phone: 'Teléfono',
        phoneHint: 'El comercial, para consultas',
        email: 'Mail',
        emailHint: 'A dónde puede escribir el pasajero',
        website: 'Sitio web',
        websiteHint: 'Con https://',
        address: 'Dirección',
        addressHint: 'La que va en el pie del documento',
        assistancePhone: 'Teléfono de asistencia',
        assistancePhoneHint: 'El que el pasajero llama EN VIAJE, no el comercial',
        headerColor: 'Color de cabecera',
        headerColorHint: 'El logo negativo va sobre este color',
        headerColorEnabled: 'Usar color de cabecera',
        headerColorOn:
          'Cabecera con banda de este color y el logo NEGATIVO encima',
        headerColorOff: 'Cabecera lisa, con el logo normal',
        tooLong: 'Máximo {{max}} caracteres',
        emailInvalid: 'Tiene que ser un mail válido, o vacío',
        colorInvalid: 'Tiene que ser #RRGGBB, o vacío',
      },
      issuesIn: {
        identity: 'El problema que apaga Guardar está en Identidad.',
        texts: 'El problema que apaga Guardar está en Textos.',
        byVertical: 'El problema que apaga Guardar está en Por tipo de producto.',
        byProvider: 'El problema que apaga Guardar está en Por proveedor.',
      },
      rejectedIn: {
        texts: 'No se guardó nada: hay un texto rechazado en Textos.',
        byVertical: 'No se guardó nada: hay un texto rechazado en Por tipo de producto.',
        byProvider: 'No se guardó nada: hay un texto rechazado en Por proveedor.',
      },
      byVertical: {
        appliesTo:
          'Este texto se SUMA al de la agencia en los documentos de ese tipo de producto. Los que no tienen texto propio usan solo el de la agencia.',
        hint: 'Se imprime debajo de la bienvenida, antes de las condiciones.',
        hasOwn: 'Con texto propio',
        usesAgency: 'Usa solo el de la agencia',
        agencyOnly: 'Sin texto propio',
        edit: 'Escribir el texto',
        close: 'Cerrar',
      },
      byProvider: {
        appliesTo:
          'El texto de un proveedor sale solo en las reservas de ese proveedor, debajo del texto de su tipo de producto o en su lugar.',
        hint: 'Se imprime después del texto del tipo de producto, antes de las condiciones.',
        append: 'Se agrega debajo',
        replace: 'Sustituye',
        appendHelp: 'Sale debajo del texto del tipo de producto.',
        replaceHelp: 'Sale en lugar del texto del tipo de producto, que no se imprime en estas reservas.',
        mixed: 'Distinto por idioma',
        mixedHelp: 'Cada idioma se imprime con un modo distinto. Elegí uno y se guarda para los dos.',
        modeNeedsText: 'Escribí el texto para elegir cómo se imprime.',
        noText: 'Sin texto propio',
        notConfigured: 'No configurado en Rutero',
        notConfiguredHelp: 'Rutero no lo tiene configurado para la agencia: solo se puede vaciar el texto.',
        rejectedShort: 'Rutero no lo tiene configurado',
        rejectedAsUnknown:
          'Rutero ya no tiene este proveedor configurado para la agencia. Vaciá el texto para poder guardar.',
        loading: 'Leyendo los proveedores de Rutero…',
        loadFailed: 'No se pudo leer la lista de proveedores de Rutero.',
        retry: 'Reintentar',
        empty: 'Rutero no publica proveedores para esta agencia.',
        hubUnavailable:
          'No se guardó nada: Rutero no respondió al verificar los proveedores. Probá de nuevo en unos minutos.',
        edit: 'Escribir el texto',
        close: 'Cerrar',
      },
      texts: {
        appliesToAll:
          'Estos textos abren y cierran TODOS los documentos de la agencia, de todos los productos.',
        format:
          'Formato: **negrita**, viñetas con "- " y links [texto](https://…). Otro marcado sale impreso tal cual, así que no se acepta.',
        emptyRemoves: 'Vaciarlo lo quita del documento.',
        counter: '{{count}} de {{max}} caracteres',
        intro: 'Bienvenida',
        introHint: 'Abre el documento, arriba de los datos del servicio.',
        footer: 'Condiciones y pie',
        footerHint: 'Cierra el documento, debajo de todo.',
        rejected: 'No se guardó nada. Revisá los textos marcados.',
        otherRejected:
          'El backend rechazó un texto que esta pantalla no muestra. Revisá los textos por tipo de producto o por proveedor.',
        lang: {
          es: 'Español',
          en: 'English',
          enEmpty: 'English · vacío, usa español',
        },
        issues: {
          too_long: 'Se pasa del tope de {{max}} caracteres',
          unsupported_markup:
            'Tiene marcado que el documento no sabe dibujar: solo negrita, viñetas y links',
          unsupported_link: 'Los links tienen que ser [texto](https://…)',
          unbalanced_emphasis: 'Hay una negrita sin cerrar',
        },
      },
      logo: {
        primary: 'Logo',
        primaryHint: 'Va en la cabecera de los documentos',
        negative: 'Logo negativo',
        negativeHint: 'La versión para fondos oscuros, sobre el color de cabecera',
        empty: 'Todavía no cargaste este logo',
        upload: 'Subir imagen',
        done: 'Logo actualizado',
        rejected: 'No se pudo usar esa imagen.',
        failed: 'No se pudo subir el logo. Probá de nuevo.',
        tooBig: 'La imagen pesa demasiado. Probá con una más liviana.',
      },
      save: {
        action: 'Guardar',
        done: 'Configuración guardada',
        failed: 'No se pudo guardar la configuración.',
        needsAdmin: 'Solo un administrador de la agencia puede editar esto.',
        saving: 'Guardando…',
        hasIssues: 'Revisá los campos marcados antes de guardar.',
        noChanges: 'No hay cambios para guardar.',
        notLoaded:
          'Todavía no se pudo leer la configuración: recargá la página antes de guardar.',
      },
      unsaved: {
        title: 'Tenés cambios sin guardar',
        body: 'Si salís ahora se pierden los cambios de la identidad y de los textos. Los logos ya subidos quedan igual.',
        leave: 'Salir sin guardar',
        stay: 'Seguir editando',
      },
    },
  },
  rutero: {
    tabLabel: 'Servicios de tierra',
    settingsTitle: 'Servicios de tierra (Rutero)',
    pageIntro:
      'Búsqueda y reserva de tours, transfers, circuitos, trenes, ferries, autos y eSIMs. Cada proveedor necesita credenciales propias: sin credenciales, el proveedor no aparece en las búsquedas de esta agencia.',
    enabledLabel: 'Habilitar servicios de tierra para esta agencia',
    voucherAutoEmailLabel:
      'Enviar el voucher por mail al confirmar (requiere servicios de tierra habilitados)',
    voucherAutoEmailHint:
      'Sale solo al contacto de la reserva, con el PDF adjunto, recién cuando el operador también confirma. El asesor lo ve en el detalle y puede reenviarlo a mano.',
    saveSuccess: 'Configuración guardada',
    saveError: 'No se pudo guardar la configuración',
    connectors: {
      title: 'Proveedores',
      intro:
        'Las credenciales se guardan cifradas en el hub y nunca se vuelven a mostrar. Guardar reemplaza el set completo de credenciales del proveedor.',
      provider: 'Proveedor',
      connector: 'Conector',
      vertical: 'Producto',
      status: 'Estado',
      actions: 'Acciones',
      configured: 'Configurado',
      disabled: 'Deshabilitado',
      notConfigured: 'Sin configurar',
      configure: 'Configurar',
      replace: 'Reemplazar',
      delete: 'Eliminar',
      cancel: 'Cancelar',
      save: 'Guardar',
      enabledLabel: 'Habilitado',
      formTitle: 'Credenciales de {{connector}}',
      integrationName: 'Cuenta compartida (nombre de integración)',
      integrationEnvironment: 'Entorno de la cuenta',
      integrationNotice:
        'Usá el mismo nombre para agencias de la misma cuenta Transferz. TEST y PROD deben tener nombres distintos. El secreto del webhook es compartido; su rotación se administra por separado. Una ruta publicada no acredita recepción de eventos.',
      integrationConflict:
        'El nombre, entorno o secreto entra en conflicto con la integración compartida. No se guardaron los cambios; revisá la configuración con el administrador.',
      webhookPath: 'Ruta del webhook (relativa al origen público de la API)',
      webhookSecret: 'Secreto HMAC (opcional; vacío conserva el existente)',
      secretConfigured: 'Secreto configurado',
      secretPending: 'Secreto pendiente',
      writeOnlyNotice:
        'Este proveedor ya tiene credenciales guardadas. Por seguridad no se muestran: completá todos los campos para reemplazarlas.',
      unsupported:
        'El hub ofrece proveedores que esta pantalla todavía no sabe configurar: {{providers}}. Hasta agregarlos al catálogo no participan de las búsquedas.',
      loadError: 'No se pudieron cargar los proveedores',
      saveSuccess: 'Credenciales guardadas',
      saveError: 'No se pudieron guardar las credenciales',
      deleteConfirmTitle: 'Eliminar credenciales',
      deleteConfirmBody:
        'Se eliminan las credenciales de {{connector}} para esta agencia: el proveedor deja de aparecer en las búsquedas. ¿Continuar?',
      deleteSuccess: 'Credenciales eliminadas',
      deleteError: 'No se pudieron eliminar las credenciales',
    },
    verticals: {
      rail: 'Trenes',
      buses: 'Buses',
      ferry: 'Ferries',
      tours: 'Tours',
      circuits: 'Circuitos',
      transfers: 'Transfers',
      cars: 'Autos',
      esims: 'eSIMs',
      passes: 'Pases de tren',
    },
  },
  copilot: {
    panel: {
      title: 'Copiloto IA',
      offline: 'desconectado',
      noSuggestions: 'Sin sugerencias por ahora',
      updateClientName: 'Actualizar nombre del cliente',
      updateCustomField: 'Actualizar campo',
      suggestReply: 'Respuesta sugerida',
      useReply: 'Usar',
      interestScore: 'Nivel de interés',
      salesCoaching: 'Coaching de ventas',
      apply: 'Aplicar',
      dismiss: 'Descartar',
      dismissError: 'No se pudo descartar la sugerencia',
      applied: 'Sugerencia aplicada',
      applyError: 'No se pudo aplicar la sugerencia',
      requestSuggestion: 'Pedir sugerencia',
      requestError: 'No se pudo pedir la sugerencia',
    },
    tabLabel: 'Copiloto IA',
    settingsTitle: 'Copiloto IA',
    apiKeyConfigured:
      'API key del copiloto configurada. Completá el campo solo si querés cambiarla.',
    credentialsTitle: 'Credenciales y contexto de la agencia',
    pageIntro:
      'El copiloto se configura en dos capas: arriba las credenciales y el contexto de la agencia; más abajo, el comportamiento del copiloto por workflow/step.',
    configs: {
      title: 'Configuraciones del copiloto',
      subtitle: 'Activá capacidades del copiloto por workflow y step.',
      createCta: 'Nueva configuración',
      empty: 'Todavía no hay configuraciones.',
      allWorkflows: 'Todos los workflows',
      allSteps: 'Todos los steps',
      moreSteps: '+{{count}} más',
      confirmDelete: '¿Eliminar esta configuración?',
      deleteSuccess: 'Configuración eliminada',
      deleteError: 'No se pudo eliminar la configuración',
      saveSuccess: 'Configuración guardada',
      saveError: 'No se pudo guardar la configuración',
      modal: {
        createTitle: 'Nueva configuración del copiloto',
        editTitle: 'Editar configuración del copiloto',
      },
      table: {
        actions: 'Acciones',
        workflow: 'Workflow',
        steps: 'Steps',
        capabilities: 'Capacidades',
        enabled: 'Activo',
      },
      form: {
        enabled: 'Activo',
        workflow: 'Workflow',
        allWorkflows: 'Todos los workflows',
        steps: 'Steps',
        allSteps: 'Todos los steps',
        capabilities: 'Capacidades',
        detectClientName: 'Detectar nombre del cliente',
        detectCustomFields: 'Detectar datos de viaje',
        analyzeInterestScore: 'Nivel de interés',
        suggestReplies: 'Sugerir respuestas',
        salesCoaching: 'Coaching de ventas',
        useExternalApis: 'Usar APIs externas',
        stepContext: 'Contexto e instrucciones del step',
        stepContextPlaceholder: '¿Qué debe lograr el agente en este step?',
        stepContextHelper:
          'Soporta Markdown. Describí el objetivo del agente en este paso, qué datos debe recolectar y cuándo sugerir el cierre.',
        passiveModel: 'Modelo pasivo (por mensaje)',
        passiveModelHelper:
          'Corre automáticamente con cada mensaje. Usá un modelo rápido y económico (ej: gpt-4o-mini). Dejalo vacío para usar el default de la agencia.',
        activeModel: 'Modelo activo (on-demand)',
        activeModelHelper:
          'Corre cuando el agente pide sugerencias on-demand. Usá un modelo más potente (ej: gpt-4o). Dejalo vacío para usar el default de la agencia.',
        externalApiFacets: 'APIs externas habilitadas',
        externalApiFacetsPlaceholder: 'Vacío = todas',
        externalApiFacetsHelper:
          'Qué facets de viaje se ofrecen (botones on-demand + automático) en este workflow/step. Vacío = todos.',
        targetCustomFields: 'Campos a completar en este step',
        targetCustomFieldsPlaceholder: 'Vacío = todos',
        targetCustomFieldsHelper:
          'El copiloto solo sugiere capturar estos campos y orienta la respuesta hacia el próximo que falte. Vacío = detecta cualquier campo.',
        create: 'Crear',
        update: 'Actualizar',
      },
    },
    travelIntelligence: {
      settings: {
        title: 'Inteligencia de viaje (API externa)',
        intro:
          'Trae contexto de viaje (clima, documentación, paquetes, riesgo, etc.) para asistir al agente. Elegí en qué steps se usa desde cada configuración del copiloto (toggle "Consultar APIs externas").',
        enable: 'Habilitar uso de API externa',
        apiKeyConfigured:
          'API key configurada. Completá el campo solo si querés cambiarla.',
        apiKey: 'API key',
        businessUnit: 'Business unit (ej: UY)',
        currency: 'Moneda (ISO, ej: USD)',
        originCountry: 'País origen (ISO, ej: UY)',
        passportCountry: 'País pasaporte (ISO, ej: UY)',
        save: 'Guardar',
        saveSuccess: 'Inteligencia de viaje guardada',
        saveError: 'No se pudo guardar',
      },
      facets: {
        weather: 'Clima',
        documentation: 'Documentación',
        money: 'Moneda',
        packages: 'Paquetes',
        highlights: 'Qué ver',
        events: 'Eventos',
        risk: 'Alertas',
        socialProof: 'Valoraciones',
      },
      fields: {
        destination: 'Destino (ciudad, ej: Cancún)',
        packageDestination: 'Código de destino para paquetes (ej: CUN-Cancún)',
        businessUnit: 'Unidad de negocio',
        originCountry: 'País de origen (código ISO)',
        passportCountry: 'País del pasaporte (código ISO)',
        travelDate: 'Fecha de viaje',
        category: 'Tipo de lugar',
      },
      categories: {
        attractions: 'Atracciones',
        restaurants: 'Restaurantes',
        hotels: 'Hoteles',
        all: 'Todos',
      },
      cards: {
        packages: 'Paquetes',
        weather: 'Clima',
        documentation: 'Documentación',
        money: 'Moneda',
        highlights: 'Qué ver',
        destination_summary: 'Destino',
        social_proof: 'Valoraciones',
        events: 'Eventos',
        risk: 'Alertas',
        fallback: 'Inteligencia de viaje',
      },
      riskLevels: {
        none_detected: 'Sin alertas',
        low: 'Riesgo bajo',
        medium: 'Riesgo medio',
        high: 'Riesgo alto',
      },
      bar: {
        noResults: 'Sin resultados de {{facet}} para este destino/fechas',
        throttled: 'Probá de nuevo en un momento',
        requestError: 'No se pudo consultar',
        missing: 'Para "{{facet}}" falta:',
        consult: 'Consultar',
      },
      card: {
        source: 'Fuente: {{source}}',
        seeMore: 'Ver más',
        seeLess: 'Ver menos',
        viewLink: 'Ver',
        linkSource: 'Fuente',
      },
      chips: {
        packagesCount: '{{count}} paquetes',
        packagesFrom: 'desde {{currency}} {{price}}',
        stay: 'Estadía: {{duration}}',
        money: '1 {{base}} ≈ {{rate}} {{target}}',
        temps: '🌡 {{max}}° / {{min}}°',
        rainyDays: '🌧 {{pct}}% días de lluvia',
        activeAlerts: '{{count}} alertas activas',
        places: '{{count}} lugares',
        events: '{{count}} eventos',
      },
    },
  },
  filters: {
    filterBy: 'Filter by',
    clear: 'Limpiar',
    clearAll: 'Limpiar todo',
    namePlaceholder: 'Escribe un nombre',
    nameLabel: 'Nombre del filtro',
    isPublic: 'Publico (todos podran verlo)',
    createFilter: 'Crear Filtro',
    filterList: 'Lista de filtros',
    editFilter: 'Editar Filtro',
    deleteFilter: 'Eliminar Filtro',
    public: 'Públicos',
    private: 'Privados',
    createdSuccess: 'Filtro guardado',
    createdError: 'Hubo un error al guardar el filtro',
    deletedSuccess: 'Filtro eliminado exitosamente',
    deletedError: 'Hubo un error al eliminar el filtro',
    deleteConfirmTitle: 'Eliminar Filtro',
    deleteConfirmMessage: '¿Estás seguro de que quieres eliminar este filtro? Esta acción no se puede deshacer.',
    priceRange: 'Rango de precios',
    searchName: 'Buscar por nombre',
    hotelChains: 'Cadenas',
    categories: 'Categorias',
    amenities: 'Comodidades',
    date: {
      today: 'Hoy',
      yesterday: 'Ayer',
      thisWeek: 'Esta semana',
      thisMonth: 'Este mes',
      lastWeek: 'La semana pasada',
      lastMonth: 'El mes pasado',
      lastNDays: 'Últimos N días',
      tomorrow: 'Mañana',
      nextWeek: 'Próxima semana',
      nextMonth: 'Próximo mes',
      nextNDays: 'Próximos N días',
      specificDate: 'Fecha específica',
      dateRange: 'Rango de fechas',
      numberOfDays: 'Número de días',
      from: 'Desde',
      to: 'Hasta',
      selectDateType: 'Seleccionar tipo de fecha',
    },
    clientName: 'Nombre del Cliente',
    countries: 'Países',
    agencies: 'Agencias',
    preferredAgent: 'Agente Preferido',
    documentTypes: 'Tipos de Documento',
    searchClientNamePlaceholder: 'Buscar por nombre o apellido',
    myClients: 'Ver solo mis clientes',
    myCases: 'Ver solo mis casos',
  },
  userNotificationTriggers: {
    title: 'Gestión de Notificaciones',
    createTrigger: 'Crear Disparador',
    editTrigger: 'Editar Disparador',
    deleteTrigger: 'Eliminar Disparador',
    trigger: 'Disparador',
    active: 'Activo',
    noConditions: 'Sin condiciones específicas',
    client: 'Cliente',
    clientOptional: 'Cliente (opcional)',
    agent: 'Agente',
    agentOptional: 'Agente (opcional)',
    workflow: 'Workflow',
    step: 'Paso',
    steps: 'pasos',
    status: 'Estado',
    case: 'Caso',
    specificCase: 'Caso específico (opcional)',
    deliveryChannels: 'Canales de entrega',
    deliveryChannelsHelp:
      'In-app y email quedan activos por defecto. Google Chat DM sigue siendo opt-in y solo funciona cuando la agencia lo configuró.',
    noDeliveryChannels: 'Sin canales de entrega',
    addWorkflow: 'Agregar workflow',
    addWorkflowHint: 'Selecciona un workflow y al menos un paso para agregar otra fila.',
    removeWorkflow: 'Eliminar workflow',
    selectClient: 'Seleccionar cliente',
    selectAgent: 'Seleccionar agente',
    selectWorkflow: 'Seleccionar workflow(s)',
    selectStep: 'Seleccionar paso',
    selectStatus: 'Seleccionar estado',
    selectWorkflowFirst: 'Primero selecciona un workflow',
    caseIdPlaceholder: 'ID del caso',
    allClients: 'Todos los clientes',
    allAgents: 'Todos los agentes',
    anyStep: 'Cualquier paso',
    allWorkflows: 'Todos los workflows',
    anyStatus: 'Cualquier estado',
    anyCase: 'Cualquier caso',
    formDescription:
      'Configura las condiciones que activarán una notificación. Al menos una condición debe ser especificada.',
    noTriggers: 'No hay disparadores configurados',
    noTriggersDescription: 'Crea tu primer disparador para recibir notificaciones automáticas.',
    createFirst: 'Crear primer disparador',
    createdBy: 'Creado por',
    confirmDelete: {
      title: 'Confirmar Eliminación',
      message: '¿Estás seguro de que deseas eliminar este disparador? Esta acción no se puede deshacer.',
      triggerDetails: 'Detalles del Disparador',
      warning: 'Esta acción eliminará permanentemente el disparador y no se puede revertir.',
    },
    fields: {
      client: 'Cliente',
      agent: 'Agente',
      workflow: 'Workflow',
      step: 'Paso',
      status: 'Estado',
    },
    channels: {
      inApp: 'In-app',
      email: 'Email',
      googleChat: 'Google Chat DM',
    },
    channelAvailability: {
      emailUnavailable:
        'Email no está disponible para esta agencia. Configúralo en Agencia -> Comunicaciones.',
      googleChatUnavailable:
        'Google Chat DM no está disponible para esta agencia. Configúralo en Agencia -> Comunicaciones.',
    },
    createSuccess: 'Disparador creado exitosamente',
    updateSuccess: 'Disparador actualizado exitosamente',
    deleteSuccess: 'Disparador eliminado exitosamente',
    saveError: 'Error al guardar el disparador',
    deleteError: 'Error al eliminar el disparador',
    activatedSuccess: 'Disparador activado',
    deactivatedSuccess: 'Disparador desactivado',
    toggleError: 'Error al cambiar el estado del disparador',
    validation: {
      workflowRequired: 'El workflow es obligatorio',
      stepsRequired: 'Selecciona al menos un paso',
      statusRequired: 'El estado es obligatorio',
    },
  },
  whatsapp: {
    chatLocation: {
      location: 'Ubicación',
    },
    title: 'Whatsapp',
    systemSender: 'Agencia',
    replyToThisMessage: 'Responder a este mensaje',
    linkedCases: 'Casos linkeados',
    noMessagesFound: 'No se encontraron mensajes..',
    typeMessage: 'Escribe tu mensaje...',
    startWithTemplate: 'Comienza con un template',
    messageStatus: {
      [WhatsappMessageEventStatusType.REQUESTED]: 'solicitado',
      [WhatsappMessageEventStatusType.ENQUEUED]: 'encolado',
      [WhatsappMessageEventStatusType.FAILED]: 'falló',
      [WhatsappMessageEventStatusType.SENT]: 'enviado',
      [WhatsappMessageEventStatusType.DELIVERED]: 'entregado',
      [WhatsappMessageEventStatusType.READ]: 'leído',
    },
    emoji: {
      categories: {
        favoritos: 'Favoritos',
        smileys_emotion: 'Caritas y emoción',
        people_body: 'Personas y cuerpo',
        travel_places: 'Viajes y lugares',
        food_drink: 'Comida y bebida',
        activities: 'Actividades',
        objects: 'Objetos',
        symbols: 'Símbolos',
        flags: 'Banderas',
      },
      names: {
        airplane: 'avión',
        globe: 'globo terráqueo',
        telephone: 'teléfono',
        speech_balloon: 'burbuja de diálogo',
        handshake: 'apretón de manos',
        smiling_face: 'cara sonriente con ojos alegres',
        face_with_hearts: 'cara con corazones',
        hugging_face: 'abrazo',
        star_struck: 'cara deslumbrada',
        folded_hands: 'manos en plegaria',
        thumbs_up: 'pulgar arriba',
        raising_hands: 'manos levantadas',
        briefcase: 'maletín',
        incoming_envelope: 'sobre entrante',
        rocket: 'cohete',
        check_mark: 'marca de verificación',
        alarm_clock: 'despertador',
        dollar_sign: 'signo de dólar',
        red_heart: 'corazón rojo',
        party_popper: 'confeti',
        grinning_face: 'cara feliz',
        beaming_face: 'cara sonriente',
        face_with_tears: 'cara llorando de risa',
        grinning_face_with_sweat: 'cara sonriente sudor frío',
        smiling_face_with_sunglasses: 'cara con gafas de sol',
        thinking_face: 'pensativo',
        face_with_rolling_eyes: 'ojos en blanco',
        crying_face: 'cara llorando',
        smiling_face_with_heart_eyes: 'cara enamorada',
        pouting_face: 'cara enfadada',
        sleeping_face: 'cara dormida',
        partying_face: 'cara de fiesta',
        waving_hand: 'saludo',
        thumbs_down: 'pulgar abajo',
        open_hands: 'manos abiertas',
        clapping_hands: 'aplausos',
        call_me_hand: 'gesto hang loose',
        flexed_biceps: 'brazo fuerte',
        car: 'coche',
        bus: 'autobús',
        train: 'tren',
        sailboat: 'velero',
        passenger_ship: 'crucero',
        statue_of_liberty: 'Estatua de la Libertad',
        world_map: 'mapa',
        eiffel_tower: 'Torre Eiffel',
        green_apple: 'manzana verde',
        hamburger: 'hamburguesa',
        pizza: 'pizza',
        sushi: 'sushi',
        steaming_bowl: 'ramen',
        shortcake: 'torta',
        beer_mug: 'jarra de cerveza',
        hot_beverage: 'café',
        wine_glass: 'copa de vino',
        bottle_with_popping_cork: 'botella de champagne',
        soccer_ball: 'fútbol',
        basketball: 'básquetbol',
        american_football: 'fútbol americano',
        tennis: 'tenis',
        volleyball: 'vóleibol',
        video_game: 'videojuego',
        musical_note: 'nota musical',
        clapper_board: 'claqueta',
        artist_palette: 'paleta de artista',
        mobile_phone: 'teléfono móvil',
        laptop: 'computadora portátil',
        desktop_computer: 'monitor',
        printer: 'impresora',
        camera: 'cámara',
        key: 'llave',
        locked: 'candado cerrado',
        wastebasket: 'papelera',
        package: 'caja',
        battery: 'batería',
        broken_heart: 'corazón roto',
        hundred_points: 'cien puntos',
        cross_mark: 'cruz',
        warning: 'advertencia',
        information: 'información',
        bell: 'campana',
        ok_button: 'OK',
        recycling_symbol: 'reciclaje',
        uruguay_flag: 'bandera de Uruguay',
        paraguay_flag: 'bandera de Paraguay',
        bolivia_flag: 'bandera de Bolivia',
        colombia_flag: 'bandera de Colombia',
        usa_flag: 'bandera de Estados Unidos',
        brazil_flag: 'bandera de Brasil',
        argentina_flag: 'bandera de Argentina',
        mexico_flag: 'bandera de México',
        chile_flag: 'bandera de Chile',
        spain_flag: 'bandera de España',
        star: 'estrella',
        glowing_star: 'estrella brillante',
        sparkles: 'destellos',
        dizzy: 'remolino de estrella',
        shooting_star: 'estrella fugaz',
      },
      selectEmoji: 'Seleccioná un emoji',
      searchPlaceholder: 'Escribí acá para buscar',
    },
    templateMessenger: {
      title: 'Enviar mensaje desde template',
      selectTemplate: 'Seleccioná un template',
      preview: 'Vista previa:',
      completeFields: 'Completa los campos:',
      placeholder: 'Placeholder {{number}}',
      sendMessage: 'Enviar mensaje',
      fileSelected: 'Archivo seleccionado',
      fileRequired: 'Se requiere un archivo para este template',
      uploadFile: 'Subir archivo',
      noFileSelected: 'Ningún archivo seleccionado',
      selectFile: 'Seleccionar archivo',
    },
    results: 'resultados',
    table: {
      clientName: 'Nombre del cliente',
      fromNumber: 'Número de teléfono',
      conversation: 'Conversación',
      agency: 'Agencia',
      msgType: 'Tipo de mensaje',
      expiration: 'Expiración',
    },
    client: {
      lastCases: 'Últimos Casos',
      noCases: 'No hay casos para mostrar',
      conversation: 'Conversación de Whatsapp',
      searchPlaceholder: 'Buscar en la conversación',
      writeMessage: 'Escribe un mensaje',
      sendTemplate: 'Enviar Template',
      aiEnabled: 'IA Habilitada',
      sentTo: 'envió a',
    },
    content: {
      whatsapp: 'Whatsapp',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      files: 'Archivos',
      notes: 'Notas',
      history: 'Historial',
      all: 'Todos',
      show: 'Mostrar',
      search: 'Buscar...',
      viewMore: 'Ver más',
      now: 'Ahora',
      minutesAgo: 'Hace {{minutes}} minutos',
      sessionExpired: 'Sesión expirada',
      timeLeft: 'Tiempo restante',
    },
    messageTypes: {
      text: 'Texto',
      contacts: 'Contactos',
      template: 'Plantilla',
      sticker: 'Sticker',
      audio: 'Audio',
      video: 'Video',
      image: 'Imagen',
      document: 'Documento',
      location: 'Ubicación',
    },
    settings: {
      title: 'Configuración de Gupshup',
      createNewSubscription: 'Crear nueva suscripción',
      tag: 'Etiqueta',
      url: 'URL',
      version: 'Versión',
      showOnUI: 'Mostrar en UI',
      modes: 'Modos',
      templates: {
        title: 'Templates',
        searchLabel: 'Buscar templates',
        searchPlaceholder: 'Buscar templates',
        empty: 'No se encontraron templates.',
        table: {
          id: 'Template ID',
          name: 'Nombre del template',
          enabled: 'Habilitado',
          actions: 'Acciones',
        },
        actions: {
          edit: 'Editar placeholders del template',
        },
        dialog: {
          title: 'Editar placeholders del template',
          templateText: 'Texto original del template',
          placeholderMappings: 'Mapeos de placeholders',
          placeholderHelp:
            'Cada selector corresponde al placeholder posicional equivalente en el texto original del template.',
          placeholderLabel: 'Placeholder {{number}}',
          unassigned: 'Sin asignar',
          noPlaceholders:
            'Este template no tiene placeholders posicionales.',
        },
        messages: {
          updatedSuccess:
            'Los placeholders del template se actualizaron correctamente.',
          saveError:
            'Hubo un error al guardar los placeholders del template.',
        },
      },
      quickReplies: {
        title: 'Respuestas rápidas',
        searchLabel: 'Buscar respuestas rápidas',
        searchPlaceholder: 'Buscar por slug, nombre o cuerpo',
        empty: 'Todavía no hay respuestas rápidas creadas.',
        emptySearch: 'No hay respuestas rápidas que coincidan con tu búsqueda.',
        table: {
          slug: 'Slug',
          name: 'Nombre',
          preview: 'Vista previa',
          enabled: 'Habilitada',
          actions: 'Acciones',
        },
        actions: {
          create: 'Crear',
          edit: 'Editar respuesta rápida',
          delete: 'Eliminar respuesta rápida',
        },
        form: {
          createTitle: 'Crear respuesta rápida',
          editTitle: 'Editar respuesta rápida',
          slug: 'Slug',
          slugPlaceholder: 'booking-update',
          slugHelper:
            'Usa solo kebab-case en minúsculas. Máximo 64 caracteres.',
          slugInvalid:
            'Usa solo kebab-case en minúsculas, con letras o números separados por guiones.',
          name: 'Nombre',
          namePlaceholder: 'Actualización de reserva',
          body: 'Cuerpo',
          bodyPlaceholder: 'Escribe aquí la respuesta guardada de WhatsApp...',
          bodyHelper:
            'Se admite texto en múltiples líneas. Máximo 2000 caracteres.',
          enabled: 'Habilitada',
        },
        deleteDialog: {
          title: 'Eliminar respuesta rápida',
          description:
            '¿Seguro que quieres eliminar "{{name}}"? Esta acción no se puede deshacer.',
        },
        help: {
          title: 'Variables disponibles',
          intro:
            'Estas variables se pueden usar en las respuestas rápidas de WhatsApp y se renderizan desde el contexto del caso.',
          note:
            'Los valores faltantes se renderizan como texto vacío, así que conviene que el mensaje siga siendo legible sin todas las variables.',
          exampleLabel: 'Ejemplo',
          exampleValue:
            'Hola {{client_first_name}}, bienvenido a Mevuelo.',
          placeholders: {
            clientName: {
              token: '{{client_name}}',
              description: 'Nombre completo del cliente.',
            },
            clientFirstName: {
              token: '{{client_first_name}}',
              description: 'Nombre del cliente.',
            },
            clientLastName: {
              token: '{{client_last_name}}',
              description: 'Apellido del cliente.',
            },
            agentName: {
              token: '{{agent_name}}',
              description: 'Nombre completo del agente.',
            },
            agentFirstName: {
              token: '{{agent_first_name}}',
              description: 'Nombre del agente.',
            },
            agentLastName: {
              token: '{{agent_last_name}}',
              description: 'Apellido del agente.',
            },
          },
        },
        messages: {
          loadError: 'Hubo un error al cargar las respuestas rápidas.',
          createdSuccess: 'Respuesta rápida creada con éxito.',
          updatedSuccess: 'Respuesta rápida actualizada con éxito.',
          deletedSuccess: 'Respuesta rápida eliminada con éxito.',
          saveError: 'Hubo un error al guardar la respuesta rápida.',
          deleteError: 'Hubo un error al eliminar la respuesta rápida.',
          toggleError:
            'Hubo un error al actualizar el estado de la respuesta rápida.',
        },
      },
    },
    slashCommands: {
      emptyCommands: 'No hay comandos que coincidan con tu búsqueda.',
      commands: {
        quickReplies: {
          label: 'Respuestas rápidas',
          description:
            'Inserta una respuesta guardada de WhatsApp en el composer para revisarla antes de enviarla.',
          aliases: {
            english: '/quick-reply',
            spanish: '/respuesta-rapida',
            shortEnglish: '/qr',
            shortSpanish: '/rp',
          },
        },
      },
      quickReplies: {
        loading: 'Cargando respuestas rápidas...',
        empty: 'No se encontraron respuestas rápidas habilitadas.',
        requiresCase: 'Abre un caso para usar respuestas rápidas aquí.',
        renderError: 'Hubo un error al insertar la respuesta rápida.',
      },
    },
    iaReasoning: {
      viewReasoning: 'Ver razonamiento de IA',
      hideDetails: 'Ocultar detalles',
      viewCompleteAnalysis: 'Ver análisis completo',
      contextAnalysis: 'Análisis del Contexto',
    },
  },
  agencyAccess: {
    title: 'Acceso a agencias',
    saveError: 'Ocurrio un problema al actualizar el permiso entre usuario y agencia',
  },
  updateClientAgency: {
    updateSuccess: 'Agencia actualizada!',
    updateError: 'Ocurrio un error al actualizar la agencia',
    title: 'Agencia Responsable',
    inputLabel: 'Seleccionar Agencia',
    confirm: 'Confirmar cambios',
    dialog1: 'Cambiar la agencia disparará varios cambios ',
    dialog2: 'El usuario dejar de formar parte de los teams perteneciente a esta agencia',
    dialog3: 'Todos los casos que pertenezcan a este usuario quedaran unassigned',
    dialog4: '¿Estás seguro que deseas continuar?',
  },
  agentAvailability: {
    title: 'Agentes Disponibles',
    status: 'Estado',
    agent: 'Agente',
    since: 'Hace',
  },
  agentStatus: {
    [AgentStatus.AFTER_CALL]: 'Seguimiento',
    [AgentStatus.AVAILABLE]: 'Disponible',
    [AgentStatus.BREAK]: 'Descanso',
    [AgentStatus.IN_CALL]: 'En llamada',
    [AgentStatus.LUNCH]: 'En Almuerzo',
    [AgentStatus.NOT_AVAILABLE]: 'No Disponible',
    [AgentStatus.NOT_APPLICABLE]: 'No Aplica',
    [AgentStatus.WORKING_IN_CASE]: 'Trabajando en caso',
    [AgentStatus.DISCONNECTED]: 'Desconectado',
  },
  roles: {
    title: 'Roles',
    [UserRoles.ADMINS]: 'Administrador',
    [UserRoles.AGENTS]: 'Agente',
    [UserRoles.OPERATORS]: 'Operador',
    [UserRoles.REGISTERED]: 'Registrado',
    [UserRoles.HOTEL_CONTENT_MODERATOR]: 'Moderador de contenido de hoteles',
    [UserRoles.EXTERNAL_INTEGRATION]: 'Integracion Externa',
    [UserRoles.TESTER]: 'Tester',
    [UserRoles.HOTEL_BOOKER]: 'Hotel Booker',
  },
  supportForms: {
    list: {
      title: 'Support forms',
      subtitle: 'Listado de support forms',
      results: 'resultados',
      error: 'Hubo un error intentando cargar los support forms',
      delete: 'Confirma para eliminar: {{name}}',
      deleteTitle: 'Eliminar support form',
      deleted: 'Support form eliminado!',
      deleteError: 'Hubo un problema al intentar eliminar el support form',
    },
    fields: {
      titleField: 'Titulo',
      workflowField: 'Workflow',
      descriptionField: 'Descripcion',
      customLogoUrl: 'URL de logo personalizado',
      customLogoUrlHelper: 'Se usará el logo de la agencia por defecto si no se completa',
      finalUrl: 'Url final',
      name: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo electrónico',
      emailSubject: '{{title}} {{code}} 🚀',
    },
    view: {
      titleCreate: 'Crear Support Form',
      preview: 'Vista preliminar',
      noWorkflows: 'No se encontraron workflows',
      saved: 'Support form guardado!',
      error: 'Hubo un problema al intentar guardar el support form',
    },
    generator: {
      title: 'Agregar campos customizados',
      fieldType: 'Tipo de campo',
      optionsLabel: 'Opciones (separadas por coma)',
      label: 'Etiqueta',
      key: 'Name del field en el form',
      isRequired: 'Es requerido',
      addField: ' Agregar campo',
    },
    send: {
      success: 'Solicitud enviada correctamente',
      successMessage: 'Te contactaremos en breves!',
      error: 'Hubo un problema al intentar enviar la solicitud',
    },
    email: {
      title: 'Un nuevo caso fue abierto para: {{email}} con los siguientes datos procesados:',
    },
  },
  auth: {
    login: {
      title: 'Iniciá sesión en Me Vuelo',
      email: 'Correo electrónico',
      password: 'Contraseña',
      forgotPassword: '¿Olvidaste tu contraseña?',
      createAccountText: '¿No tenés cuenta?',
      createAccountLink: 'Registrate',
      loginMesssage: 'Iniciar sesión',
      logoutMesssage: 'Cerrar sesión',
      loginGoogleMesssage: 'Iniciar con Google',
      fieldErrorMessage: 'Este campo es requerido',
      error: 'Usuario o password invalido',
    },
    forgotPassword: {
      title: '¿Olvidaste tu contraseña?',
      subtitle: 'No te preocupes, te enviaremos un código para restablecerla',
      email: 'Ingresa tu correo',
      reset: 'Restablecer contraseña',
      back: 'Volver',
      error: 'Hubo un problema',
      sentEmail: 'Correo enviado',
    },
    resetPasswordCode: {
      title: 'Restablecimiento de contraseña',
      subtitle: 'Te enviamos un código a',
      continue: 'Continuar',
      back: 'Volver',
      error: 'Hubo un problema',
    },
    resetPassword: {
      title: 'Establece una nueva contraseña',
      newPassword: 'Nueva contraseña',
      confirmNewPassword: 'Confirmar contraseña',
      save: 'Restablecer contraseña',
      error: 'Hubo un problema',
      success: 'Contraseña restablecida con exito',
    },
    register: {
      title: 'Registrate a Me Vuelo',
      email: 'Correo electrónico',
      password: 'Contraseña',
      confirm: 'Confirma tu contraseña',
      registerMesssage: 'Registrarse',
      logInText: '¿Ya tenés cuenta?',
      logInLink: 'Iniciá sesión',
      fieldErrorMessage: 'Este campo es requerido',
      userRegistered: 'Usuario registrado: ahora iniciá sesión',
      error: 'El correo electrónico ya existe en nuestro systema',
      errorMessage: 'Usuario o password invalido!',
    },
    changePassword: {
      title: 'Cambiar contraseña',
      currentPassword: 'Contraseña actual',
      newPassword: 'Nueva contraseña',
      confirmNewPassword: 'Confirmar contraseña',
      passwordsDontMatch: 'Las contraseñas no coinciden',
      changePasswordError: 'Ha ocurrido un error al intentar cambiar la contraseña',
      success: 'Contraseña cambiada correctamente',
      invalidPassword: 'Contraseña incorrecta',
    },
    editUser: {
      title: 'Editar datos personales',
      subtitle: 'Ingresa los datos como aparecen en tu documento de identificación o pasaporte.',
      failMessage: 'Error al actualizar el usuario',
      uploadPicture: 'Subir imagen',
      pictureFieldDescription: 'Añade una foto. Tamaño máximo del archivo 3MB',
      firstName: {
        placeHolder: 'Nombres',
        errorMessage: 'Campo requerido',
        helperText: 'Tal cual figura en su DNI',
      },
      lastName: {
        placeHolder: 'Apellidos',
        errorMessage: 'Campo requerido',
        helperText: 'Tal cual figura en su DNI',
      },
      phoneCountryCode: {
        placeHolder: 'Codigo de area',
        errorMessage: 'Campo requerido',
      },
      phoneNumber: {
        placeHolder: 'Numero de telefono',
        errorMessage: 'Campo requerido',
      },
      phoneExtension: {
        placeHolder: 'Numero de extensión',
        errorMessage: 'Este campo falló',
        helperText: 'Numero de extensión (opcional)',
      },
      position: {
        placeHolder: 'Posición',
        errorMessage: 'Este campo falló',
      },
      address1: {
        placeHolder: 'Direccion',
        errorMessage: 'Campo requerido',
        helperText: 'Ingrese su direccion',
      },
      address2: {
        placeHolder: '',
        errorMessage: 'Campo requerido',
        helperText: '2nda linea de direccion (opcional)',
      },
      country: {
        placeHolder: 'Pais',
        errorMessage: 'Campo requerido',
      },
      city: {
        placeHolder: 'Ciudad',
        errorMessage: 'Campo requerido',
      },
      postalCode: {
        placeHolder: 'Codigo Postal',
        errorMessage: 'Campo requerido',
      },
      documentType: {
        placeHolder: 'Tipo de documento',
        errorMessage: 'Campo requerido',
        helperText: 'Tipo de documento',
      },
      documentNumber: {
        placeHolder: 'Numero de documento',
        errorMessage: 'Campo requerido',
        helperText: 'Tal cual figura en el documento',
      },
      profilePicture: {
        errorMessage: 'Hubo un problema subiendo tu foto.',
        fileTooLarge: 'El archivo es demasiado grande, el tamaño máximo es de 3MB',
        invalidFileFormat: 'Formato de archivo no soportado.',
      },
      applyChangesBtn: 'Aplicar',
      patchSuccess: 'Usuario actualizado con éxito!',
    },
  },
  noteEditor: {
    subject: 'Asunto',
    save: 'Guardar',
    send: 'Enviar',
    to: 'Para',
    cc: 'CC',
    bcc: 'BCC',
    from: 'De',
    placeholder: 'Escribe algo',
    emailTitle: 'Nuevo E-mail',
    noteTitle: 'Nueva nota',
    noOptions: 'No se encontraron resultados',
    controls: {
      minimize: 'Minimizar',
      maximize: 'Maximizar',
      close: 'Cerrar',
      remove: 'Remover',
      bold: 'Negrita',
      italic: 'Itálica',
      underline: 'Subrayado',
      bulletList: 'Lista',
      attachments: 'Adjustar',
      link: 'Link',
      image: 'Imagen',
      undo: 'Deshacer',
      redo: 'Rehacer',
    },
    errors: {
      subject: 'El asunto es requerido',
      content: 'El contenido es requerido',
      email: 'El destinatario es requerido',
      fileTooLarge: 'El archivo es demasiado grande, el tamaño máximo es de 3MB',
      fileNotAvailable: 'El archivo no está disponible',
    },
  },
  calls: {
    subtitle: 'Lista de llamadas del sistema',
    table: {
      title: 'Llamadas',
      type: 'Tipo',
      from: 'Desde',
      to: 'Hacia',
      agent: 'Agente',
      status: 'Estado',
      duration: 'Duración',
      inbound: 'Entrante',
      outbound: 'Saliente',
      notAssigned: 'Sin asignar',
    },
    status: {
      [CallStatus.IN_PROGRESS]: 'En curso...',
      [CallStatus.DECLINED]: 'No contestada',
      loading: 'Cargando...',
      unknown: 'Desconocido',
    },
    assignment: {
      title: 'Detalle de la llamada',
      search: 'Buscar caso',
      newCase: 'Nuevo caso',
      caseId: 'ID del caso',
      success: 'Llamada asignada con éxito',
      error: 'No se pudo vincular esta llamada al caso seleccionado. Intentá nuevamente.',
      missingCallId:
        'No pudimos encontrar la información de la llamada necesaria para vincular esta llamada. Reabrí la llamada o actualizá la página.',
      flow: 'Flujo',
      client: 'Cliente',
      clientUnassigned: 'Sin asignar',
      step: 'Paso',
      status: 'Estado',
      team: 'Equipo',
      assignedTo: 'Agente asignado',
      link: 'Asociar a este caso',
      create: {
        title: 'Nuevo caso',
        cancel: 'Cancelar',
        accept: 'Crear',
        subject: 'Asunto del caso',
        unassigned: 'Sin asignar',
        warning: 'La llamada en curso se asociará a este nuevo caso',
        missingCallId:
          'No pudimos encontrar la información de la llamada necesaria para crear el caso. Reabrí la llamada o actualizá la página.',
        error: 'No se pudo crear el caso para esta llamada. Intentá nuevamente.',
      },
      filters: {
        title: 'Filtrar por',
        team: 'Equipo',
        workflow: 'Flujo',
        step: 'Paso',
        agent: 'Agente',
        client: 'Cliente',
      },
    },
    incoming: {
      title: 'Llamada entrante',
      callFrom: 'Llamada de {{phoneNumber}}',
      unknown: 'Desconocido',
      contentSubtitle: 'Te está llamando',
      answer: 'Aceptar',
      phone: 'Teléfono',
      decline: 'Colgar',
      transfer: {
        title: 'Transferir llamada',
        searchPlaceholder: 'Buscar usuario',
        freqUsers: 'Usuarios frecuentes',
        calling: 'Llamando...',
        joined: 'En curso',
      },
    },
    interaction: {
      title: 'Habilitar recepción de llamadas',
      description:
        'Para recibir llamadas y reproducir sonidos automáticamente, necesitas hacer clic en cualquier parte de la pantalla.',
      enable: 'Habilitar llamadas',
      enable_audio: 'Habilitar sonido',
      banner_message:
        'Haz clic aquí para habilitar el sonido de llamadas entrantes. También puedes hacer clic en cualquier parte de la página.',
    },
    inProgress: { title: 'Llamada en curso', caseNumber: 'Caso #{{caseId}}' },
  },
  customFields: {
    title: 'Campos Personalizados',
    subtitle: 'Lista de campos personalizados',
    fieldBlockCreate: {
      title: 'Crear bloque de campos',
      name: 'Nombre',
      createdSuccess: 'Bloque de campos creado',
      createdError: 'Ocurrio un error al crear el bloque de campos',
    },
    fieldBlockEdit: {
      title: 'Editar bloque de campos',
      editSuccess: 'Bloque de campos actualizado',
      editError: 'Ocurrio un error al editar el bloque de campos',
    },
  },
  common: {
    all: 'Todas',
    hours: 'horas',
    view: 'Ver',
    create: 'Crear',
    delete: 'Eliminar',
    deleting: 'Eliminando...',
    active: 'Activo',
    inactive: 'Inactivo',
    mode: 'Modo',
    count: 'Cantidad',
    name: 'Nombre',
    noData: 'Sin datos disponibles',
    comingSoon: 'Próximamente',
    mandatoryField: 'Este campo es obligatorio',
    invalidDate: 'Fecha inválida',
    add: 'Agregar',
    close: 'Cerrar',
    loading: 'Guardando…',
    retry: 'Reintentar',
    update: 'Actualizar',
    continue: 'Continuar',
    cheapest: 'Más económicos',
    nonEconomic: 'Más caros',
    recommended: 'Recomendados',
    orderBy: 'Ordernar por:',
    na: 'N/A',
    accept: 'Aceptar',
    confirmAction: 'Confirmar Acción',
    goBack: 'Volver atras',
    warning: 'Cuidado',
    save: 'Guardar',
    today: 'Hoy',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    unassigned: 'Sin asignar',
    yes: 'Si',
    no: 'No',
    welcomeMessage: 'Hola mundo! este es un mensaje en español de bienvenida para: ',
    filters: 'Filtros',
    general: 'General',
    notValueFound: '-',
    results: 'Resultados',
    search: 'Buscar',
    refresh: 'Refrescar',
    refreshData: 'Refrescar datos',
    status: 'Estado',
    step: 'Paso',
    workflow: 'Flujo',
    channel: 'Canal',
    agent: 'Agente',
    updated: 'Actualizado',
    list: 'Lista',
    new: 'Nuevo',
    takeALook: 'Ver',
    selectFile: 'Seleccionar archivo',
    tbd: 'TBD',
    maxSelectionsReached: 'Máximo de selecciones alcanzado',
    itemsSelected: 'items seleccionados',
    readMore: 'Ver más',
    showLess: 'Ver menos',
    actions: {
      add: 'Agregar',
      close: 'Cerrar',
      cancel: 'Cancelar',
      create: 'Crear',
      save: 'Guardar',
      gptGeneration: 'Generar con GPT',
      gptAllGeneration: 'Generar todo con GPT',
      open: 'Abrir',
      remove: 'Borrar',
      send: 'Enviar',
      download: 'Descargar',
      edit: 'Editar',
    },
    form: {
      onlyLetters: 'Solo letras',
      onlyNumbers: 'Solo números',
      onlyLettersAndNumbers: 'Solo letras y números',
      pressEnterToAdd: 'Presiona enter para agregar',
      invalidMail: 'Correo inválido',
      duplicateMail: 'Correo duplicado',
      apply: 'Aplicar',
      clear: 'Limpar',
      required: 'Campo requerido',
      save: 'Guardar',
      discard: 'Descartar',
      select: 'Seleccionar',
      delete: 'Eliminar',
      url: 'El campo es una URL',
    },
    nav: {
      searchNavigation: 'Buscadores',
      moreSearches: 'Más buscadores',
      serviceUnavailable: 'Este servicio no está disponible para la agencia.',
      flights: 'Vuelos',
      hotels: 'Hoteles',
      transfers: 'Traslados',
      experiences: 'Experiencias',
      esims: 'eSIMs',
      rail: 'Trenes',
      buses: 'Buses',
      ferry: 'Ferries',
      circuits: 'Circuitos',
      passes: 'Pases',
      travelBookings: 'Reservas',
      cars: 'Autos',
      explorer: 'Explorar',
      dashboard: 'Dashboard',
      saleOrders: 'Sale Orders',
      clients: 'Clientes',
      agencies: 'Agencias',
      cases: 'Casos',
      calls: 'Llamadas',
      teams: 'Equipos',
      workflows: 'Flujos de trabajo',
      whatsapp: 'Whatsapp',
      users: 'Usuarios',
      flightIntegrations: 'Integraciones de vuelo',
      hotelIntegrations: 'Integraciones de hotel',
      hotelContentManagement: 'Hotel Content',
      userMenu: {
        userIdentifier: 'Invitado',
        myFavorites: 'Mis favoritos',
        myNotifications: 'Notificaciones',
        myBookings: 'Mis Reservas',
        admin: 'Admin',
        routingRules: 'Routing rules',
        markupRules: 'Reglas de margenes',
        userList: 'Listado de usuarios',
        contentManager: 'Gestor de Contenidos',
        accountMessage: 'Cuenta',
        currentCurrency: 'Moneda',
        currentLanguage: 'Idioma',
        help: 'Ayuda',
        selectedLanguage: 'Español',
        teams: 'Teams',
      },
    },
    footer: {
      companyType: 'Agencia de viajes registrada',
      identity: 'Real Consulting S.A. Resolución Registur N° 1263/2019',
      contactMessage: 'Contactanos',
      company: {
        title: 'Empresa',
        about: 'Sobre Nosotros',
        terms: 'Términos y Condiciones',
        privacy: 'Políticas de Privacidad',
        join: 'Sumate al Equipo',
      },
      account: {
        title: 'Cuenta',
        data: 'Mis Datos',
        favourites: 'Mis Favoritos',
        alerts: 'Mis Alertas',
        reserves: 'Mis Reservas',
        close: 'Cerrar Sesión',
      },
      platform: {
        title: 'Plataforma',
        currency: 'Moneda',
        language: 'Idioma',
        rates: 'Rates Tracker',
        rules: 'Markup Rules',
        travelers: 'Mis Viajeros',
        airlines: 'ABM Aerolineas',
        cabines: 'ABM Cabinas',
        alliances: 'ABM Alianzas',
      },
      payments: {
        certification: {
          title: 'Certificación de seguridad',
          description:
            'Mevuelo.com se encuentra certificado por el consejo de normas de seguridad para tus medios de pago.',
        },
        intelligentTravel: {
          title: 'Viajá inteligente y gastá menos',
          description:
            'Descubrí precios inmejorables en vuelos, hoteles y autos, haciendo de cada viaje una aventura económica.',
        },
        explore: {
          title: 'Explorá más, preocupate menos',
          description:
            'Con Mevuelo, viajar es más fácil que nunca. Personalizá tu viaje como quieras, empacá tus sueños y nosotros nos encargamos del resto.',
        },
        paymentMethods: {
          title: 'Pagá con el método que más te guste',
          credit: 'Tarjetas de crédito',
          bankTransfers: 'Transferencias bancarias',
          cash: 'Efectivo en cualquiera de nuestras sucursales',
        },
        altImages: {
          visa: 'logo de la tarjeta visa',
          oca: 'logo de la tarjeta oca',
          mastercard: 'logo de la tarjeta mastercard',
          american: 'logo de la tarjeta american',
          securityEncryption: 'imagen caja de seguridad',
          wallet: 'imagen billetera',
          backpack: 'imagen mochila',
          card: 'icono de tarjeta',
          bank: 'icono de banco',
          cash: 'icono de dinero',
        },
      },
      help: {
        title: 'Ayuda',
        faq: "FAQ's",
      },
    },
    priceTrend: {
      message: 'Tendencia de precios',
    },
    tableList: {
      numberOfResults: '{{count}} Resultados',
      rowsPerPage: 'Filas por página:',
      empty: 'Opss.. No se encontraron resultados',
    },
    fields: {
      country: 'País',
      provider: 'Provedor',
      status: 'Status',
      actions: 'Acciones',
      uploadFile: 'Subir archivo',
    },
    language: {
      english: 'Inglés',
      portuguese: 'Portugués',
      spanish: 'Español',
    },
    error: {
      server: 'Ops! Algo salio mal! :(',
      client: 'Ops! La acción solicitada no pudo ejecutarse',
      unathorized: 'No se puede verificar tus credenciales',
      documentNotSupported: 'El tipo de archivo no es soportado',
    },
  },
  dashboard: {
    title: 'Tablero',
    subtitle: 'Descripcion general',
    casesByChannel: 'Casos por analisis de ingreso',
    casesByDay: 'Casos creados por día',
    casesByHourAndChannel: 'Casos creados por hora y analisis de ingreso',
    casesNeedAgentByTime: 'Casos necesitando agente por tiempo',
    missingAgent: 'Necesitan agente',
    todayCases: 'Casos creados hoy',
    connectedAgents: 'Agentes conectados',
    sections: {
      importantNumbers: 'Números Importantes',
      needsAgent: 'Necesita Agente',
      needAgentByTeam: 'Casos que necesitan agente por equipo',
      needAgentByChannel: 'Casos que necesitan agente por canal',
      noDataAvailable: 'No hay datos disponibles',
      quickComparisons: 'Comparativas Rápidas',
      agentsStatus: 'Estado de Agentes',
      activityTrends: 'Tendencias de Actividad',
    },
    kpis: {
      availableAgents: 'Agentes disponibles',
      needAgentCases: 'Casos necesitan agente',
      callsOnHold: 'Llamadas en espera',
      avgEmailResponse: 'Promedio respuesta Email',
      avgWhatsappResponse: 'Promedio respuesta WhatsApp',
      noData: '-',
    },
    charts: {
      unassignedCasesByTeam: 'Casos sin asignar por equipo',
      avgResponseByChannel: 'Promedio de respuesta por canal (minutos)',
      casesByHourPattern: 'Promedio de casos abiertos por hora los {{day}}',
      casesByWeekday: 'Promedio de casos abiertos por día de semana',
    },
    comparatives: {
      casesResolved: 'Casos Resueltos',
      casesCreated: 'Casos Creados',
      whatsappConversations: 'Conversaciones WhatsApp',
      incomingCalls: 'Llamadas recibidas',
      todayVsYesterday: 'Hoy vs Ayer',
      thisWeekVsPrevious: 'Esta semana vs anterior',
      vs: 'vs',
      casesNeedingAgent: 'Casos que necesitan agente por tiempo',
      timeRanges: {
        '0-1': '1 hora o menos',
        '1-3': '1-3 horas',
        '3-8': '3-8 horas',
        '8-24': '8-24 horas',
        '24-48': '24-48 horas',
        '+48': 'Más de 48 horas',
      },
    },
    agentsStatus: {
      agentStates: 'Estados de Agentes',
      agentsList: 'Lista de Agentes',
      totalAgents: 'Total Agentes',
      updatedAgo: 'Actualizado hace {{time}}',
      noAgentsConnected: 'No hay agentes conectados',
    },
    trends: {
      weekday: 'Día de la semana',
      startDate: 'Fecha inicio',
      endDate: 'Fecha fin',
      weekdays: {
        monday: 'Lunes',
        tuesday: 'Martes',
        wednesday: 'Miércoles',
        thursday: 'Jueves',
        friday: 'Viernes',
        saturday: 'Sábado',
        sunday: 'Domingo',
      },
      weekdaysShort: {
        mon: 'Lun',
        tue: 'Mar',
        wed: 'Mié',
        thu: 'Jue',
        fri: 'Vie',
        sat: 'Sáb',
        sun: 'Dom',
      },
    },
    filters: {
      agencies: 'Agencias',
      teams: 'Equipos',
      channels: 'Canales',
      agency: 'Seleccionar Agencia',
      agencyPlaceholder: 'Todas las agencias',
      startDate: 'Fecha Desde',
      endDate: 'Fecha Hasta',
      withoutTeam: 'Sin equipo',
    },
    channels: {
      whatsapp: 'Whatsapp',
      call: 'Llamada',
      email: 'Email',
      externalIntegration: 'Integración Externa',
      manual: 'Manual',
      uploaded: 'Subido',
      supportForm: 'Formulario de Soporte',
    },
  },
  bookings: {
    view: {
      title: 'Booking',
      subtitle: 'Informacion de la reserva',
      bookingNumber: 'Reserva #',
      cancelBooking: 'Cancelar',
      issueBooking: 'Emitir',
      caseNumber: 'Caso #',
      quotationNumber: 'Cotizacion #',
      salesOrderNumber: 'Salesorder #',
      created: 'Fecha de creacion',
      passengers: 'Pasajeros',
      name: 'NOMBRES',
      lastname: 'APELLIDOS',
      document: 'DOCUMENTO',
      paxType: 'TIPO DE PAX',
      nightsIn: 'noches en',
      finalPrice: 'Valor final total',
    },
    title: 'Bookings',
    subtitle: 'Listado de bookings',
    table: {
      holder: 'Titular',
      paxQty: 'Pasajeros',
      destination: 'Destino',
      fareProvider: 'Proveedor de tarifa',
      serviceProvider: 'Proveedor de servicio',
      status: 'Estado',
      reservationCode: 'Reserva',
    },
    status: {
      open: 'abierto',
      pending: 'pendiente',
      failed: 'fallo',
      confirmed: 'confirmada',
      completed: 'completada',
      cancelled: 'cancelada',
      not_found: 'no encontrada',
      expired: 'expirada',
      unknown: 'desconocido',
    },
  },
  flights: {
    searcher: {
      ariaLabelSearcher: 'Motor de vuelos',
      oneWay: 'Solo ida',
      roundTrip: 'Ida y vuelta',
      multidestination: 'Multidestino',
      origin: 'Origen',
      destination: 'Destino',
      departureDate: 'Fecha de partida',
      arrivalDate: 'Fecha de retorno',
      go: 'Ida',
      return: 'Vuelta',
      unknownDates: 'Todavía no decido las fechas',
      economic: 'Economica',
      guest: 'Pasajero',
      search: 'Buscar',
      addSection: 'Añadir segmento',
      section: 'Tramo {{amount}}',
    },
    availabilityLayout: {
      editSearchTitle: 'Editar Busqueda',
      avatarAriaLabel: 'Icono Abatar de cama de Hotel',
      viewMapAriaLabel: 'boton abrir vista de mapa',
      tuneFiltersAriaLabel: 'Boton Abrir Filtros',
      result_one: 'resultado',
      result_other: 'resultados',
      viewMap: 'Ver mapa',
      loadingFlightsLegend: 'Estamos buscando las mejores ofertas de vuelo para vos.',
      loadingMoreFlights: 'Cargando más vuelos...',
      flightDetail: 'Detalle de vuelo',
      isReturn: 'vuelta',
      isStart: 'ida',
      totalDuration: 'Duración total',
      noFareDataAvailable: 'No hay data disponible de esta tarifa',
      noFares: 'No hay tarifas disponibles que concuerden con tu busqueda',
    },
    cardPackage: {
      direct: 'Directo',
      doubleBaseText: 'Valor por persona en dobles',
      fromText: 'Desde',
      reserveButtonText: 'Reservar',
      night_one: 'noche',
      night_other: 'noches',
      stop_one: 'Escala',
      stop_other: 'Escalas',
    },
    availabilityCard: {
      recommendedLabel: 'Recomendado',
    },
    booking: {
      purchaseDetails: 'Detalle de compra',
      total: 'total',
      continueBooking: 'continuar',
    },
    payment: {
      summary: 'Resumen de compra',
      total: 'Pago total',
      success: '¡Pago exitoso!',
      failed: 'Pago no exitoso',
      method: 'Medio de pago',
      yours: 'Tu pago',
      serviceFare: 'Tarifa de servicio',
      taxes: 'Impuestos',
      date: 'Fecha de pago',
    },
    voucher: {
      card: 'Tarjeta de embarque',
      localizer: 'Localizador de reserva',
      agency: 'Agencia',
      sits: 'Asientos',
      gohome: 'volver al home',
      gate: 'Puerta',
      terminal: 'Terminal',
      arrival: 'Llegada',
      departure: 'Salida',
    },
  },
  hotels: {
    farebreakDownModal: {
      title: 'Desgloce de la tarifa',
      netAmount: 'Importe neto',
      grossAmount: 'Importe bruto',
      included: 'incluido',
      excluded: 'a pagar en hotel',
      markup: 'Markup',
      fixed: 'fijo',
      total: 'Total',
    },
    rating: {
      opinion_one: '({{formattedCount}} opinión)',
      opinion_other: '({{formattedCount}} opiniones)',
      error: 'Se produjo un error al obtener la calificación del hotel. Contactá con el administrador del sistema.',
    },
    cancelPolicyModal: {
      title: 'Política de Cancelación',
      refundableFare: 'Tarifa reembolsable',
      penaltyNights: 'noche(s) de penalización',
      fromTotal: '% del total',
      fixedAmount: 'Importe fijo',
      unknownPenalty: 'Penalidad desconocida',
      limitDate: 'Aplica desde',
      penaltyTitle: 'Penalización por cancelación',
      additionalDetails: 'Detalles adicionales',
      dateCaluclatedByProvider: 'Origen de la fecha calculada por el proveedor',
      dateCaluclatedBySystem: 'Origen de la fecha calculada por el sistema',
    },
    availability: {
      fareCount: 'Hasta {{count}} opciones',
      noMarkup: 'Precio sin markup',
      loading: 'Cargando resultados..',
      empty: 'Uups, no se encontraron resultados. Por favor intenta de nuevo en algunos minutos.',
      error: 'Uups, algo salió mal. Por favor intenta de nuevo en algunos minutos.',
    },
    fares: {
      filters: {
        searchByName: 'Buscar por nombre',
        board: 'Board',
        provider: 'Proveedor',
        onlyRefundable: 'Solo reembolsables',
      },
      amenitites: 'Comodidades',
      showAllAmenitiesTrue: 'Mostrar todas las comodidades',
      showAllAmenitiesFalse: 'Ocultar todas las comodidades',
      showCompleteDescriptionTrue: 'Leer más',
      showCompleteDescriptionFalse: 'Ocultar despcripción',
      about: 'Acerca de este hotel',
      rooms: 'Selecciona tu opción',
      summary: 'Resumen de tu reserva',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      checkMinAge: 'Edad mínima para el check-in/check-out',
      checkInstructions: 'Instrucciones para check-in/check-out',
      remarks: 'Observaciones',
      paymentType: {
        MERCHANT: 'El pago es gestionado por el proveedor',
        DIRECT:
          'El pago se realiza directamente al beneficiario final (por ejemplo, el hotel), sin involucrar a un intermediario o tercero. El pago se completará al momento del check-in',
        CARD_BOOKING: 'El pago es gestionado por el proveedor. El pago se efectúa en el momento de la reserva',
        CARD_CHECK_IN: 'El pago es gestionado por el proveedor y se realiza en el hotel durante el check-in',
      },
      paxes: {
        title: 'Habitación para:',
        adult: 'Un adulto ({{age}} años)',
        children: 'Un niño ({{age}} años)',
      },
      room: {
        title: 'Habitación: ',
      },
      detail: {
        price: 'Precio: ',
        refundable: 'Reembolsable: ',
        paymentType: 'Método de pago: ',
      },
      hotelPaxData: {
        pax: {
          addInfo: 'Agregar información de pasajeros',
          useExisting: 'Usar pasajero existente',
        },
        name: {
          title: 'Nombre',
          required: 'El nombre es requerido.',
        },
        surname: {
          title: 'Apellido',
          required: 'El apellido es requerido.',
        },
        lastName: {
          title: 'Apellido',
          required: 'El apellido es requerido.',
        },
        birthDate: {
          title: 'Fecha de Nacimiento',
          required: 'La fecha de nacimiento es requerida.',
          notValid: 'Por favor ingrese una fecha de nacimiento válida.',
          notPast: 'La fecha de nacimiento no puede ser en el futuro.',
        },
        email: {
          title: 'Email',
          notValid: 'Por favor ingrese un email válido.',
        },
        phone: {
          title: 'Teléfono',
        },
        form: {
          age_one: '{{count}} año',
          age_other: '{{count}} años',
          index: 'Pasajero: {{count}}',
        },
      },
      cancelPolicy: {
        title: 'Políticas de cancelación',
        details: 'Ver detalles',
        deadline: 'Cancelación gratuita hasta',
        refundable: 'Reembolsable',
        nonRefundable: 'No reembolsable',
      },
      rateRules: {
        title: 'Reglas de tarifa:',
        values: {
          NORMAL: 'Normal',
          PACKAGE: 'Paquete',
          OLDER55: 'Mayores de 55 años',
          OLDER60: 'Mayores de 60 años',
          OLDER65: 'Mayores de 65 años',
          CANARY_RESIDENT: 'Residente canario',
          BALEARIC_RESIDENT: 'Residente balear',
          LARGE_FAMILY: 'Familia numerosa',
          HONEYMOON: 'Luna de miel',
          PUBLIC_SERVANT: 'Funcionario público',
          UNEMPLOYED: 'Desempleado',
          NON_REFUNDABLE: 'No reembolsable',
          MOBILE: 'Móvil',
          WARRANTY: 'Garantía',
          ESSENTIAL_WORKER: 'Trabajador esencial',
          NEGOTIATED: 'Negociado',
        },
      },
    },
    searcher: {
      title: 'Búsqueda de hoteles',
      destination: 'Destino',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      unknownDates: 'Todavía no decido las fechas',
      room: 'Habitaciones',
      guest: 'Huéspedes',
      search: 'Buscar',
      apply: 'Aplicar',
      hotels: 'Hoteles',
      locations: 'locations',
    },
    roomMenu: {
      roomCount: '{{count}} habitación',
      roomCount_other: '{{count}} habitaciones',
      adultCount: '{{count}} adulto',
      adultCount_other: '{{count}} adultos',
      childCount: '{{count}} menor',
      childCount_other: '{{count}} menores',

      title: 'Habitaciones y viajeros',
      distribute: 'Distribuí los viajeros de cada habitación.',
      summary: '{{rooms}} · {{adults}} · {{children}}',
      ageAtCheckIn: 'Edades al momento del check-in',
      addRoom: '+ Agregar habitación',
      removeRoom: 'Quitar habitación',
      cancel: 'Cancelar',
      adultAges: 'Edades de adultos',
      adultRange: '18 años o más',
      childRange: 'De 0 a 17 años',
      infantAge: 'Menos de 1 año: ingresá 0',
      invalidRooms: 'Revisá las edades: cada habitación requiere un adulto y admite hasta 4 viajeros.',

      roomAmount: 'Cantidad',
      room: 'Habitación',
      year: 'año',
      years: 'años',
      adults: 'Adultos',
      minors: 'Menores',
      apply: 'Aplicar',
      selected: '{{count}} habitación seleccionada',
      selected_other: '{{count}} habitaciones seleccionadas',
      minorAge: 'Edad del menor: {{index}}',
      adultAge: 'Edad del Adulto: {{index}}',
      yearsOld: '{{count}} año',
      yearsOld_other: '{{count}} años',
      lessThanOneYear: 'Menor de un año',
      error: 'Por favor revisá que todos los campos este correctamente completeados',
    },
    cardsDestination: {
      seeMore: 'Ver más',
      from: 'Desde',
    },
    cardPackage: {
      doubleBaseText: 'Valor por persona en base doble',
      fromText: 'Desde',
      reserveButtonText: 'Reservar',
      hotelRating: 'Hotel {{stars}} estrellas',
      nightsOfDuration: '{{amount}} noches',
    },
    filter: {
      filters: 'Filtros',
      orderByAriaLabel: 'Grupo de filtros para ordenar por',
      orderBy: 'Ordenar por',
      recommended: 'Recomendados',
      bestPrice: 'Mejor precio',
      moreReviews: 'Más opiniones',
      score: 'Puntuación',
      name: 'Nombre',
      searchDistanceAriaLabel: 'Deslizador de distancia de búsqueda',
      searchDistance: 'Distancia de búsqueda',
      radiusMessage: 'En un radio de',
      popularFiltersAriaLabel: 'Popular filters group',
      popularFilters: 'Grupo de filtros populares',
      allInclusive: 'All inclusive',
      oceanView: 'Ocean view',
      hotelResort: 'Hotel resort',
      hotel: 'Hotel',
      freeCancel: 'Cancelación gratis',
      noPaymentInAdvance: 'Sin pago por adelantado',
      priceAriaLabel: 'Slider de rango de precios',
      price: 'Precio',
      travelersExperienceAriaLabel: 'Grupo de filtros de experiencia de viajeros',
      travelersExperience: 'Experiencia de viajeros',
      lgbtq: 'LGBTQ',
      businessFriendly: 'Business friendly',
      reducedMobility: 'Movilidad reducida',
      onlyAdults: 'Only adults',
    },
    availabilityLayout: {
      editSearchTitle: 'Editar búsqueda',
      avatarAriaLabel: 'Icono ávatar de cama de hotel',
      viewMapAriaLabel: 'Botón para ver mapa',
      tuneFiltersAriaLabel: 'Botón para ajustar filtros',
      results: 'resultados',
      viewMap: 'Ver mapa',
    },
    availabilityCard: {
      opinions: '{{numberOfOpinions}} opiniones',
      endValueText: 'Valor final total desde',
      hotelRating: 'Hotel {{rating}} estrellas',
      allInclusiveLabel: 'All inclusive',
      recommendedLabel: 'Recomendado',
    },
    markupRules: {
      buttonNewRule: '+ NUEVA REGLA',
      buttonBackHome: 'Volver al home',
      shownElements: 'Elementos mostrados',
      listTitle: 'Listado de reglas',
      search: 'Buscador',
    },
    routingRules: {
      buttonNewRule: '+ NUEVA REGLA',
      buttonBackHome: 'Volver al home',
      shownElements: 'Elementos mostrados',
      listTitle: 'Listado de reglas',
      search: 'Buscador',
    },
    propertyMapDrawer: {
      hotelDetails: 'Detalles del hotel',
      value: 'Valor final total desde',
      reserveButton: 'Reservar',
    },
    propertyMapCard: {
      details: 'Detalles',
      opinions: 'Opiniones',
      reserveButton: 'Reservar',
      popularAmenities: 'Comodidades populares',
    },
    contentManager: {
      title: 'Contenido',
      subtitle: 'Listado de hoteles',
      search: 'Buscar hoteles..',
      error: 'Ha ocurrido un error obteniendo los hoteles.',
      status: {
        managed: 'Revisado',
        outdated: 'Desactualizado',
        toReview: 'Por Revisar',
      },
      fields: {
        id: 'Hotel ID',
        idSub: 'Internal ID: {{id}}',
        code: 'TGX ID',
        accessCode: 'Proveedor',
        name: 'Nombre',
        country: 'País',
        city: 'Ciudad',
        address: 'Dirección',
        impressions: '# Impresiones',
        status: 'Status',
        linked: 'Asociado',
        modParent: 'ID Padre',
        modParentName: 'Nombre del Padre',
        priority: 'Prioridad',
      },
      filters: {
        status: {
          managed: 'Administrado',
          outdated: 'Desactualizado',
          toReview: 'Revisar',
        },
      },
      configuration: {
        title: 'Configuración',
        tabs: {
          providers: {
            title: 'Proveedores',
          },
          imageTags: {
            title: 'Tags para imagenes',
          },
          updates: {
            title: 'Actualizacion',
          },
          amenities: {
            title: 'Amenities',
            subTitle: 'Listado de iconos de amenities disponibles',
            translationTo: 'Traducido al local actual',
          },
          amenitiesMapping: {
            title: 'Mapeo de Amenities',
            subTitle: 'Selecciona un proveedor y mapea los amenitites',
            notMapped: 'No hay amenities mapeadas todavía',
            mapped: 'Amenity mapeada correctamente',
          },
          categoriesMapping: {
            title: 'Mapeo de Categorías',
            subTitle: 'Selecciona un proveedor y mapea las categorías',
            notMapped: 'No hay categorías mapeadas todavía',
            mapped: 'Categoría mapeada correctamente',
          },
        },
        defaultValues: {
          description: 'Descripcion predeterminada',
          location: 'Ubicación predeterminada',
          rooms: 'Habitaciones predeterminadas',
          images: 'Imágenes predeterminadas',
          amenities: 'Amenities predeterminadas',
          updateSuccess: 'Valor predeterminado actualizado correctamente',
          updateError: 'Ha ocurrido un error actualizando el valor predeterminado',
          getError: 'Ha ocurrido un error obteniendo los valores predeterminados',
        },
      },
      detail: {
        title: 'Resumen de hotel',
        linkedHotels: {
          title: 'Hoteles asociados',
          manually: 'Link manually',
        },
        error: {
          detail: 'Ha ocurrido un error obteniendo el hotel seleccionado. Contactacte al administrador del sitio',
          detailInfo:
            'Ha ocurrido un error obteniendo información del hotel seleccionado. Contactacte al administrador del sitio',
        },
        description: {
          tab: 'Hotel',
          title: 'Mi descripción',
          editor: {
            name: {
              required: 'El nombre del hotel es obligatorio',
            },
            rating: {
              required: 'La calificación por estrellas es obligatoria',
            },
            descriptions: {
              required: 'La descripción es obligatoria',
              card: 'Descripción en la card',
              detail: 'Descripción del detalle',
            },
            generateByAI: 'Do you want to generate descriptions by AI?',
          },
          update: {
            success: 'Descripciones actualizadas correctamente',
            error: 'Ha ocurrido un error actualizando las descripciones. Contacte al administrador del sitio',
          },
        },
        checkOptions: {
          tab: 'Check In / Out',
          title: 'Check In / Check Out',
          editor: {
            addOptions: 'Agregar',
            type: {
              title: 'Tipo',
              checkIn: 'Check In',
              checkOut: 'Check Out',
            },
            minAge: {
              title: 'Edad mínima',
              required: 'La edad mínima es requerida.',
              error: 'Edad inválida.',
              value: '{{value}} años',
            },
            startTime: {
              title: 'Desde',
              required: 'La hora "desde" es requerida.',
              error: 'Hora inválida.',
              value: '{{value}} hs',
            },
            endTime: {
              title: 'Hasta',
              required: 'La hora "hasta" es requerida.',
              error: 'Hora inválida.',
              value: '{{value}} hs',
            },
            instructions: {
              title: 'Instrucciones',
              isSpecial: 'Es especial?',
              text: 'Texto',
              language: 'Idioma',
              edit: 'Editar instrucción',
            },
          },
          update: {
            success: 'Check In / Out actualizado correctamente',
            error:
              'Ha ocurrido un error actualizando las opciones de Check In / Out. Contacte al administrador del sitio',
          },
        },
        location: {
          tab: 'Location',
          title: 'Mi ubicación',
          showInMap: 'Usar ubicación',
          editor: {
            latLong: {
              required: 'La latitud y longitud son obligatorias',
              error: 'Formato de latitud y longitud inválido',
            },
          },
          update: {
            success: 'Ubicación actualizadas correctamente',
            error: 'Ha ocurrido un error actualizando la ubicación. Contacte al administrador del sitio',
          },
        },
        rooms: {
          tab: 'Habitaciones',
          title: 'Mis habitaciones',
          subTitle: 'Habitación {{code}}',
        },
        images: {
          tab: 'Imágenes',
          title: 'Imágenes del Hotel',
          tags: 'Etiquetas de la habitación',
          update: {
            success: 'Imágenes actualizadas correctamente',
            error: 'Ha ocurrido un error actualizando las imágenes. Contacte al administrador del sitio',
          },
        },
        amenities: {
          tab: 'Amenitites',
          title: 'Amenitites del Hotel',
          update: {
            success: 'Amenitites actualizadas correctamente',
            error: 'Ha ocurrido un error actualizando las amenities. Contacte al administrador del sitio',
          },
        },
        moderation: {
          link: {
            button: 'Asociar',
            success: 'Hotel asociado correctamente',
            error: 'Ha ocurrido un error asociando los hoteles. Contactacte al administrador del sitio',
          },
          unlink: {
            button: 'Desasociar',
            success: 'Hotel desasociado correctamente',
            error: 'Ha ocurrido un error desasociando los hoteles. Contactacte al administrador del sitio',
          },
          moderate: {
            button: "Marcar como '{{status}}'",
            success: "Hotel marcado como '{{status}}'",
            error: "Ha ocurrido un error marcando el hotel como '{{status}}'. Contactacte al administrador del sitio",
          },
          linked: {
            title: 'Asociado',
          },
        },
        priority: {
          label: 'Prioridad',
          success: 'Prioridad actualizada a {{priority}}',
          error: 'Ha ocurrido un error actualizando la prioridad',
        },
      },
    },
    amenitiesTitle: 'Comodidades',
    amenities: {
      LGBTQ: 'LGBTQ',
      ac: 'Aire acondicionado',
      allInclusive: 'All Inclusive',
      aquaGym: 'Aqua Gym',
      arte: 'Arte',
      azafata: 'Azafata',
      babyFriendly: 'Bebés',
      badminton: 'Bádminton',
      bakery: 'Panadería',
      barDeTragos: 'Bar de tragos',
      basketball: 'Básquetbol',
      beach: 'Playa',
      beerPaint: 'Cervecería',
      bicycle: 'Bicicletas',
      billar: 'Mesa de billar',
      botSail: 'Vela',
      breakfast: 'Desayuno incluido',
      brillos: 'Fuegos artificiales',
      brunch: 'Brunch',
      carRental: 'Alquiler de autos',
      cardFill: 'Tarjeta de crédito',
      casino: 'Casino',
      chefCocina: 'Chef',
      childCare: 'Guardería para niños',
      cleaningService: 'Servicio de limpieza',
      closet: 'Clóset',
      concierge: 'Conserje',
      conferenceRoom: 'Salón de conferencias',
      currencyExchange: 'Casa de cambio',
      deck: 'Deck',
      desfibrilator: 'Desfibrilador',
      doctor: 'Doctor',
      dryCleaning: 'Lavandería en seco',
      dryer: 'Secadora',
      eGames: 'eGames',
      ecoFriendly: 'Eco-friendly',
      edificio: 'Edificio',
      elevator: 'Ascensor',
      entertainment: 'Entretenimiento',
      family: 'Familiar',
      fireplace: 'Chimenea',
      girlGym: 'Gimnasia para mujeres',
      golf: 'Golf',
      grillBbc: 'Barbacoa',
      gym: 'Gimnasio',
      hairSaloon: 'Peluquería',
      jacuzzi: 'Jacuzzi',
      laundry: 'Lavandería',
      library: 'Librería',
      luggageCart: 'Carrito para valijas',
      meetingRoom: 'Sala de reuniones',
      mobileOk: 'Señal para móvil',
      moneyOff: 'Efectivo',
      multipleCard: 'Varias tarjetas',
      nightClub: 'Club nocturno',
      nightLife: 'Vida nocturna',
      parking: 'Estacionamiento',
      petfriendly: 'Pet friendly',
      phone: 'Teléfono',
      photocamara: 'Fotografía',
      pingPong: 'Ping Pong',
      pool: 'Piscina',
      poolTable: 'Mesa de pool',
      proyector: 'Proyector',
      restaurant: 'Servicio de restaurante',
      roomService: 'Servicio a la habitación',
      safeBox: 'Caja fuerte',
      sauna: 'Sauna',
      scubadiving: 'Buceo',
      securityCam: 'Cámaras de seguridad',
      seguridad: 'Seguridad',
      shop: 'Tienda',
      smokeDetector: 'Detector de humo',
      smokeFree: 'Libre de humo',
      smoking: 'Fumadores',
      solarium: 'Solárium',
      spa: 'Spa',
      sportsDeportes: 'Deportes',
      starFilled: 'Estrella',
      surf: 'Surf',
      tennis: 'Tenis',
      transfer: 'Traslados',
      tv: 'Televisión',
      valetParking: 'Valet parking',
      veggie: 'Vegetarianos',
      volley: 'Voleibol',
      volunteerActivism: 'Voluntariado',
      waterSki: 'Esquí acuático',
      wheelChair: 'Acceso para silla de ruedas',
      wifi: 'WiFi',
      notMappedYet: 'El amenity no ha sido mapeado aún.',
    },
    categories: {
      [HotelCategories.AGROTOURISM]: 'Agroturismo',
      [HotelCategories.ONE_STAR]: 'Una Estrella',
      [HotelCategories.ONE_KEY]: 'Una Llave',
      [HotelCategories.TWO_STARS]: 'Dos Estrellas',
      [HotelCategories.TWO_KEYS]: 'Dos Llaves',
      [HotelCategories.THREE_STARS]: 'Tres Estrellas',
      [HotelCategories.THREE_KEYS]: 'Tres Llaves',
      [HotelCategories.FOUR_STARS]: 'Cuatro Estrellas',
      [HotelCategories.FOUR_KEYS]: 'Cuatro Llaves',
      [HotelCategories.FOUR_STARS_LUXURY]: 'Cuatro Estrellas Lujo',
      [HotelCategories.FIVE_STARS]: 'Cinco Estrellas',
      [HotelCategories.FIVE_KEYS]: 'Cinco Llaves',
      [HotelCategories.FIVE_STARS_LUXURY]: 'Cinco Estrellas Lujo',
      [HotelCategories.ONE_STAR_APARTHOTEL]: 'Apartotel Una Estrella',
      [HotelCategories.TWO_STARS_APARTHOTEL]: 'Apartotel Dos Estrellas',
      [HotelCategories.THREE_STARS_APARTHOTEL]: 'Apartotel Tres Estrellas',
      [HotelCategories.FOUR_STARS_APARTHOTEL]: 'Apartotel Cuatro Estrellas',
      [HotelCategories.FIVE_STARS_APARTHOTEL]: 'Apartotel Cinco Estrellas',
      [HotelCategories.FIRST_CATEGORY_APARTMENT]: 'Apartamento de Primera Categoría',
      [HotelCategories.SECOND_CATEGORY_APARTMENT]: 'Apartamento de Segunda Categoría',
      [HotelCategories.THIRD_CATEGORY_APARTMENT]: 'Apartamento de Tercera Categoría',
      [HotelCategories.BED_AND_BREAKFAST]: 'Cama y Desayuno',
      [HotelCategories.THREE_STARS_BED_AND_BREAKFAST]: 'Cama y Desayuno Tres Estrellas',
      [HotelCategories.FOUR_STARS_BED_AND_BREAKFAST]: 'Cama y Desayuno Cuatro Estrellas',
      [HotelCategories.FIVE_STARS_BED_AND_BREAKFAST]: 'Cama y Desayuno Cinco Estrellas',
      [HotelCategories.BOUTIQUE]: 'Boutique',
      [HotelCategories.FIRST_CATEGORY_CAMPING]: 'Camping de Primera Categoría',
      [HotelCategories.SECOND_CATEGORY_CAMPING]: 'Camping de Segunda Categoría',
      [HotelCategories.GUESTHOUSE]: 'Casa de Huéspedes',
      [HotelCategories.ONE_AND_HALF_STARS]: 'Una Estrella y Media',
      [HotelCategories.SUPERIOR_TWO_STARS]: 'Dos Estrellas Superior',
      [HotelCategories.TWO_AND_HALF_STARS]: 'Dos Estrellas y Media',
      [HotelCategories.SUPERIOR_THREE_STARS]: 'Tres Estrellas Superior',
      [HotelCategories.THREE_AND_HALF_STARS]: 'Tres Estrellas y Media',
      [HotelCategories.FOUR_AND_HALF_STARS]: 'Cuatro Estrellas y Media',
      [HotelCategories.FIVE_AND_HALF_STARS]: 'Cinco Estrellas y Media',
      [HotelCategories.LUXURY_HISTORIC_HOTEL]: 'Hotel Histórico de Lujo',
      [HotelCategories.SUPERIOR_CATEGORY_RURAL_HOTEL]: 'Hotel Rural Categoría Superior',
      [HotelCategories.ONE_STAR_HOSTEL]: 'Hostal Una Estrella',
      [HotelCategories.TWO_STARS_HOSTEL]: 'Hostal Dos Estrellas',
      [HotelCategories.THREE_STARS_HOSTEL]: 'Hostal Tres Estrellas',
      [HotelCategories.FOUR_STARS_HOSTEL]: 'Hostal Cuatro Estrellas',
      [HotelCategories.FIVE_STARS_HOSTEL]: 'Hostal Cinco Estrellas',
      [HotelCategories.ONE_STAR_RURAL_HOSTEL]: 'Hostal Rural Una Estrella',
      [HotelCategories.TWO_STARS_RURAL_HOSTEL]: 'Hostal Rural Dos Estrellas',
      [HotelCategories.LODGE]: 'Lodge',
      [HotelCategories.MINI_HOTEL]: 'Mini Hotel',
      [HotelCategories.PENDING_CATEGORY]: 'Categoría Pendiente',
      [HotelCategories.PENSION]: 'Pensión',
      [HotelCategories.POUSADA]: 'Posada',
      [HotelCategories.RESIDENCE]: 'Residencia',
      [HotelCategories.RESORT]: 'Resort',
      [HotelCategories.WITHOUT_OFFICIAL_CATEGORY]: 'Sin Categoría Oficial',
      [HotelCategories.STANDARD]: 'Estándar',
      [HotelCategories.FOUR_SUPERIOR_STARS]: 'Cuatro Estrellas Superior',
      [HotelCategories.VILLA]: 'Villa',
      [HotelCategories.VACATION_TOURIST_HOMES]: 'Viviendas Turísticas Vacacionales',
    },
    hotelImageTag: {
      title: 'Tags',
      subtitle: 'Tags disponibles',
      results: 'Resultados',
      search: 'Buscar',
      table: {
        name: 'Nombre',
        color: 'Color',
      },
      create: {
        createdSuccess: 'Tag creado',
        createdError: 'Ocurrio un error al crear el tag',
        title: 'Crear Tag',
        name: 'Nombre',
        color: 'Color',
      },
      edit: {
        createdSuccess: 'Tag actualizado',
        createdError: 'Ocurrio un error al actualizar el tag',
        title: 'Editar tag',
        name: 'Nombre',
        color: 'Color',
      },
      delete: {
        success: 'Tag eliminada',
        error: 'Ocurrió un error al eliminar el tag',
        title: 'Eliminar tag',
        message: 'Seguro desear eliminar: {{ name }}?',
      },
    },
    paymentPolicies: {
      nonAnticipate: 'Sin pago adelantado',
    },
    cancelationPolicies: {
      free: 'Cancelación gratis',
    },
  },
  users: {
    results: 'resultados',
    search: 'Buscar usuario',
    create: {
      title: 'Crear usuario',
      createdError: 'Error al crear el usuario',
      warning: 'Esta es la única vez donde se va a mostrar el password! Guárdalo bien!.',
      user: 'Usuario:',
      password: 'Password:',
      finish: 'Terminar',
    },
    selector: {
      title: 'Selección de usuarios',
    },
    list: {
      title: 'Usuarios',
      subtitle: 'Listado de usuarios',
    },
    table: {
      name: 'Nombre Completo',
      email: 'Email',
      agency: 'Agencia',
      roles: 'Roles',
      client: 'Vista como cliente',
    },
    view: {
      teams: 'equipos',
    },
  },
  clients: {
    selector: {
      title: 'Selector de Cliente',
    },
    title: 'Clientes',
    subtitle: 'Lista de clientes',
    results: 'Resultados',
    search: 'Buscar',
    table: {
      name: 'Nombre',
      email: 'Correo',
      phone: 'Teléfono #',
      agency: 'Agencia',
      whatsapp: 'WhatsApp #',
      client: 'Cliente',
      contact: 'Contacto',
      preferredAgent: 'Agente Preferido',
      organization: 'Organización',
      location: 'Ubicación',
      created: 'Creado',
    },
    filters: {
      clientName: 'Nombre del Cliente',
      countries: 'Países',
      organizations: 'Organizaciones',
      agencies: 'Agencias',
      preferredAgent: 'Agente Preferido',
      documentTypes: 'Tipos de Documento',
      searchClientNamePlaceholder: 'Buscar por nombre o apellido',
      myClients: 'Ver solo mis clientes',
    },
    view: {
      title: 'Información del Cliente',
      agencyInfo: 'Información de Agencia',
      basicInfo: 'Información Básica',
      contactInfo: 'Información de Contacto',
      addressInfo: 'Información de Dirección',
      documentInfo: 'Información de Documento',
      agency: 'Agencia',
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo electrónico',
      phoneCountryCode: 'Código de País',
      phoneNumber: 'Número de Teléfono',
      whatsappNumber: 'Número de WhatsApp',
      country: 'País',
      city: 'Ciudad',
      postalCode: 'Código Postal',
      address1: 'Dirección',
      address2: 'Dirección (línea 2)',
      documentType: 'Tipo de Documento',
      documentNumber: 'Número de Documento',
      clientSince: 'Cliente desde',
      basicInfoSuccess: 'Información básica actualizada',
      contactInfoSuccess: 'Información de contacto actualizada',
      addressInfoSuccess: 'Información de dirección actualizada',
      documentInfoSuccess: 'Información de documento actualizada',
      createdError: 'Hubo un error al actualizar la información',
      preferredAgent: 'Agente preferido',
      selectPreferredAgent: 'Seleccionar agente preferido',
    },
    errors: {
      DUPLICATED_PHONE_ERROR: 'El teléfono ya está registrado para la Agencia seleccionada',
      DUPLICATED_EMAIL_ERROR: 'El correo ya está registrado para la Agencia seleccionada',
      DUPLICATED_WHATSAPP_ERROR: 'El número de WhatsApp ya está registrado para la Agencia seleccionada',
      MISSING_FIELDS_ERROR: 'Debes proporcionar un correo, teléfono o número de WhatsApp',
    },
    create: {
      createdSuccess: 'Cliente creado exitosamente',
      createdError: 'Hubo un error al crear el cliente',
      createdErrorPhone: 'El teléfono ya está registrado para la Agencia seleccionada',
      createdErrorEmail: 'El correo ya está registrado para la Agencia seleccionada',
      createdErrorWhatsapp: 'El número de WhatsApp ya está registrado para la Agencia seleccionada',
      createdErrorMissingFields: 'Debes proporcionar un correo, teléfono o número de WhatsApp',
      title: 'Crear Cliente',
      firstName: 'Nombre',
      agency: 'Agencia',
      lastName: 'Apellido',
      email: 'Correo electrónico',
      phoneNumber: 'Teléfono',
      phoneCountryCode: 'Código de País',
      country: 'País',
      city: 'Ciudad',
      postalCode: 'Código Postal',
      documentType: 'Tipo de Documento',
      documentNumber: 'Número de Documento',
      address1: 'Dirección',
      address2: 'Dirección (línea 2)',
      whatsappNumber: 'WhatsApp',
    },
    edit: {
      whatsappNumber: 'WhatsApp',
      createdSuccess: 'Cliente actualizado exitosamente',
      createdError: 'Hubo un error al actualizar el cliente',
      title: 'Actualizar Cliente',
      firstName: 'Nombre',
      agency: 'Agencia',
      lastName: 'Apellido',
      email: 'Correo electrónico',
      phoneNumber: 'Teléfono',
      phoneCountryCode: 'Código de País',
      country: 'País',
      city: 'Ciudad',
      postalCode: 'Código Postal',
      documentType: 'Tipo de Documento',
      documentNumber: 'Número de Documento',
      address1: 'Dirección',
      address2: 'Dirección (línea 2)',
    },
  },
  workflows: {
    title: 'Flujos de trabajo',
    subtitle: 'Listado de flujos de trabajo',
    results: 'Resultados',
    search: 'Buscar',
    form: {
      name: 'Nombre',
      color: 'Color',
      domains: 'Dominios',
      domainsHint: 'Puedes agregar dominios o emails completos, ejemplo: *@acme.com o john.doe@acme.com',
      error: {
        invalidEmailDomain: 'El dominio {{ emailDomainValue }} no es válido',
      },
    },
    selectedStep: {
      title: 'Detalle del paso',
      label: 'Nombre del paso',
      info: 'Información del paso',
      delete: 'Eliminar paso',
      teams: 'Equipos',
      mailTemplate: 'Plantilla de correo',
      isCancelStepLabel: 'Paso de cancelación?',
      cancelStepExists: 'Ya existe un paso de cancelación',
    },
    instructions: {
      title: 'Instrucciones para {{step}}',
      save: 'Guardar',
      close: 'Cerrar',
      tabs: {
        edit: 'Edición',
        preview: 'Previsualización',
      },
    },
    actions: {
      title: 'Acciones',
      filters: 'Filtros',
      settings: 'Configuraciones',
      add: 'Agregar',
    },
    table: {
      name: 'Nombre',
      color: 'Color',
      emailDomains: 'Dominios de email',
    },
    view: {
      addInitialStep: 'Agregar paso inicial',
      addMiddleStep: 'Agregar paso intermedio',
      addFinalStep: 'Agregar paso final',
      agency: 'Agencia',
      color: 'Color',
      created: 'Creado',
      updatedSuccess: 'Flujo de trabajo actualizado',
    },
    edit: {
      title: 'Editar Flujo de trabajo',
      error: 'Ocurrió un error al actualizar el flujo de trabajo',
      success: 'Flujo de trabajo actualizado',
      unsavedChanges: 'Hay cambios sin guardar. Quieres guardarlos antes de salir?',
    },
    create: {
      title: 'Crear flujo de trabajo',
      error: 'Ocurrió un error al crear el flujo de trabajo',
      success: 'Flujo de trabajo creado!',

      step: {
        name: 'Nombre',
        title: 'Crear paso',
        color: 'Color',
        teams: 'Equipos',
      },
    },
  },
  agencies: {
    title: 'Agencias',
    subtitle: 'Listado de agencias',
    results: 'Resultados',
    search: 'Buscar',
    view: {
      dashboard: 'Dashboard',
      caseHandlers: 'Manejadores de casos',
      generalSettings: 'Configuración General',
      teams: 'Equipos',
      communications: 'Comunicaciones',
      callsMenu: 'Menú de llamadas',
      iaConfig: 'Configuración de IA',
      whatsappSettings: 'Configuración de Whatsapp',
      caseTriggers: 'Disparadores de casos',
      uploads: 'Subir data',
      workflows: 'Flujos de trabajo',
      organizations: 'Organizaciones',
      settings: 'Configuracion',
      supportForms: 'Support Forms',
      flights: 'Aire',
      hotels: 'Hoteles',
      markupRules: 'Reglas de Markup',
      routingRules: 'Reglas de Ruteo',
      invalidationRules: 'Reglas de invalidación',
      integrations: 'Integraciones',
      customFields: 'Campos Personalizados',
      webhooks: 'Webhooks',
      metaAds: 'Meta Ads',
    },
    settings: {
      twilio: 'Twilio',
      saveSuccess: 'Settings guardados',
      saveError: 'Error al guardar los settings',
      general: 'General',
      auth: 'Autenticación',
      communicationChannels: 'Canales de communicación',
      maps: 'Mapas',
      whitelabeling: 'Etiqueta blanca',
      aws: 'AWS',
      sendgrid: 'Sendgrid',
      gmail: 'OAuth2 SMTP de Gmail',
      googleMaps: 'Google Maps',
      callsMenu: 'Menú de llamadas',
      whatsappSettings: 'Configuración de Whatsapp',
      phone: 'Telefonía',
      email: 'Correo',
      googleChat: 'Google Chat',
      googleSignIn: 'Google Sign-in',
      registration: 'Registro',
      whatsapp: 'Whatsapp (Gupshup)',
      whatsappSubscriptionError: 'Error al crear subscripcion',
      emailSignature: 'Firma de correo',
      openai: 'OpenAI',
      ai: 'Inteligencia Artificial',
      hotels: 'Hotels',
      placeholders: {
        selectAIUser: 'Selecciona un usuario IA',
        noUsersFound: 'No se encontraron usuarios',
        contextMessages: '10',
      },
      envMap: {
        AI_CASE_HANDLERS_ENABLED: 'Habilitar IA para manejadores de casos',
        IA_USER_ID: 'ID de Usuario IA',
        TWILIO_ACCOUNT_SID: 'Account SID',
        TWILIO_AUTH_TOKEN: 'Authorization Token',
        TWILIO_API_KEY: 'API KEY',
        TWILIO_API_KEY_SECRET: 'Api KEY secret',
        TWILIO_TWIML_APP_SID: 'Twiml app SID',
        TWILIO_PHONE_NUMBER: 'Numero de telefono',
        TWILIO_TRUNK_SID: 'Twilio trunk SID',
        JWT_SECRET: 'JWT secret',
        DEFAULT_WORKFLOW_ID: 'Default workflow Id',
        WHATSAPP_DEFAULT_WORKFLOW_ID: 'Flujo de trabajo predeterminado Whatsapp',
        WHATSAPP_PREFERRED_AGENT_WORKFLOW_ID: 'Flujo de trabajo para agente preferido WhatsApp',
        REFRESH_JWT_SECRET: 'JWT refresh token secret',
        JWT_RESET_PASSWORD: 'JWT reset pwd token secret',
        WHITELABEL_CODE: 'Codigo de Whitelabel',
        AWS_REGION: 'Region',
        AWS_ACCESS_KEY_ID: 'Access Key Id',
        AWS_SECRET_ACCESS_KEY: 'Secret Access Key',
        AWS_S3_ENDPOINT: 'S3 endpoint',
        AWS_S3_BUCKET_EMAIL_ATTACHMENTS: 'S3 bucket mail attachments',
        SENDGRID_API_KEY: 'API Key',
        SENDGRID_SENDER_EMAIL: 'Mail emisor',
        SENDGRID_INBOUND_MAILS: 'Casillas gestionadas',
        VITE_GOOGLE_KEY: 'Google Key',
        VITE_MAP_ID: 'Map Id',
        GOOGLE_CLIENT_ID: 'Client ID',
        GOOGLE_CLIENT_SECRET: 'Client Secret',
        GOOGLE_CALLBACK_URL: 'Callback URL',
        GMAIL_OAUTH_CLIENT_ID: 'ID de cliente OAuth de Gmail',
        GMAIL_OAUTH_CLIENT_SECRET: 'Secreto de cliente OAuth de Gmail',
        GMAIL_OAUTH_REFRESH_TOKEN: 'Token de actualizacion OAuth de Gmail',
        CLIENT_URL: 'Client URL',
        GUPSHUP_AUTH_SECRET: 'Auth Secret',
        GUPSHUP_AUTH_USER: 'Mail de login',
        MAIL_CREDENTIAL: 'Credenciales de email',
        GUPSHUP_AUTH_TOKEN: 'Auth Token',
        GUPSHUP_APP_ID: 'ID de applicación',
        GUPSHUP_PARTNER_API_URL: 'Partner Api URL',
        GUPSHUP_APP_NAME: 'Nombre de aplicación',
        GUPSHUP_PHONE_NUMBER: 'Número telefónico',
        GUPSHUP_SENDER_NAME: 'Nombre de quién envía el mensaje',
        GUPSHUP_API_KEY: 'API Key',
        GOOGLE_CHAT_CLIENT_EMAIL: 'Client Email',
        GOOGLE_CHAT_PRIVATE_KEY: 'Private Key',
        ALLOWED_EMAIL_DOMAIN: 'Dominio de email permitido para acceder',
        VITE_MANUAL_REGISTRATION_ALLOWED: 'Registro manual activado? (true/false)',
        WHATSAPP_OPENAI_API_KEY: 'Clave API de OpenAI',
        WHATSAPP_OPENAI_AMOUNT_OF_CONTEXT_MESSAGES: 'Cantidad de mensajes de contexto para la IA',
        COPILOT_AGENCY_CONTEXT: 'Contexto de la agencia (negocio, tono, mercado)',
        COPILOT_PROVIDER: 'Proveedor de IA',
        COPILOT_PASSIVE_MODEL: 'Modelo pasivo (análisis por mensaje)',
        COPILOT_ACTIVE_MODEL: 'Modelo activo (sugerencias de respuesta)',
        COPILOT_API_KEY: 'Clave API del copiloto',
        TRAVEL_INTELLIGENCE_BUSINESS_UNIT:
          'Inteligencia de viaje — Business unit (ej: UY)',
        TRAVEL_INTELLIGENCE_ORIGIN_COUNTRY:
          'Inteligencia de viaje — País de origen (ISO, ej: UY)',
        TRAVEL_INTELLIGENCE_PASSPORT_COUNTRY:
          'Inteligencia de viaje — País de pasaporte (ISO, ej: UY)',
        TRAVEL_INTELLIGENCE_CURRENCY:
          'Inteligencia de viaje — Moneda (ISO, ej: USD)',
        HOTEL_BOOK_AGENCY_REFERENCE: 'Prefijo de referencia de reserva de hoteles',
        HOTEL_BOOK_MINOR_AGE_DELIMITER: 'Determinar edade de menores',
      },
    },
    table: {
      name: 'Nombre',
      currency: 'Moneda',
      country: 'Pais',
      isPrivate: 'Es un sitio privado',
    },
    create: {
      createdSuccess: 'Agencia creada!',
      createdError: 'Ocurrio un error al crear la agencia',
      title: 'Crear Agencia',
      name: 'Nombre',
      country: 'Pais',
      currency: 'Moneda',
      isPrivate: 'Es un sitio privado',
    },
    edit: {
      createdSuccess: 'Agencia actualizada!',
      createdError: 'Ocurrió un error al actualizar la agencia',
      title: 'Editar Agencia',
      name: 'Nombre',
      country: 'País',
      currency: 'Moneda',
      isPrivate: 'Es un sitio privado',
    },
  },
  caseHandlers: {
    title: 'Manejadores de casos',
    subtitle: 'Listado de manejadores de casos',
    results: 'Resultados',
    search: 'Buscar',
    table: {
      name: 'Nombre',
      description: 'Descripción',
      enabled: 'Habilitado',
      scanWorkflow: 'Flujo de escaneo',
      scanStep: 'Paso de escaneo',
      scanStatus: 'Estado de escaneo',
      nextWorkflow: 'Siguiente flujo',
      nextStep: 'Siguiente paso',
      nextStatus: 'Siguiente estado',
      channel: 'Canal',
    },
    edit: {
      title: 'Editar Manejador de Casos',
      success: 'Manejador actualizado exitosamente',
      error: 'Ocurrió un error al actualizar el manejador',
    },
    create: {
      title: 'Crear Manejador de Casos',
      success: 'Manejador creado exitosamente',
      error: 'Ocurrió un error al crear el manejador',
    },
    form: {
      name: 'Nombre',
      namePlaceholder: 'Ingrese el nombre del manejador',
      description: 'Descripción',
      descriptionPlaceholder: 'Ingrese una descripción opcional',
      messageContextHistoryCount: 'Cantidad de contexto',
      enabled: 'Habilitado',
      channel: 'Canal',
      channelPlaceholder: 'Ingrese el canal (opcional)',
      scanStatus: 'Estado de escaneo',
      scanStatusPlaceholder: 'Ingrese el estado de escaneo (opcional)',
      nextStatus: 'Siguiente estado',
      nextStatusPlaceholder: 'Ingrese el siguiente estado (opcional)',
      scanWorkflow: 'Workflow de escaneo',
      scanWorkflowPlaceholder: 'Seleccione workflow de escaneo',
      scanStep: 'Paso de escaneo',
      scanStepPlaceholder: 'Seleccione paso de escaneo',
      nextWorkflow: 'Siguiente workflow',
      nextWorkflowPlaceholder: 'Seleccione siguiente workflow',
      nextStep: 'Siguiente paso',
      nextStepPlaceholder: 'Seleccione siguiente paso',
      prompt: 'Prompt',
      promptPlaceholder: 'Ingrese el prompt del manejador',
      listeningTo: 'Escuchando',
      onSuccess: 'En caso de éxito',
      onBailout: 'En caso de bailout',
      onCancel: 'En caso de cancelación',
      promptSection: 'Prompt',
      // Nuevas traducciones para los campos del IA Handler
      iaHandlerConfiguration: 'Configuración del Handler IA',
      handlerPurpose: 'Propósito del Handler',
      handlerPurposePlaceholder: 'Describe el propósito específico de este handler...',
      behaviorRules: 'Reglas de Comportamiento',
      behaviorRulesPlaceholder: 'Define las reglas específicas de comportamiento...',
      stepsDescription: 'Descripción de Pasos',
      stepsDescriptionPlaceholder: 'Describe los pasos que debe seguir...',
      examples: 'Ejemplos',
      handlerExample: 'Ejemplo de Resultado',
      handlerExamplePlaceholder: 'Proporciona un ejemplo del resultado esperado...',
      conversationExample: 'Ejemplo de Conversación',
      conversationExamplePlaceholder: 'Muestra un ejemplo de conversación...',
      validationsAndNotes: 'Validaciones y Notas',
      validations: 'Validaciones',
      validationsPlaceholder: 'Define las validaciones requeridas...',
      allowedTools: 'Herramientas Permitidas',
      allowedToolsPlaceholder: 'Selecciona las herramientas que puede usar este handler',
      additionalNotes: 'Notas Adicionales',
      additionalNotesPlaceholder: 'Agrega cualquier nota adicional importante...',
      // Tabs labels
      tabs: {
        listening: 'Escuchando',
        handlePurpose: 'Propósito del Handler',
        behaviourRules: 'Reglas de Comportamiento',
        steps: 'Pasos',
        resultExamples: 'Ejemplos de Resultados',
        conversationExamples: 'Ejemplos de Conversación',
        validations: 'Validaciones',
        additionalNotes: 'Notas Adicionales',
      },
    },
  },
  organizations: {
    title: 'Organizaciones',
    subtitle: 'Organizaciones disponibles',
    results: 'Resultados',
    search: 'Buscar',
    table: {
      name: 'Nombre',
      domain: 'Dominio',
      agency: 'Agencia',
      memberCount: 'Cantidad de miembros',
    },
    create: {
      createdSuccess: 'Organización creada',
      createdError: 'Ocurrió un error al crear organización',
      title: 'Crear Organización',
      name: 'Nombre',
      domain: 'Dominio',
    },
    edit: {
      createdSuccess: 'Organización actualizada correctamente',
      createdError: 'Ocurrio un error al actualizar la organización',
      title: 'Editar Organización',
      name: 'Nombre',
      domain: 'Dominio',
    },
    domainError: 'Ingresa un domino válido (e.g. @tudominio.com)',
    members: 'miembros',
    linkUserToOrganization: {
      success: 'Usuario asociado correctamente',
      failed: 'Un problema al asociar al usuario',
      removed: 'Usuario removido de la organización',
      removedFailed: 'Ocurrio un error al remover el usuario',
      removeToolip: 'Remover de la organización',
    },
    selector: {
      add: 'agregar',
      title: 'Seleccion de Organización',
    },
  },
  teams: {
    title: 'Equipos',
    subtitle: 'Equipos disponibles',
    results: 'Resultados',
    search: 'Buscar',
    table: {
      name: 'Nombre',
      email: 'Email',
      agency: 'Agencia',
      color: 'Color',
      isAvailableInPhone: 'atiende llamadas ',
    },
    create: {
      createdSuccess: 'Equipo creado',
      createdError: 'Ocurrio un error al crear el equipo',
      title: 'Crear Equipo',
      name: 'Nombre',
      agency: 'Agencia',
      color: 'Color',
    },
    edit: {
      createdSuccess: 'Equipo actualizado',
      createdError: 'Ocurrio un error al actualizar el equipo',
      title: 'Editar Equipo',
      name: 'Nombre',
      agency: 'Agencia',
      color: 'Color',
    },
    members: 'miembros',
    linkUserToTeam: {
      success: 'Usuario asociado correctamente',
      failed: 'Un problema al asociar al usuario',
      removed: 'Usuario Removido del equipo',
      removedFailed: 'Ocurrio un error al Remover el usuario',
      removeToolip: 'Remover del equipo',
    },
  },
  error404: {
    message: 'La pagina que buscas no se encontro',
    btnLabel: 'Volver al incio',
  },
  error401: {
    message: 'Acceso no autorizado.',
    btnLabel: 'Volver al incio',
  },
  linkCaseModal: {
    newCase: 'Nuevo caso',
    linkedTo: 'Relacionar con',
    duplicates: 'Duplica a',
    linkSuccess: 'Caso linkeado exitosamente',
    linkError: 'Fallo al linkear el caso',
    selectCaseError: 'Precisas selecionar un caso',
    searchTextLabel: 'Buscá un caso',
  },
  travelers: {
    title: 'Viajeros del caso',
    subtitle: 'Prepará una sola vez los datos que vas a usar al reservar.',
    search: 'Buscar por nombre o documento',
    birthDateValue: 'Nacimiento: {{date}}',
    noBirthDate: 'Fecha de nacimiento sin cargar',
    summary: {
      title: 'Viajeros',
      count: '{{count}} viajero',
      count_other: '{{count}} viajeros',
      more: 'y más',
    },
    sections: {
      roster: 'En este caso ({{count}})',
      rosterHint: 'Son las personas disponibles para las reservas de este viaje.',
      known: 'Conocidos del cliente ({{count}})',
      knownHint: 'Agregalos sólo cuando participen de este viaje.',
    },
    actions: {
      manage: 'Administrar viajeros',
      create: 'Crear viajero',
      addToCase: 'Agregar al caso',
      remove: 'Quitar del caso',
    },
    fields: {
      title: 'Tratamiento',
      firstName: 'Nombre',
      lastName: 'Apellido',
      birthDate: 'Fecha de nacimiento',
      email: 'Email',
      phone: 'Teléfono',
      nationality: 'Nacionalidad',
      countryOfResidence: 'País de residencia',
    },
    documents: {
      title: 'Documentos',
      add: 'Agregar documento',
      remove: 'Quitar documento',
      type: 'Tipo',
      country: 'País emisor',
      number: 'Número',
      expiresOn: 'Vencimiento',
      types: {
        passport: 'Pasaporte',
        ci: 'Cédula de identidad',
        dni: 'DNI',
      },
      privateHint: 'El número completo sólo se muestra dentro de este formulario.',
      maskedHint: 'Número oculto por seguridad',
    },
    form: {
      createTitle: 'Nuevo viajero',
      editTitle: 'Editar viajero',
    },
    validation: {
      required: 'Este dato es obligatorio',
      email: 'Ingresá un email válido',
      phone: 'Ingresá un teléfono internacional válido',
      country: 'Elegí un país de la lista',
    },
    states: {
      unavailable: 'No pudimos cargar el resumen de viajeros.',
      loadError: 'No pudimos cargar los viajeros. Reintentá.',
      suggestionsError: 'No pudimos cargar los viajeros conocidos.',
      noPermission: 'No tenés permisos para administrar viajeros de este caso.',
      noClient: 'Asigná un cliente al caso para crear viajeros o reutilizar personas conocidas.',
      emptyRoster: 'Todavía no hay viajeros en este caso.',
      emptySuggestions: 'No hay otros viajeros conocidos para sugerir.',
      noResults: 'No encontramos viajeros para esta búsqueda.',
    },
    feedback: {
      saved: 'Datos del viajero guardados',
      saveError: 'No pudimos guardar los datos del viajero.',
      added: '{{name}} fue agregado al caso',
      addError: 'No pudimos agregar el viajero al caso.',
      removed: 'El viajero fue quitado del caso',
      removeError: 'No pudimos quitar el viajero del caso.',
    },
    remove: {
      title: 'Quitar viajero del caso',
      description: '¿Querés quitar a {{name}} de este caso?',
      keepProfile: 'Sus datos seguirán asociados al cliente para poder sugerirlos en viajes futuros.',
    },
  },
  cases: {
    status: {
      [CaseStatus.open]: 'abierto',
      [CaseStatus.inProgress]: 'en progreso',
      [CaseStatus.needsClientAction]: 'esperando respuesta',
      [CaseStatus.needsAgentAction]: 'necesita agente',
      [CaseStatus.done]: 'completado',
      [CaseStatus.canceled]: 'cancelado',
      any: 'Cualquier estado (por defecto: abierto)',
    },
    originatedByChannel: {
      [OriginatedByChannel.WHATSAPP]: 'WhatsApp',
      [OriginatedByChannel.CALL]: 'Llamada',
      [OriginatedByChannel.EMAIL]: 'Correo electrónico',
      [OriginatedByChannel.MANUAL]: 'Manual',
      [OriginatedByChannel.EXTERNAL_INTEGRATION]: 'Integración externa',
      [OriginatedByChannel.UPLOADED]: 'Upload',
      [OriginatedByChannel.SUPPORT_FORM]: 'Formulario de soporte',
    },
    stats: {
      byDay: 'Casos por día',
      count: 'Número de casos',
      date: 'Fecha',
      byTeam: 'Casos por equipo',
      byStatus: 'Casos por estado',
      byWorkflow: 'Casos por workflow',
      noTeam: 'Sin equipo',
      noWorkflow: 'Sin asignar',
    },
    statistics: {
      title: 'Estadísticas de Casos',
      byAgent: 'Casos por Agente',
      byTeam: 'Casos por Equipo',
      byAgency: 'Casos por Agencia',
      byChannel: 'Casos por Canal',
      byStatus: 'Casos por Estado',
      byWorkflow: 'Casos por Flujo',
      byStep: 'Casos por Paso',
    },
    export: {
      csvButton: 'Generar reporte CSV (recibirás un email cuando esté listo)',
      processingMessage: 'Reporte de casos en proceso. Recibirás un email cuando esté listo.',
      errorMessage: 'Hubo un error al generar el reporte',
    },
    create: {
      createdSuccess: 'Case creado exitosamente',
      createdError: 'Ocurrió un error al crear el caso',
      placeholder: 'Ingrese un asunto para el caso...',
      agency: 'Agencia',
      client: 'Cliente',
    },
    update: {
      success: 'Caso actualzado',
      error: 'Ocurrió un error al actualizar el caso',
    },
    list: {
      bulk: {
        title: 'Edicion masiva',
        selectedCount: '{{count}} seleccionados',
        clear: 'Limpiar',
        apply: 'Aplicar',
        leaveUnchanged: 'Sin cambios',
        unassigned: 'Sin asignar',
        workflow: 'Flujo',
        step: 'Paso',
        status: 'Estado',
        agent: 'Agente',
        updatedSuccess: 'Actualizados {{count}} casos',
        updatedError: 'Error al actualizar casos',
        workflowRequired: 'Selecciona un flujo antes de elegir un paso',
        noChanges: 'Selecciona al menos un campo para actualizar',
      },
      filters: {
        status: 'Status',
        title: 'Filtros',
        name: 'Nombre del filtro',
        placeHolderNew: 'Ingrese nombre del nuevo filtro',
        placeHolderExisting: 'Editar nombre del filtro',
        owner: 'Autor',
        myFilters: 'Mis Filtros',
        publicFilters: 'Filtros Públicos',
        checkbox: 'Marcar como público',
        clear: 'Limpiar',
        save: 'Guardar',
        createNew: 'Crear Nuevo',
        createError: 'Error al crear fitlro',
      },
      filterByStatus: 'Filtrar por estado',
      filterByTeam: 'Filtrar por equipo',
      filterByWorkflow: 'Filtrar por flujo',
      filterByStep: 'Filtrar por paso',
      filterByAgent: 'Filtrar por agente',
      filterByClient: 'Filtrar por cliente',
      filterByOrganization: 'Filtrar por organizacion',
      filterBySubject: 'Filtrar por asunto',
      filterByUtmSource: 'Filtrar por UTM source',
      filterByUtmCampaign: 'Filtrar por UTM campaign',
      filterByAdId: 'Filtrar por ID de anuncio',
      filterByOriginatedByChannel: 'Filtrar por canal de origen',
      filterByAgency: 'Filtrar por agencia',
      filterByCreated: 'Filtrar por fecha de creación',
      filterByUpdated: 'Filtrar por fecha de actualización',
      filterByCreatedAfter: 'Creado despues de',
      filterByCreatedBefore: 'Creado antes de',
      title: 'Casos',
      subtitle: 'Lista de casos',
      tabs: {
        all: 'Todos',
        myGroups: 'Mis Grupos',
        myCases: 'Mis Casos',
      },
      search: 'Buscar...',
      results: 'Resultados',
      table: {
        organization: 'Organización',
        client: 'Cliente',
        subject: 'Asunto',
        agency: 'Agencia',
        workflow: 'Flujo',
        step: 'Paso',
        status: 'Estado',
        channel: 'Canal',
        team: 'Equipo',
        agent: 'Agente',
        created: 'Creado',
        lastUpdate: 'Actualizado',
      },
    },
    view: {
      assignToMe: 'Asignarme a mi',
      case: 'Caso',
      copyCaseNumber: 'Copiar número de caso',
      copySuccess: 'Número de caso copiado al portapapeles',
      titleStatus: 'Estado del caso',
      titleClient: 'Información del cliente',
      travelBookings: 'Ver reservas del caso',
      titleOtherDetails: 'Detalles adicionales',
      relationRemovedSuccess: 'Relacion removida con exito',
      relationRemovedError: 'Error remover la relacion',
      addRelationShip: 'Agregar relacion a otro caso',
      workflow: 'Flujo',
      instructions: 'Instrucciones',
      step: 'Paso',
      status: 'Estado',
      team: 'Equipo',
      organization: 'Organizacion',
      client: 'Cliente',
      agent: 'Agente Asignado',
      saleorderLegacy: 'Sales Order (Legacy)',
      agency: 'Agencia',
      created: 'Creado',
      iaEnabled: 'IA Habilitada',
      log: {
        UPDATE: 'actualizó',
        CREATE: 'creó',
        LINKED: 'asoció',
        DUPED: 'duplicó',
        WORKFLOW: 'Flujo',
        ORGANIZATION: 'Organización',
        AGENCY: 'Agencia',
        IA_ENABLED: 'IA Habilitada',
        STEP: 'Paso',
        TEAM: 'Equipo',
        STATUS: 'Estado',
        CLIENT: 'Client',
        AGENT: 'Agente',
        CASE: 'Caso',
        DELETE: 'eliminó',
        SALEORDER: 'Sales order',
        from: 'de',
        to: 'a',
        saleorder: {
          DELETE: 'Orden de venta eliminada',
          CREATE: 'Orden de venta agregada',
        },
      },
      content: {
        activity: 'Actividad',
        voicemail: 'Mensaje de voz',
        note: 'Nota',
        search: 'Buscar...',
        whatsapp: 'Whatsapp',
        show: 'Mostrar',
        all: 'Todos',
        history: 'Historial',
        phone: 'Llamadas',
        email: 'E-mails',
        files: 'Archivos',
        notes: 'Notas',
        endsWithin: 'Su sesión finaliza en:',
        subject: 'Asunto',
        date: 'Fecha',
        viewMore: 'Ver más',
        noteText: 'agregó una nota',
        caseEdit: 'Editó el caso',
        caseCreate: 'Creó el caso',
        edit: 'Edición',
        emailText: 'envió un correo electrónico',
        phoneCallText: 'llamó a',
        reply: 'Responder',
        replyToAll: 'Responder a todos',
        from: 'De',
        to: 'Para',
        cc: 'CC',
        bcc: 'BCC',
        newEmail: 'Enviar email',
        draft: 'Borrador',
        newWhatsapp: 'Enviar whatsapp',
        noWhatsappNumber: 'Este cliente no tiene un número de WhatsApp asignado',
        newNotes: 'Crear nota',
        imagePreview: 'Previsualización de la imagen',
        call: 'Llamada',
        incomingCall: 'Llamada entrante',
        outgoingCall: 'Llamada saliente',
        missingContactData: 'No hay datos de contacto disponibles',
        callTransfers: {
          transferredTo: 'Transferido a',
        },
        loading: 'Cargando...',
        hideThread: 'Ocultar hilo',
        showThread: 'Ver hilo anterior',
        showThreadWithCount: 'Ver hilo anterior ({{count}} mensajes)',
        previousMessages: 'Mensajes anteriores • {{count}} mensajes',
        noDate: 'Sin fecha',
        replySubject: 'Re',
        legacyEmailTooltip: 'Email anterior a la optimización de hilos',
        cleanedEmailTooltip: 'Contenido citado detectado y limpiado',
        showFullEmail: 'Ver mail completo',
        showCleanedEmail: 'Ver sin el hilo',
      },
      moreInfo: 'Mas información',
      lessInfo: 'Menos información',
      tabInfo: 'Info',
      tabHistory: 'Historia',
      attribution: {
        title: 'Atribución',
        utmSource: 'UTM Source',
        utmCampaign: 'UTM Campaign',
        adId: 'ID de anuncio',
        adSourceType: 'Tipo de origen',
        ctwaClid: 'CTWA Click ID',
        fbclid: 'Facebook Click ID',
      },
    },
  },
  callsMenu: {
    [WELCOME_MESSAGE]: 'Mensaje de bienvenida',
    saveSuccess: 'IVR guardado correctamente',
    saveError: 'Ocurrió un error al guardar el IVR',
    selectedStage: {
      timeout: 'Tiempo de espera (seg.)',
      timeoutAction: {
        label: 'Si ningun digito es marcado',
        action: {
          [TimeoutAction.REPEAT]: 'Repetir',
          [TimeoutAction.EXIT]: 'Salir',
        },
      },
      dialpad: 'Números a conectar',
      audioRecorder: {
        title: 'Grabar',
        delete: 'Eliminar grabación',
      },
      text: {
        title: 'Texto',
        textPlaceholder: 'Ingrese el texto que desea convertir a voz',
      },
      file: {
        title: 'Archivo',
        uploading: 'Subiendo archivo...',
        delete: 'Eliminar archivo',
        upload: 'Subir archivo',
        uploaded: 'Audio cargado',
        uploadSuccess: 'Archivo cargado correctamente',
        uploadError: 'Ocurrió un error al cargar el archivo',
      },
      audioPlayer: {
        play: 'Reproducir',
        pause: 'Pausar',
        delete: 'Eliminar audio',
      },
      sendTo: 'Enviar a',
      actionType: {
        [IVRActionType.ENTER_EXTENSION]: 'Extensión',
        [IVRActionType.SEND_TO_QUEUE]: 'Equipo',
      },
      communicationType: {
        title: 'Medio de comunicación',
        types: {
          [CommunicationType.TEXT_TO_SPEECH]: 'Texto a voz',
          [CommunicationType.AUDIO_RECORD]: 'Sonido',
          [CommunicationType.AUDIO_FILE]: 'Archivo',
        },
      },
      menu: {
        label: 'Nombre del menú',
        delete: 'Eliminar menú',
      },
      action: {
        label: 'Nombre de la acción',
        delete: 'Eliminar acción',
      },
    },
    stage: {
      team: 'Equipo',
    },
  },
  notifications: {
    title: 'Notificaciones',
    clean: 'Marcar como leidas',
    recents: 'Recientes',
    [NotificationType.CASE_ASSIGNED_TO_ME]: {
      title: 'Caso Asignado',
      message: 'El usuario <b>{{username}}</b> te asigno el caso <b>{{caseId}}</b>',
    },
    [NotificationType.CASE_UNASSIGNED_ME]: {
      title: 'Caso Asignado',
      message: 'El usuario <b>{{username}}</b> quito del caso <b>{{caseId}}</b>',
    },
    [NotificationType.CASE_STATUS_MODIFIED]: {
      title: 'Caso Modificado',
      message: 'El usuario <b>{{username}}</b> modificó el estado del caso <b>{{caseId}}</b> a <b>{{status}}</b>',
    },
    [NotificationType.CASE_NOTE_ADDED]: {
      title: 'Nota Agregado',
      message: 'El usuario <b>{{username}}</b> agregó una nota al caso <b>{{caseId}}</b>',
    },
    [NotificationType.CASE_EMAIL_ADDED]: {
      title: 'Mail enviado',
      message: 'El usuario <b>{{username}}</b> envio un mail en el caso <b>{{caseId}}</b>',
    },
    [NotificationType.CASE_CLIENT_REPLIED]: {
      title: 'El Cliente Contesto',
      message: 'El cliente <b>{{clientName}}</b> contestó en el caso <b>{{caseId}}</b>',
    },
    [NotificationType.USER_NOTIFICATION_TRIGGER]: {
      title: 'Coincidencia de Disparador',
      message: 'El caso <b>{{caseId}}</b> coincidió con tu disparador (estado <b>{{status}}</b>)',
    },
  },
  markupRules: {
    isActive: 'Activa',
    newGroup: '+ NUEVO GRUPO',
    buttonBackList: 'Volver a la lista',
    aplicationRatesTrackers: 'Aplica para Rates Trackers',
    deleteGroup: 'ELiminar grupo',
    addCondition: '+ Agregar condición',
    addAction: '+ Agregar acción',
    relationshipGroups: 'Relación entre grupos',
    and: 'Y',
    or: 'O',
    name: 'Nombre',
    order: 'Orden',
    orderPlaceholder: 'Vacío = al final',
    orderHelper:
      'Posición de evaluación (1 = primera). La regla se inserta ahí y las demás se corren.',
    orderAssigned: 'Se asignó el orden {{order}} (el pedido superaba el final de la lista)',
    markup: 'Margen',
    percentage: 'porcentaje',
    fee: 'cargo fijo',
    buttonDiscard: 'Descartar',
    buttonSave: 'Guardar',
    conditionalGroup: 'Grupo condicional',
    createSuccess: 'Regla creada',
    createError: 'Hubo un error al crear la regla',
    viewEdit: {
      titleNew: 'Crear margen',
      titleEdit: 'Editar margen',
      subtitleNew: 'Crear margen',
      subtitleEdit: 'Editar margen',
    },
    yup: {
      nameRequired: 'El nombre es requerido',
      nameCharLength: 'El nombre de la regla puede tener 50 caracteres o menos',
      operatorRequired: 'El operador es requerido',
      operatorInvalid: 'Operador invalido',
      fieldRequired: 'Campo requerido',
      fieldInvalid: 'Campo invalido',
      valueRequired: 'El valor es requerido',
      valueCharLength: 'El valor puede tener 100 caracteres o menos',
      minConditions: 'Necesitas una al menos una condicion',
      markupRequired: 'El Margen es requerido',
      valueNotNegative: 'El valor no puede ser negativo',
    },
    hotelMarkupFieldOptions: {
      [MarkupFieldOptionHotels.PAX_QTY]: 'Cantidad de pasajeros',
      [MarkupFieldOptionHotels.ROOM_QTY]: 'Cantidad de habitaciones',
      [MarkupFieldOptionHotels.HOTEL_VENDOR]: 'Cadena hotelera',
      [MarkupFieldOptionHotels.REQUEST_DATE]: 'Fecha de solicitud',
      [MarkupFieldOptionHotels.TRIP_START_DATE]: 'Fecha de inicio del viaje',
      [MarkupFieldOptionHotels.PROPERTY_NAME]: 'Nombre de la propiedad',
      [MarkupFieldOptionHotels.DESTINATION]: 'Destino',
      [MarkupFieldOptionHotels.HAS_INFANT]: 'Tiene infantes',
      [MarkupFieldOptionHotels.HAS_CHILD]: 'Tiene niños',
      [MarkupFieldOptionHotels.RATE_CURRENCY]: 'Moneda',
      [MarkupFieldOptionHotels.RATE_REFUNDABLE]: 'Es reembolsable',
      [MarkupFieldOptionHotels.IS_CORPO]: 'Es corporativo',
      [MarkupFieldOptionHotels.CONNECTIVITY_VENDOR]: 'Proveedor de conectividad',
    },
    ruteroMarkupFieldOptions: {
      PROVIDER: 'Proveedor',
      VERTICAL: 'Tipo de producto',
      DESTINATION: 'Destino',
      CURRENCY: 'Moneda',
      PAX_QTY: 'Cantidad de pasajeros',
    },
    serviceType: 'Tipo de servicio',
    serviceTypes: {
      hotel: 'Hoteles',
      rail: 'Trenes',
      buses: 'Buses',
      ferry: 'Ferries',
      tours: 'Tours',
      circuits: 'Circuitos',
      transfers: 'Transfers',
      cars: 'Autos',
      esims: 'eSIMs',
    },
    operators: {
      [MarkupRuleOperator.EQUALS]: '=',
      [MarkupRuleOperator.NOT_EQUALS]: '!=',
      [MarkupRuleOperator.GREATER_THAN]: '>',
      [MarkupRuleOperator.GREATER_THAN_OR_EQUAL]: '>=',
      [MarkupRuleOperator.LESS_THAN]: '<',
      [MarkupRuleOperator.LESS_THAN_OR_EQUAL]: '=<',
      [MarkupRuleOperator.CONTAINS]: 'contiene',
      [MarkupRuleOperator.NOT_CONTAINS]: 'no contiene',
      [MarkupRuleOperator.STARTS_WITH]: 'empieza con',
      [MarkupRuleOperator.ENDS_WITH]: 'ends termina con',
    },
  },
  cart: {
    title: 'Tu Carrito',
    legacy: {
      directAccess:
        'El carrito quedó reservado para la compatibilidad del flujo de hoteles. Para iniciar una compra, empezá desde el buscador de hoteles.',
      goToHotels: 'Ir a hoteles',
    },
    summary: 'Resumen',
    total: 'Total',
    checkout: 'Crear a Orden de Venta',
    keepBuying: 'Seguir Comprando',
    cartAddItemError: 'Hubo un error al intentar agregar el item al carrito',
    hotels: 'Hoteles',
    cars: 'Autos',
    flights: 'Vuelos',
    services: 'Servicios',
    ruteroAuthority: {
      rowVerifying: 'Verificando estado de la reserva…',
      rowUnavailable: 'No se pudo verificar el estado de la reserva',
      checkoutVerifying:
        'Hay servicios de viaje cuyo estado todavía se está verificando.',
      checkoutUnavailable:
        'No se pudo verificar el estado de uno de los servicios de viaje.',
    },
    convert: {
      success: 'Orden de venta creada',
      error: 'Hubo un error al convertir el carrito a una orden de venta. Por favor intentalo más tarde',
      successMessage: 'El número de seguimieton de la orden es:',
    },
  },
  saleOrder: {
    status: {
      [SALE_ORDER_STATUS.Sold]: 'Vendido',
      [SALE_ORDER_STATUS.Active]: 'Activo',
      [SALE_ORDER_STATUS.Canceled]: 'Cancelado',
      [SALE_ORDER_STATUS.Lead]: 'Lead',
    },
    list: {
      title: 'Órdenes de venta',
      subtitle: 'Lista de órdenes de venta',
      results: 'resultados',
      table: {
        id: '#',
        status: 'Estado',
        createdBy: 'Autor',
        convertedAt: 'Convertido',
        updatedAt: 'Actualizado',
        case: 'Caso',
        amount: {
          title: 'Monto',
          value: 'USD {{value}}',
        },
      },
    },
    view: {
      title: 'Orden de venta',
      subtitle: '# {{record}}',
      sideBarTitle: 'Menú lateral de orden de venta',
      passengers: {
        title: 'Pasajeros',
        subtitle: 'Lista de pasajeros',
        newPassenger: 'Nuevo Pasajero',
        passengerData: 'Datos del Pasajero',
        successUpdatingPax: 'Información del pasajero actualizada exitosamente',
        errorUpdatingPax: 'Error al actualizar la información del pasajero',
        table: {
          name: 'Nombre',
          lastname: 'Apellido',
          email: 'Email',
          age: 'Edad (actual)',
          dob: 'Fecha de nacimiento',
          actions: 'Acciones',
        },
        form: {
          name: 'Nombre',
          lastName: 'Apellido',
          birthDate: 'Fecha de Nacimiento',
          email: 'Email',
          phone: 'Teléfono',
        },
      },
      hotels: {
        title: 'Hotel: {{name}}',
        detail: {
          title: 'Detalles',
          nights: 'Noches',
          markup: 'Markup %',
          subPrice: 'Sub precio',
          totalPrice: 'Precio total',
          checkIn: 'Check In',
          checkOut: 'Check Out',
          bookingId: 'ID de reserva',
          supplierReference: 'Referencia - {{supplierName}}',
          board: 'Régimen',
          cancelPolicies: 'Políticas de cancelación',
          remarks: 'Observaciones',
          rateRules: 'Reglas de tarifa',
        },
        cancel: 'Cancelar',
        cancelled: 'Cancelado',
        cancelSuccess: 'Reserva cancelada exitosamente',
        emit: 'Emitir',
        emitSuccess: 'Reserva emitida exitosamente',
        emitError: 'Hubo un error al emitir la reserva',
        holder: {
          title: 'Datos del titular',
          name: 'Nombre',
          lastname: 'Apellido',
          email: 'Email',
        },
      },
      rooms: {
        title: 'Habitaciones ({{rooms}})',
        paxName: 'Nombre',
        paxAge: 'Edad (al momento del check-out)',
      },
    },
    link: {
      action: {
        add: 'Agregar orden de venta',
      },
      modal: {
        action: 'Vincular',
        title: 'Vincular a caso',
        searchPlaceholder: 'Buscar por número de orden...',
        loadError: 'Error al cargar órdenes de venta',
      },
      list: {
        title: 'Órdenes de Venta',
        linkButton: 'Vincular Orden',
        createdBy: 'Creado por',
        amount: 'Monto',
        name: 'Nombre',
        unlinkConfirm: {
          title: 'Confirmar Desvincular',
          message: '¿Estás seguro que deseas desvincular esta orden?',
          cancel: 'Cancelar',
          confirm: 'Desvincular',
        },
      },
      notifications: {
        linkSuccess: 'Orden de venta vinculada exitosamente',
        linkError: 'Error al vincular orden de venta',
        unlinkSuccess: 'Orden de venta desvinculada exitosamente',
        unlinkError: 'Error al desvincular orden de venta',
        loadError: 'Error al cargar órdenes de venta',
      },
    },
    unlink: {
      modal: {
        title: 'Confirmar Desvincular',
        message: '¿Estás seguro que deseas desvincular esta orden?',
        cancel: 'Cancelar',
        confirm: 'Desvincular',
      },
      notifications: {
        unlinkSuccess: 'Orden de venta desvinculada exitosamente',
        unlinkError: 'Error al desvincular orden de venta',
      },
    },
    bookingDetails: {
      title: 'Detalles del proveedor',
      hotelName: 'Nombre de hotel proveedor',
      provider: 'Nombre del proveedor',
      reference: 'Referencia de reserva del proveedor',
    },
  },
  invalidationRules: {
    name: 'Nombre',
    expireAfter: 'Expira en',
    isActive: 'Activo',
    title: 'Reglas de Invalidación',
    subtitle: 'Listado de reglas de invalidación',
    results: 'Resultados',
    search: 'Buscar',
    minutes: 'Minutos',
    serviceType: {
      hotels: 'Hoteles',
    },
    table: {
      order: 'Orden',
      isDefault: 'Por defecto',
      serviceType: 'Tipo de servicio',
      yes: 'Sí',
      no: 'No',
      lastUpdate: 'Última actualización',
      created: 'Creado',
      updatedBy: 'Actualizado por',
      createdBy: 'Creado por',
    },
    validations: {
      nameCharLength: 'El nombre de la regla debe tener 255 caracteres o menos',
      fieldRequired: 'Este campo es obligatorio',
      expireAfterMin: 'El valor de expiración debe ser mayor o igual a 0',
      expireAfterMustBeNumber: 'El valor de expiración debe ser un número',
      operatorInvalid: 'Operador inválido seleccionado',
      fieldInvalid: 'Campo inválido seleccionado',
      valueRequired: 'El valor es obligatorio',
      valueCharLength: 'El valor debe tener 255 caracteres o menos',
      minConditions: 'Se requiere al menos una condición',
      valueInvalidDate: 'Fecha inválida, el valor debe tener el formato YYYY-MM-DD',
    },
    viewEdit: {
      titleNew: 'Crear regla de invalidación',
      titleEdit: 'Editar regla de invalidación',
      subtitleNew: 'Crear regla de invalidación',
      subtitleEdit: 'Editar regla de invalidación',
      deleteGroup: 'Eliminar grupo',
      addCondition: '+ Agregar condición',
      addAction: '+ Agregar acción',
      createSuccess: 'Regla de invalidación creada',
      createError: 'Ocurrió un error al crear la regla de invalidación',
      updateSuccess: 'Regla de invalidación actualizada',
      updateError: 'Ocurrió un error al actualizar la regla de invalidación',
      buttonDiscard: 'Descartar',
      conditions: 'Condiciones',
      field: 'Campo',
      operator: 'Operador',
      value: 'Valor',
    },
    fieldOptions: {
      SUPPLIER_ACCESS_CODE: 'Código de acceso del proveedor',
      CHECK_IN_DATE: 'Fecha de check-in',
      CHECK_OUT_DATE: 'Fecha de check-out',
    },
    operatorOptions: {
      EQUALS: '=',
      NOT_EQUALS: '!=',
      GREATER_THAN: '>',
      GREATER_THAN_OR_EQUAL: '>=',
      LESS_THAN: '<',
      LESS_THAN_OR_EQUAL: '=<',
    },
  },
  dataUploads: {
    title: 'Cargas de Datos',
    subtitle: 'Carga masiva de datos',
    tabs: {
      clients: 'Clientes',
      cases: 'Casos',
    },
    clients: {
      title: 'Carga de Clientes',
      subtitle: 'Carga masiva de clientes',
      results: 'resultados',
      search: 'Buscar',
      table: {
        id: 'ID',
        agencyId: 'ID de Agencia',
        status: 'Estado',
        createdAt: 'Fecha de Creación',
        createdBy: 'Creado Por',
        filename: 'Nombre del Archivo',
        actions: 'Descargar',
      },
      status: {
        created: 'Creado',
        pending: 'Pendiente',
        processing: 'Procesando',
        completed: 'Completado',
        failed: 'Fallido',
      },
      create: {
        title: 'Subir archivo de clientes',
        description: 'Seleccione un archivo CSV con datos de clientes',
        createdSuccess: 'Archivo subido exitosamente',
        createdError: 'Hubo un error al subir el archivo',
      },
    },
    cases: {
      title: 'Carga de Casos',
      subtitle: 'Carga masiva de casos',
      results: 'resultados',
      search: 'Buscar',
      table: {
        id: 'ID',
        agencyId: 'ID de Agencia',
        status: 'Estado',
        createdAt: 'Fecha de Creación',
        createdBy: 'Creado Por',
        filename: 'Nombre del Archivo',
        workflow: 'Workflow',
        actions: 'Descargar',
      },
      status: {
        created: 'Creado',
        pending: 'Pendiente',
        processing: 'Procesando',
        completed: 'Completado',
        failed: 'Fallido',
      },
      create: {
        title: 'Subir archivo de casos',
        description: 'Seleccione un archivo CSV con datos de casos',
        createdSuccess: 'Archivo subido exitosamente',
        createdError: 'Hubo un error al subir el archivo',
      },
    },
  },
  flightIntegrations: {
    title: 'Integraciones de Vuelo',
    subtitle: 'Lista de integraciones de vuelo',
    results: 'Resultados',
    search: 'Buscar',
    table: {
      provider: 'Proveedor',
      ownerClientName: 'Cliente propietario',
      isShared: 'Es compartida',
      createdAt: 'Creado en',
    },
    create: {
      title: 'Crear Integración de Vuelo',
      success: 'Integración de vuelo creada exitosamente',
      error: 'Error al crear la integración de vuelo',
    },
    edit: {
      loadItemError: 'Error al cargar integración de vuelo',
      title: 'Editar Integración de Vuelo',
      success: 'Integración de vuelo actualizada exitosamente',
      error: 'Error al actualizar la integración de vuelo',
    },
    update: {
      success: 'Integración de vuelo actualizada exitosamente',
      error: 'Error al actualizar la integración de vuelo',
    },
    form: {
      provider: {
        label: 'Proveedor',
      },
      allowSeeByOthers: {
        label: 'Permitir ver por otros clientes',
      },
      username: {
        label: 'Usuario',
      },
      password: {
        label: 'Contraseña',
      },
    },
  },
  hotelIntegrations: {
    title: 'Integraciones de Hotel',
    subtitle: 'Lista de integraciones de hotel',
    results: 'Resultados',
    search: 'Buscar',
    table: {
      name: 'Nombre',
      provider: 'Proveedor',
      ownerClientName: 'Cliente propietario',
      isShared: 'Es compartida',
      createdAt: 'Creado en',
    },
    create: {
      title: 'Crear Integración de Hotel',
      success: 'Integración de hotel creada exitosamente',
      error: 'Error al crear la integración de hotel',
    },
    edit: {
      loadItemError: 'Error al cargar integración de hotel',
      title: 'Editar Integración de Hotel',
      success: 'Integración de hotel actualizada exitosamente',
      error: 'Error al actualizar la integración de hotel',
    },
    update: {
      success: 'Integración de hotel actualizada exitosamente',
      error: 'Error al actualizar la integración de hotel',
    },
    form: {
      provider: {
        label: 'Proveedor',
      },
      allowSeeByOthers: {
        label: 'Permitir ver por otros clientes',
      },
      apiKey: {
        label: 'Clave API',
      },
      clientCode: {
        label: 'Código de Cliente',
      },
      clientName: {
        label: 'Nombre del Cliente',
      },
      name: {
        label: 'Nombre de la Integración',
      },
      suppliers: {
        label: 'Proveedores',
        helperText: 'Selecciona los proveedores para esta integración',
      },
    },
  },
  agencyFlightIntegrations: {
    title: 'Integraciones de vuelos por agencia',
    subtitle: 'Listado de integraciones de vuelos de la agencia',
    results: 'Resultados',
    search: 'Buscar',
    table: {
      provider: 'Proveedor',
      ownerClientName: 'Cliente propietario',
      isShared: 'Es compartida',
      createdAt: 'Fecha de creación',
      isEnabledForAgency: 'Integración habilitada',
      itemEnabled: 'La integración está habilitada',
      itemDisabled: 'Esta integración está deshabilitada',
    },
    enabled: {
      success: 'La integración de vuelos se habilitó correctamente.',
      error: 'Ocurrió un error al habilitar la integración de vuelos. Por favor, intentá nuevamente.',
    },
    disabled: {
      success: 'La integración de vuelos se deshabilitó correctamente.',
      error: 'Ocurrió un error al deshabilitar la integración de vuelos. Por favor, intentá nuevamente.',
    },
    confirmDisableModal: {
      title: 'Deshabilitar integración de vuelos',
      message:
        'Si deshabilitás esta integración de vuelos, la agencia ya no podrá buscar vuelos usando esta integración. ¿Querés continuar de todas formas?',
      accept: 'Aceptar',
      cancel: 'Cancelar',
    },
  },
  hotelContent: {
    management: {
      title: 'Gestión de Contenido Hotelero',
      general: 'General',
      activeJobs: 'Trabajos Activos',
      viewJobs: 'Ver trabajos',
      tabs: {
        suppliers: 'Proveedores',
        defaultSuppliers: 'Proveedores Predeterminados',
        boards: 'Tableros',
        categories: 'Categorías',
        destinations: 'Destinos',
        vendorHotels: 'Hoteles de Proveedores',
        nimbuxHotels: 'Hoteles Nimbux',
      },
      defaultSuppliers: {
        title: 'Proveedores Predeterminados',
        subtitle: 'Configura el orden de prioridad de los proveedores para cada tipo de contenido',
      },
      suppliers: {
        title: 'Proveedores de Contenido Hotelero',
        subtitle: 'Gestionar y visualizar proveedores de contenido hotelero',
        updateMetadata: 'Actualizar Metadata',
        updateMetadataMessages: {
          success: 'Metadata actualizada exitosamente',
          error: 'Error al actualizar metadata',
        },
        refreshMessages: {
          success: 'Se encolo un Job para actualizar los proveedores',
          error: 'Error al actualizar los proveedores',
        },
        table: {
          supplier: 'Proveedor',
          provider: 'Proveedor',
          supplierCode: 'Código de Proveedor',
          providerCode: 'Código de Proveedor',
          supplierName: 'Nombre del Proveedor',
          supplierContext: 'Contexto del Proveedor',
          providerName: 'Nombre del Proveedor',
          isProviderActive: 'Proveedor Activo',
          isSupplierActive: 'Proveedor Activo',
        },
        errors: {
          getSuppliers: 'Error al cargar proveedores',
        },
      },
      vendorHotels: {
        title: 'Hoteles de Proveedores',
        subtitle: 'Gestionar y visualizar listados de hoteles de proveedores',
        createExtraction: 'Crear Extracción',
        table: {
          name: 'Nombre del Hotel',
          code: 'Código del Hotel',
          location: 'Ubicación',
          address: 'Dirección',
          supplier: 'Proveedor',
          parent: 'Hotel Padre',
        },
        clearFilters: 'Limpiar Filtros',
        linkModal: {
          currentNimbuxHotel: 'Nimbux Hotel Actual',
          linkToNimbuxHotel: 'Vincular a Nimbux Hotel',
          searchPlaceholder: 'Buscar Nimbux Hotels...',
          availableNimbuxHotels: 'Nimbux Hotels Disponibles',
          noNimbuxHotelsFound: 'No se encontraron Nimbux Hotels',
          noLinkedNimbuxHotel: 'Este hotel no está vinculado a ningún Nimbux Hotel',
          link: 'Vincular',
          unlink: 'Desvincular',
          nimbuxHotelLabel: 'Nimbux Hotel:',
          noNimbuxHotel: 'No tiene',
        },
        errors: {
          getVendorHotels: 'Error al cargar hoteles de proveedores',
        },
        modal: {
          title: 'Crear Nueva Extracción',
          supplier: 'Proveedor',
          destination: 'Destino',
          startExtraction: 'Iniciar Extracción',
        },
        moderate: {
          title: 'Moderar',
          success: 'Hoteles moderados exitosamente',
          error: 'Error al moderar los hoteles',
        },
      },
      boards: {
        title: 'Regímenes',
        subtitle: 'Gestionar y visualizar regímenes',
        table: {
          code: 'Código',
          supplierName: 'Nombre del Proveedor',
          texts: 'Textos',
        },
        errors: {
          getBoards: 'Error al cargar regímenes',
        },
      },
      categories: {
        title: 'Categorías',
        subtitle: 'Gestionar y visualizar categorías',
        table: {
          code: 'Código',
          supplierName: 'Nombre del Proveedor',
          texts: 'Textos',
        },
        errors: {
          getCategories: 'Error al cargar categorías',
        },
      },
      amenties: {
        title: 'Amenities',
        subtitle: 'Gestionar y visualizar amenities',
        table: {
          code: 'Código',
          supplierName: 'Nombre del Proveedor',
          texts: 'Textos',
        },
        errors: {
          getAmenities: 'Error al cargar amenities',
        },
      },
      destinations: {
        title: 'Destinos',
        subtitle: 'Gestionar y visualizar destinos',
        table: {
          code: 'Código',
          supplierName: 'Nombre del Proveedor',
          texts: 'Textos',
          type: 'Tipo',
        },
        errors: {
          getDestinations: 'Error al cargar destinos',
        },
      },
    },
    extraction: {
      supplier: 'Proveedor',
      destinations: 'Destinos',
      success: 'Extracción iniciada exitosamente',
      error: 'Error al iniciar la extracción',
      newExtraction: 'Crear Nueva Extracción',
      startExtraction: 'Iniciar Extracción',
    },
    jobs: {
      errors: {
        getJobs: 'Error al cargar trabajos de extracción de contenido',
      },
      modal: {
        title: 'Colas de Extracción',
        resultsFound: 'trabajos encontrados',
        noJobsFound: 'No se encontraron trabajos',
        parameters: 'Parámetros',
        errors: 'Errores',
        created: 'Creado',
        started: 'Iniciado',
        finished: 'Finalizado',
        status: {
          pending: 'Pendiente',
          processing: 'En progreso',
          completed: 'Completado',
          failed: 'Fallido',
        },
      },
    },
    suppliers: 'Proveedores',
    boards: 'Regímenes',
    categories: 'Categorías',
    destinations: 'Destinos',
    vendorHotels: 'Hoteles del Proveedor',
    nimbuxHotels: {
      title: 'Hoteles Nimbux',
      empty: 'Aquí se mostrará la lista de hoteles',
      emptyDescription: 'Esta sección contendrá la interfaz de gestión para hoteles Nimbux.',
      card: {
        information: 'Información de la zona',
        lastModeration: 'Última moderación fue: {{date}}',
        editButton: 'Editar',
        link: 'Link',
        opinions: '({{count}} opiniones)',
        popularAmenities: 'Comodidades populares',
        showAllAmenities: 'Ver todas las comodidades',
        showLessAmenities: 'Mostrar menos comodidades',
        status: {
          markedForModeration: 'Marcado para moderar',
          moderated: 'Moderado',
          toReview: 'Para revisar',
          reviewed: 'Revisado',
        },
      },
      linkModal: {
        title: 'Vincular Hoteles - {{hotelName}}',
        searchPlaceholder: 'Buscar hoteles...',
        linkedHotels: 'Hoteles Vinculados',
        availableHotels: 'Hoteles Disponibles',
        noLinkedHotels: 'No hay hoteles vinculados aún',
        noAvailableHotels: 'No se encontraron hoteles',
        link: 'Vincular',
        unlink: 'Desvincular',
        country: 'País',
        city: 'Ciudad',
        parentHotel: 'Hotel Nimbux',
        noParentHotel: 'Sin hotel nimbux',
        noSupplier: 'Sin proveedor',
        close: 'Cerrar',
      },
      errors: {
        getNimbuxHotels: 'Error al cargar hoteles nimbux',
        loadingError: 'Error al cargar los hoteles. Por favor, intenta de nuevo.',
      },
      loadingMore: 'Cargando más hoteles...',
      noMoreHotels: 'No hay más hoteles para mostrar',
    },
    filters: {
      orderBy: 'Ordenar por',
      name: 'Nombre',
      country: 'País',
      suppliers: 'Proveedores',
      searchByName: 'Buscar por Nombre',
      searchPlaceholder: 'Ingrese el nombre del hotel',
      filterByCountry: 'Filtrar por País',
      selectCountry: 'Seleccionar país',
      allCountries: 'Todos los países',
      filterByAddress: 'Filtrar por Dirección',
      address: 'Dirección',
      addressPlaceholder: 'Ingrese una dirección',
      distance: 'Distancia',
    },
    view: {
      tabs: {
        general: 'General',
        checkinCheckout: 'Check-in / Check-out',
        location: 'Ubicación',
        images: 'Imágenes',
        amenities: 'Amenities',
        content: 'Contenido',
      },
      images: {
        published: 'Publicadas ({{count}})',
        available: 'Disponibles ({{count}})',
        count: '{{count}} imágenes',
        mainBadge: 'Principal',
        moveToAvailable: 'Pasar a Disponibles',
        moveToPublished: 'Pasar a Publicadas',
        messages: {
          getVendorImagesError: 'Error al cargar imágenes',
          noAvailableImages: 'No hay imágenes disponibles',
          updateSuccess: 'Imágenes actualizadas exitosamente',
          updateError: 'Error al actualizar las imágenes',
        },
      },
      location: {
        title: 'Ubicación',
        address: 'Dirección',
        latitude: 'Latitud',
        longitude: 'Longitud',
        map: 'Mapa',
        dragInstructions: 'Arrastra el pin en el mapa para ajustar la ubicación manualmente',
        loadingMap: 'Cargando mapa...',
        messages: {
          updateSuccess: 'Ubicación actualizada exitosamente',
          updateError: 'Error al actualizar la ubicación',
        },
      },
      amenities: {
        title: 'Amenities',
        messages: {
          updateSuccess: 'Amenities actualizadas exitosamente',
          updateError: 'Error al actualizar las amenities',
        },
        selectedAmenities: 'Amenities seleccionadas ({{count}})',
      },
      checkinCheckout: {
        title: 'Check-in / Check-out',
        checkIn: 'Check-in',
        checkOut: 'Check-out',
        from: 'Desde',
        to: 'Hasta',
        minimumAge: 'Edad mínima',
        minimumAgeForCheckin: 'Edad mínima para el checkin',
        minimumAgeForCheckout: 'Edad mínima para el checkout',
        selectTime: 'Seleccionar hora',
        selectAge: 'Seleccionar edad',
        years: 'años',
        instructionsForCheckin: 'Instrucciones para el checkin',
        instructionsForCheckout: 'Instrucciones para el checkout',
        generateWithAI: 'Completar con IA',
        messages: {
          updateSuccess: 'Check-in / Check-out actualizado correctamente',
          updateError: 'Error al actualizar el check-in / check-out',
          generateTranslationsSuccess: 'Translations generated successfully',
          generateTranslationsError: 'Error al generar las traducciones',
        },
      },
      areaInformation: 'Información de la zona',
    },
    contentEditor: {
      title: 'Contenido Nimbux',
      editorTitle: 'Editor de Contenido',
      placeholder: 'Edita el contenido del hotel aquí',
      suppliersPreview: 'Descripción Suppliers (Preview)',
      generateWithAI: 'Generar con IA',
      ckeditor: {
        paragraph: 'Párrafo',
        heading1: 'Título 1',
        heading2: 'Título 2',
        heading3: 'Título 3',
        heading4: 'Título 4',
      },
      expandContent: 'Expandir contenido',
      collapseContent: 'Colapsar contenido',
      noDescriptionsAvailable: 'No hay descripciones disponibles para este proveedor',
      loadingDescriptions: 'Cargando descripciones de proveedores...',
      noDescriptionsFromSuppliers: 'No hay descripciones de proveedores disponibles',
    },
  },
  caseTriggers: {
    form: {
      sendWhatsapp: 'Enviar mensaje de WhatsApp',
      statusPlaceholderAny: 'Cualquier estado (déjalo vacío para aplicar a todos)',
      statusHelperAny: 'Si no seleccionas ningún estado, este disparador se aplicará sin importar el estado del caso.',
      nextStatus: {
        keepCurrent: 'Mantener estado actual',
      },
    },
    template: {
      placeholdersHint:
        'Puedes usar marcadores dinámicos como {{client_name}}, {{client_first_name}}, {{client_last_name}}, {{agent_name}}, {{agent_first_name}}, {{agent_last_name}}; se reemplazan automáticamente por los datos del cliente en cada caso.',
      supportedPlaceholders:
        'Marcadores disponibles: {{client_name}}, {{client_first_name}}, {{client_last_name}}, {{agent_name}}, {{agent_first_name}}, {{agent_last_name}}',
    },
  },
  webhooks: {
    title: 'Webhooks',
    subtitle: 'Envía eventos del CRM a sistemas externos',
    results: 'resultados',
    searchPlaceholder: 'Buscar (no implementado)',
    allWorkflows: 'Todos los flujos',
    empty: 'Todavía no hay webhooks configurados.',
    createCta: 'Crear webhook',
    confirmDelete: '¿Seguro que querés eliminar este webhook?',
    deleteSuccess: 'Webhook eliminado',
    deleteError: 'Error al eliminar el webhook',
    table: {
      actions: 'Acciones',
      url: 'URL',
      events: 'Eventos',
      workflows: 'Flujos',
      active: 'Activo',
    },
    events: {
      'client.created': 'Cliente creado',
      'client.updated': 'Cliente actualizado',
      'case.created': 'Caso creado',
      'case.step_changed': 'Cambio de step del caso',
      'case.status_changed': 'Cambio de estado del caso',
      'case.agent_assigned': 'Agente asignado al caso',
      'case.custom_field_updated': 'Campo personalizado actualizado',
    },
    modal: {
      createTitle: 'Crear webhook',
      editTitle: 'Editar webhook',
    },
    form: {
      url: 'URL de destino',
      secret: 'Secret',
      secretHelper: 'Opcional. Se usa para firmar el payload (HMAC-SHA256).',
      secretEditHelper: 'Dejalo en blanco para mantener el secret actual.',
      events: 'Eventos',
      eventsPlaceholder: 'Seleccioná eventos',
      eventsRequired: 'Seleccioná al menos un evento',
      workflows: 'Flujos',
      workflowsPlaceholder: 'Todos los flujos',
      workflowsHelper: 'Dejalo vacío para aplicar a todos los flujos de la agencia.',
      active: 'Activo',
      create: 'Crear',
      update: 'Actualizar',
      saveSuccess: 'Webhook guardado',
      saveError: 'Error al guardar el webhook',
    },
  },
  metaCapi: {
    title: 'Meta Ads — Atribución y Conversiones',
    subtitle:
      'Configurá la Conversions API de Meta para atribuir conversaciones y reservas a tus anuncios (WhatsApp CTWA y Web)',
    form: {
      enabled: 'Activar envío de conversiones a Meta',
      credentialsSection: 'Credenciales',
      accessToken: 'Access Token',
      accessTokenHelper:
        'Token de acceso de Meta con permisos de gestión de eventos.',
      accessTokenEditHelper:
        'Ya hay un token guardado. Dejá el campo en blanco para mantenerlo.',
      datasetId: 'Dataset ID',
      whatsappBusinessAccountId: 'WhatsApp Business Account ID (WABA)',
      graphApiVersion: 'Versión de Graph API',
      graphApiVersionHelper: 'Dejalo vacío para usar la versión por defecto.',
      defaultCurrency: 'Moneda por defecto',
      testEventCode: 'Test Event Code',
      testEventCodeHelper:
        'Opcional. Para probar eventos en el Events Manager de Meta.',
      purchaseTriggerSection: 'Disparador del evento Purchase',
      purchaseTriggerType: 'Tipo de disparador',
      purchaseTriggerTypeHelper:
        'Definí cuándo se envía el evento de compra a Meta.',
      purchaseTriggerNone: 'Sin disparador (solo Lead)',
      purchaseTriggerStep: 'Cuando el caso llega a un paso',
      purchaseTriggerStepPlaceholder: 'Seleccioná un paso',
      purchaseTriggerCustomField: 'Cuando cambia un campo personalizado',
      purchaseTriggerFieldName: 'Nombre del campo',
      purchaseTriggerFieldValue: 'Valor esperado',
      purchaseTriggerFieldValueHelper:
        'Opcional. Si lo completás, el evento solo se dispara cuando el campo toma ese valor.',
      save: 'Guardar',
      saveSuccess: 'Configuración guardada',
      saveError: 'Error al guardar la configuración',
    },
  },
};
